import React, { useState, useEffect } from "react";
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer, Cell, Bar } from "recharts";
// import ReactTooltip from "react-tooltip";
import "./PerformanceDashboard.css";
import { Button, Col, Container, Row, Nav, Alert, Accordion, Table, Tab } from "react-bootstrap";
import Menubar from "../Menubar";
import KpiService from "../../Services/KpiService";
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { geoCentroid } from 'd3-geo';
import { AiOutlineSearch } from "react-icons/ai";
import { Field, FormikProvider, Form, useFormik } from "formik";
import * as Yup from "yup";
import { datetime, exportTodashExcel, formatNumberIndianWithDecimal, generatedashPdf, generateindPdf, getReadableTimeStamp, } from "../utils/commonFunctions";
import { store } from "../../App";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import MasterService from "../../Services/MasterService";
import { IoIosReturnLeft } from "react-icons/io";
import * as d3 from "d3-geo";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { FaRegHandPointRight } from "react-icons/fa";
import { getSortedIndicators, groupIndicators } from "./EconomicDashboard";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { GrDocumentPdf } from "react-icons/gr";
import { RiFileExcel2Line } from "react-icons/ri";

const Dashboardnewchanges = () => {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  let username = localStorage.getItem("username");
  let role_cat_id = localStorage.getItem("catid");
  let secretariat_code = localStorage.getItem("secretariat_code");
  let hod_id = localStorage.getItem("hod_id");
  let deptid = localStorage.getItem("deptid");
  let districtid = localStorage.getItem("districtid");
  let deptcodeName = localStorage.getItem("deptcodeName");
  let SectariatcodeName = localStorage.getItem("SectariatcodeName");
  let mandalid = localStorage.getItem("mandalid");
  let ulbid = localStorage.getItem("ulbid");
  let constdist = localStorage.getItem("districtname");

  let assemblyid = localStorage.getItem("assemblyid");

  const [ulbdept, setulbdept] = useState();
  const [ulbdept2, setulbdept2] = useState();
  const [selectedsec, setselectedsec] = useState();
  const [selecteddept, setselecteddept] = useState();
  const [Secid, setSecid] = useState();
  const [departments, setDepartments] = useState([]);
  const [dashboardKpiData, setdashboardKpiData] = useState([]);
  const [dashboardMonthData, setdashboardMonthData] = useState(null);
  // months array used by the Month dropdown — derive from API response with safe fallbacks

  const [months, setMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [monthsErrorMessage, setMonthsErrorMessage] = useState("");
  const [initialMonthLoaded, setInitialMonthLoaded] = useState(false);
  const [suppressDataFetch, setSuppressDataFetch] = useState(false);

  useEffect(() => {
    const loadFinYearMonth = async () => {
      try {
        const res = await KpiService.monthNameFromMonthCode({ userId: username, type: "FinYearAndmonth", });

        if (res?.data?.dataList?.length > 0) {
          const data = res.data.dataList[0];

          formik.setFieldValue("year", data.year || "");
          formik.setFieldValue("scoreForMonth", data.score_for_month?.toString() || "");
          setInitialMonthLoaded(true);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadFinYearMonth();
  }, []);


  const validationSchema = Yup.object({});
  const formik = useFormik({
    initialValues: {
      year: "",
      scoreForMonth: "",
      scoreCatId: "Monthly",
      constituency: "",
      Mandal: "",
      godown: "",
      consentform: "",
      district_id: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => { },
  });
  useEffect(() => {
    if (!formik.values.year) return;
   let params = {
  userId: username,
  year: formik.values.year,
  scoreForMonth: apiMonthValue,
  scoreCatId: formik.values.scoreCatId,
  dashboardType: "MAINDASHBOARD"
};

KpiService.dashboardDisplaysDateWise(params).then((response) => {
  if (
    response?.data?.SCODE === "01" &&
    response?.data?.dataList?.length > 0
  ) {
    setReportGeneratedDate(response.data?.dataList[0]?.insert_time);
  }
});
    const loadMonths = async () => {
      try {
        const params = {
          userId: username,
          year: formik.values.year,
          "type": "MAINDASHBOARD",
        };

        const res = await KpiService.monthNameFromMonthCode(params);

        if (res?.data?.dataList && res.data.dataList.length > 0) {
          const monthList = res.data.dataList;
          setMonths(monthList);
          setMonthsErrorMessage("");

          const firstMonth = (
            monthList?.[0]?.month_code ||
            monthList?.[0]?.monthCode ||
            monthList?.[0]?.code
          )?.toString() || "0";

          // If the current form month is empty or not present in the new month list,
          // default it to the first returned month. This handles year changes where
          // the month dropdown is reloaded but the form value may still point to
          // a previous/invalid month code.
          const currentMonth = (formik.values.scoreForMonth || "").toString();
          const monthCodes = monthList.map(m => ((m.month_code || m.monthCode || m.code) || "").toString());
          if (!currentMonth || !monthCodes.includes(currentMonth)) {
            formik.setFieldValue("scoreForMonth", firstMonth);
          }
        } else {
          if (res?.data?.SCODE === "02") {
            showAlertMessage("No Months available", "warning");
          }
          setMonths([]);
          formik.setFieldValue("scoreForMonth", "0");
        }
      } catch (e) {
        console.error(e);
      }
    };

    loadMonths();
  }, [formik.values.year, formik.values.scoreCatId]);
  const apiMonthValue = formik.values.scoreCatId === "Monthly" ? (formik.values.scoreForMonth || "0") : "3";

const [reportGeneratedDate, setReportGeneratedDate] = useState(null);

  const [search, setSearch] = useState("")
  const [clickType, setClickType] = useState("sec");
  const [Backclick, setBackclick] = useState(false)
  const [BackclickMap, setBackclickMap] = useState(false)
  const [SecEna, setSecEna] = useState(false);
  const [hodEna, sethodEna] = useState(false);
  const [KpiEna, setKpiEna] = useState(false);
  const [districtScores, setDistrictScores] = useState({});
  const [ConstScores, setConstScores] = useState({});
  const [activeTab, setActiveTab] = useState('Indicator');
  const [Indicatorenb, setIndicatorenb] = useState(false);
  const [Distenb, setDistenb] = useState(true);
  const [Constu, setConstu] = useState(false);
  const [distsearch, setdistsearch] = useState("");
  const [mandalsearch, setmandalsearch] = useState("");
  const [districtScoreslist, setDistrictScoreslist] = useState([]);
  const [ConstScoreslist, setConstScoreslist] = useState([]);
  const [mandalScoreslist, setmandalScoreslist] = useState([]);
  const [mandalScores, setmandalScores] = useState([]);
  const [geoData, setGeoData] = useState(null);
  const [tooltipContent, setTooltipContent] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedDistrictId, setSelectedDistrictId] = useState(null);
  const [filteredGeoData, setFilteredGeoData] = useState(null);
  const [selectedMandal, setSelectedMandal] = useState(null);
  const [mapCenter, setMapCenter] = useState([80.6, 16.3]); // default AP center
  const [mapScale, setMapScale] = useState(3500);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const handleMouseMove = (evt) => setTooltipPos({ x: evt.clientX + 10, y: evt.clientY + 10 });
  const [departmentHistory, setDepartmentHistory] = useState([]);
  const [parentDept, setParentDept] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [chartKey, setChartKey] = useState(0);
  const [Deptenb, setDeptenb] = useState(false);
  const [deptsearch, setdeptsearch] = useState("");
  const [departmentslist, setdepartmentslist] = useState([]);
  const [nodistdata, setnodistdata] = useState([]);
  const [show, setShow] = useState()
  const [Indicatormodal, setIndicatormodal] = useState()
  const [Indicatormandalsearch, setIndicatormandalsearch] = useState("");
  const [dashboardDistrictWiseIndicatorDataScoreslist, setdashboardDistrictWiseIndicatorDataScoreslist] = useState([]);
  const [Mandalenb, setMandalenb] = useState(false);
  const [mandalTabScoreslist, setmandalTabScoreslist] = useState([]);
  const [mandalTabScores, setmandalTabScores] = useState({});
  const [mandaltabsearch, setmandaltabsearch] = useState("");
  const [distlist, setDistrictList] = useState([]);
  const [distindenb, setdistindenb] = useState(false);
  const defaultGradeFilter = { "A+": true, "A": true, "B": true, "C": true, }; const [gradeFilter, setGradeFilter] = useState(defaultGradeFilter); const resetGradeFilter = () => setGradeFilter(defaultGradeFilter);

  const handleGradeChange = (grade) => { setGradeFilter((prev) => ({ ...prev, [grade]: !prev[grade], })); };

  const [Mandalalert, setMandalalert] = useState(false);

  // Helper to sanitize API name values - treat literal 'null'/'undefined' as empty
  const sanitizeName = (val) => {
    if (val === null || val === undefined) return ""; const s = String(val).trim();
    if (!s) return ""; if (["null", "undefined", "NULL", "UNDEFINED"].includes(s)) return ""; return s;
  };

  const getGeoProp = (props = {}, keys = []) => { for (const k of keys) {
      if (props.hasOwnProperty(k) && props[k] !== null && props[k] !== undefined) {
        const s = String(props[k]).trim();
        if (s !== "" && !["null", "undefined", "NULL", "UNDEFINED"].includes(s)) return s;
      } }
    const lowerMap = Object.keys(props).reduce((acc, cur) => { acc[cur.toLowerCase()] = props[cur]; return acc; }, {});
    for (const k of keys) {
      const v = lowerMap[k.toLowerCase()];
      if (v !== null && v !== undefined) { const s = String(v).trim(); if (s !== "" && !["null", "undefined", "NULL", "UNDEFINED"].includes(s)) return s; } } return ""; };

  // Compute modal header names with safe fallbacks to avoid 'null' strings (handles ULB/mandal/const APIs)
  const modalDistrictName = sanitizeName(mandalScoreslist?.[0]?.district_name || mandalScoreslist?.[0]?.district || mandalScoreslist?.[0]?.acname || mandalScoreslist?.[0]?.name);

  const modalSubName = (() => {
    if (!mandalScoreslist || mandalScoreslist.length === 0) return "";
    const first = mandalScoreslist[0];
    // For Indicator tab we don't show a sub-name (keeps original behaviour)
    if (activeTab === "Indicator") return "";
    if (activeTab === "Const") return sanitizeName(first.acname || first.const_name || first.name);
    // for ULB departments the list uses ulb_name, otherwise mandal_name
    if (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") return sanitizeName(first.ulb_name || first.mandal_name || first.name);
    return sanitizeName(first.mandal_name || first.ulb_name || first.name);
  })();

  // --- Indicator modal safe names (for `show={Indicatormodal}` modal) ---
  const indicatorFirst = dashboardDistrictWiseIndicatorDataScoreslist?.[0] || null;
  const indicatorModalDistrictName = indicatorFirst ? sanitizeName(indicatorFirst.district_name || indicatorFirst.district || indicatorFirst.acname || indicatorFirst.name) : "";
  const indicatorModalSubName = (() => {
    if (!indicatorFirst) return "";
    if (activeTab === "Indicator") return "";
    if (activeTab === "Const") return sanitizeName(indicatorFirst.acname || indicatorFirst.const_name || indicatorFirst.name);
    if (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") return sanitizeName(indicatorFirst.ulb_name || indicatorFirst.mandal_name || indicatorFirst.name);
    return sanitizeName(indicatorFirst.mandal_name || indicatorFirst.ulb_name || indicatorFirst.name);
  })();

  const [selectedAssemblycode, setSelectedAssemblyCode] = useState(false);
  const [SelectedAssembly, setSelectedAssembly] = useState(false);
  const [activeDept, setActiveDept] = useState(null);
  const [drillDepartments, setDrillDepartments] = useState([]);
  const [drillDepartmentsList, setDrillDepartmentsList] = useState([]);
  const [drillType, setDrillType] = useState("sec");




  const GradeFilter = ({ gradeFilter, onChange }) => {
    return (
      <div style={{ display: "flex", gap: "20px", alignItems: "center", marginBottom: "10px", paddingLeft: "10px", }} >
        <label> <input type="checkbox" checked={gradeFilter["C"]} onChange={() => onChange("C")} />{" "} <span style={{ color: "#ff5c5c", fontWeight: 600, marginLeft: "3px" }}> Aspirant (C) &lt; 50% </span> </label>

        <label> <input type="checkbox" checked={gradeFilter["B"]} onChange={() => onChange("B")} />{" "} <span style={{ color: "#27c9f3", fontWeight: 600, marginLeft: "3px" }}> Performer (B) 50% – 74% </span> </label>

        <label> <input type="checkbox" checked={gradeFilter["A"]} onChange={() => onChange("A")} />{" "} <span style={{ color: "#ffc107", fontWeight: 600, marginLeft: "3px" }}> Front Runner (A) 75% – 89% </span> </label>

        <label> <input type="checkbox" checked={gradeFilter["A+"]} onChange={() => onChange("A+")} />{" "} <span style={{ color: "#7ac943", fontWeight: 600, marginLeft: "3px" }}> Achiever (A+) 90% – 100% </span> </label>
      </div>);
  };


  const defaultPeriodicityFilter = { monthlyLowScore: false, quarterlyLowScore: false, }; const [periodicityFilter, setPeriodicityFilter] = useState(defaultPeriodicityFilter);

  const applyPeriodicityScoreFilter = (indicators = []) => {
    if (
      !periodicityFilter.monthlyLowScore &&
      !periodicityFilter.quarterlyLowScore
    ) {
      return indicators;
    }

    return indicators.filter((rec) => {
      const score = Number(rec?.achievedscore ?? 0);

      const periodicity = (rec?.periodic_name || "")
        .toString()
        .trim()
        .toLowerCase();

      if (
        periodicityFilter.monthlyLowScore &&
        periodicity.includes("monthly") &&
        score < 75
      ) {
        return true;
      }

      if (
        periodicityFilter.quarterlyLowScore &&
        periodicity.includes("quarterly") &&
        score < 75
      ) {
        return true;
      }

      return false;
    });
  };



  const resetPeriodicityFilter = () => setPeriodicityFilter(defaultPeriodicityFilter);

  const getFinalFilteredSDGData = () => { return gradeFilteredData?.map((sec) => ({ ...sec, departments: sec.departments?.map((dept) => ({ ...dept, indicators: applyPeriodicityScoreFilter(dept.indicators), }))?.filter((dept) => dept.indicators.length > 0), }))?.filter((sec) => sec.departments.length > 0); };

  useEffect(() => { return () => {  }; }, []);





  useEffect(() => {
    setChartKey((prev) => prev + 1);
  }, [districtScores]);

  const filteredDistData = distsearch.length > 0 ? districtScoreslist?.filter((item) => (
    item && Object.keys(item).some((key) => {
      const value = item[key];
      return (value !== null && value.toString().toLowerCase().includes(distsearch.toLowerCase()));
    })
  )) : districtScoreslist;

  const filteredConstData = distsearch.length > 0 ? ConstScoreslist?.filter((item) => (
    item && Object.keys(item).some((key) => {
      const value = item[key];
      return (value !== null && value.toString().toLowerCase().includes(distsearch.toLowerCase()));
    })
  )) : ConstScoreslist;

  const filteredMandalData = mandalsearch.length > 0 ? mandalScoreslist?.filter((item) => (
    item && Object.keys(item).some((key) => {
      const value = item[key];
      return (value !== null && value.toString().toLowerCase().includes(mandalsearch.toLowerCase()));
    })
  )) : mandalScoreslist;

  const filteredMandalTabScores = mandaltabsearch.length > 0 ? mandalTabScoreslist?.filter((item) => (
    item && Object.keys(item).some((key) => {
      const value = item[key];
      return (value !== null && value.toString().toLowerCase().includes(mandaltabsearch.toLowerCase()));
    })
  )) : mandalTabScoreslist;


  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        store.dispatch({ type: "SHOW_SPINNER" });
        const res = await MasterService.getDistricts();
        if (res?.data) setDistrictList(res.data);
      } catch (err) {
        console.error("getDistricts error", err);
      } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    };
    fetchDistricts();
    setDeptenb(false); setActiveTab("Indicator"); setDistenb(false); setIndicatorenb(true); setMandalenb(false); setConstu(false);
  }, [districtScoreslist]);


  const [secgrade, setsecgrade] = useState();
  const secretariatgradedata = (sec, dist, mandalIId, type) => {
    if (formik.values.scoreCatId === "Monthly" && !formik.values.scoreForMonth) { return; }
    let paramsssss = {
      userId: username, year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      type: role_cat_id === "116" ? (clickType === "sec" ? "sec" : clickType === "hod" ? "hod" : clickType === "district" ? "district" : "") : "sec",
      "secId": "0", "deptId": "0", districtId: dist, "mandalId": mandalIId, "ulbId": "0",
      typeDrill: role_cat_id === "116" ? "Sec" : role_cat_id === "115" || role_cat_id === "114" ? "hod" : role_cat_id === "119" ? "District" : role_cat_id === "111" || role_cat_id === "117" ? "Mandal" : ""
      // typeDrill:_cat_id === "114" ? "hod" : role_cat_id === "119" || role_cat_id === "113" ? "District" : role_cat_id === "111" || role_cat_id === "117" ? "Mandal" : "",
    };
    if (role_cat_id !== "112") {
      store.dispatch({ type: "SHOW_SPINNER" });
      KpiService.dashboardKpiScoresGardes(paramsssss).then((res) => {
        if (res.data && res.data.dataList) {
          const targetObj = res.data.dataList.find(item => item.secid === sec);
          setsecgrade(targetObj);

        }

      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }

  }



  useEffect(() => {
    setdashboardDistrictWiseIndicatorDataScoreslist([]);
  }, [activeTab]);


  useEffect(() => {

    if (suppressDataFetch) return;
    if (
      formik.values.scoreCatId === "Monthly" &&
      !formik.values.scoreForMonth
    ) {
      return;
    }
    const fetchAdminConststats = async () => {
      if (!(role_cat_id === "112" || role_cat_id === "116")) return;
      const params44 = {
        userId: username,
        year: formik.values.year,
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        type: "sec",
        districtId: selectedDistrictId ? selectedDistrictId : districtid,
        constId: assemblyid,
      };
      const params = {
        userId: username, year: formik.values.year, type: "main",
        districtId: selectedDistrictId ?? "0",
        constId: assemblyid, secId: "0", deptId: "0",
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      };

      try {
        store.dispatch({ type: "SHOW_SPINNER" });
        const res = role_cat_id === "116"
          ? await KpiService.DashboardAdminDataConstituencyWise(params)
          : role_cat_id === "112"
            ? await KpiService.dashboardDistrictDataConstituencyWise(params44)
            : null;

        if (res?.data) {
          if (res.data?.SCODE === "02") {
            setConstScoreslist([]); setConstScores({}); setnodistdata(true);
          } else {
            const scores = {};
            res.data.dataList?.forEach((item) => {
              const districtName = item.acname?.trim().toUpperCase();
              const isNoData = item.SCODE === "02";
              scores[districtName] = {
                avg: isNoData ? "-" : item.averagescore,
                grade: isNoData ? "-" : item.grade,
                color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
                indicators: isNoData ? 0 : item.noofindicators,
              };
            });
            setConstScoreslist(res.data.dataList); setConstScores(scores);
            setnodistdata(false);
          }
        }
      } catch (err) {
        setConstScoreslist([]); setConstScores({});
      } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    };
    fetchAdminConststats();
  }, [formik.values.year,
    apiMonthValue,
  formik.values.scoreCatId, suppressDataFetch]);

  useEffect(() => {
    if (suppressDataFetch) return;

    if (
      formik.values.scoreCatId === "Monthly" &&
      !formik.values.scoreForMonth
    ) {
      return;
    }
    if (["115", "114"].includes(role_cat_id)) { secretariatgradedata(secretariat_code, "0", "0"); }
    if (["119", "113", "117", "111"].includes(role_cat_id)) {
      formik.setFieldValue("district_id", districtid?.toString() || "");
      setSelectedDistrictId(districtid);
      secretariatgradedata(secretariat_code, districtid, ["111", "117"] ? mandalid : "0");
    } else {
      formik.setFieldValue(
        "district_id",
        "0"
      );
    }
    if (role_cat_id === "115") {
      setselectedsec(secretariat_code);
      setselecteddept("0")
    }
    else if (role_cat_id === "114") {
      setselectedsec(secretariat_code);
      setselecteddept(deptid)
    }
    else if (["113", "111"].includes(role_cat_id)) {
      setselectedsec(secretariat_code);
      setselecteddept(deptid);
    }
    mandaltabdata("0", "0", ["119", "113", "117", "111"].includes(role_cat_id) ? districtid : "0");
    setBackclick(false);
    let paramss = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year, type: "sec", "secId": "0", "deptId": "0", districtId: selectedDistrictId ?? "0", "mandalId": selectedmandalcode ?? "0", "ulbId": "0",
      typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
        ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
          (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
            : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
              : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",
    };

    if (role_cat_id === "116") {
      paramss.type = "sec";
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    } else if (role_cat_id === "115") {
      paramss.type = "hod";
      paramss.secId = secretariat_code;
      setKpiEna(true); sethodEna(true); setSecEna(false); setClickType("district");
    }
    else if (role_cat_id === "114") {
      paramss.type = "district";
      paramss.secId = secretariat_code;
      paramss.deptId = deptid;
      paramss.districtId = "0";
      setKpiEna(true); sethodEna(false); setSecEna(false); setClickType("");
    }
    else if (role_cat_id === "119") {
      paramss.type = "sec";
      paramss.secId = "0";
      paramss.deptId = "0";
      paramss.districtId = districtid;
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    }
    else if (role_cat_id === "113") {
      paramss.type = "district";
      paramss.secId = secretariat_code;
      paramss.deptId = deptid;
      paramss.districtId = districtid;
      setKpiEna(true); sethodEna(false); setSecEna(false); setClickType("");
    }
    else if (role_cat_id === "111") {
      paramss.type = "mandal";
      paramss.secId = secretariat_code;
      paramss.deptId = deptid;
      paramss.districtId = districtid;
      paramss.mandalId = ulbdeptlist.includes(deptid) ? "0" : mandalid;
      paramss.ulbId = ulbdeptlist.includes(deptid) ? ulbid : "0";
      setKpiEna(true); sethodEna(false); setSecEna(false); setClickType("");

    }
    else if (role_cat_id === "117") {
      paramss.type = "sec";
      paramss.secId = "0";
      paramss.deptId = "0";
      paramss.districtId = districtid;

      paramss.mandalId = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid;
      paramss.ulbId = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0";

      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    }
    let params44 = {
      "userId": username, "year": formik.values.year, "scoreForMonth": apiMonthValue, "scoreCatId": formik.values.scoreCatId, "type": "sec",
      "constId": assemblyid,
    }
    if (role_cat_id === "112") {
      console.log("hod", clickType)
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    }


    let param = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year, type: "", "secId": "0", "deptId": "0", districtId: selectedDistrictId ?? "0", "mandalId": selectedmandalcode ?? "0", "ulbId": "0",
      typeDrill: selectedMandal ? "Mandal" : selectedDistrict ? "District" : role_cat_id === "116" ? "Sec" : role_cat_id === "115" || role_cat_id === "114" ? "hod" : role_cat_id === "119" || role_cat_id === "113" ? "District" : role_cat_id === "111" || role_cat_id === "117" ? "Mandal" : ""
    };
    if (role_cat_id === "116") {
      param.type = "sec";
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    } else if (role_cat_id === "115") {
      param.type = "hod";
      param.secId = secretariat_code;
      setKpiEna(true); sethodEna(true); setSecEna(false); setClickType("district");
    } else if (role_cat_id === "114") {
      param.type = "district";
      param.secId = secretariat_code;
      param.deptId = deptid;
      param.districtId = role_cat_id === "119" ? districtid : "0";
      setKpiEna(true); sethodEna(true); setSecEna(false); setClickType("");
    }
    else if (role_cat_id === "119") {
      param.type = "sec";
      param.secId = "0";
      param.deptId = "0";
      param.districtId = districtid;
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    }
    else if (role_cat_id === "113") {
      param.type = "district";
      param.secId = secretariat_code;
      param.deptId = deptid;
      param.districtId = districtid;
      setKpiEna(true); sethodEna(false); setSecEna(false); setClickType("");
    }
    else if (role_cat_id === "117") {
      param.type = "sec";
      param.secId = "0";
      param.deptId = "0";
      param.districtId = districtid;
      param.mandalId = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid;
      param.ulbId = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0";
      setKpiEna(true); sethodEna(true); setSecEna(true); setClickType("hod");
    }
    else if (role_cat_id === "111") {
      param.type = "mandal";
      param.secId = secretariat_code;
      param.deptId = deptid;
      param.districtId = districtid;
      param.mandalId = (ulbdeptlist.includes(deptid) || selectedsec === "MAU01") ? "0" : mandalid;
      param.ulbId = (ulbdeptlist.includes(deptid) || selectedsec === "MAU01") ? ulbid : "0";

      setKpiEna(true); sethodEna(false); setSecEna(false); setClickType("");
    }
    if (!["116", "117", "119"].includes(role_cat_id)) { setulbdept(deptid); setulbdept2(deptid); }


    const fetchDepartmentsAndKpi = async () => {
      try {
        store.dispatch({ type: "SHOW_SPINNER" });
        const serviceCallRes = role_cat_id === "112"
          ? await KpiService.dashboardKpiScoresGardesConstituencyWise(params44)
          : await KpiService.dashboardKpiScoresGardes(param);

        if (serviceCallRes?.data) {
          if (serviceCallRes.data?.SCODE === "02") {
            setDepartments([]);
            setdepartmentslist([]);
          } else if (serviceCallRes.data && serviceCallRes.data.dataList) {
            const apiDepartments = serviceCallRes.data.dataList.map((item) => ({
              deptcode: (role_cat_id === "116" || role_cat_id === "119" || role_cat_id === "117" || role_cat_id === "112") ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
              dept_id: (role_cat_id === "116" || role_cat_id === "119" || role_cat_id === "117" || role_cat_id === "112") ? item.secid : item.dept_id,
              dept_name: (role_cat_id === "116" || role_cat_id === "119" || role_cat_id === "117" || role_cat_id === "112") ? item.sec_name : item.dept_name,
              secid: item.secid,
              sec_short_name: item.sec_short_name,
              secretariat_code: item.secretariat_code || "",
              averagescore: item.averagescore,
              grade: item.grade,
              color_code: item.color_code || item.color || null,
              noofindicators: item.noofindicators,
              assembly_name: item.assembly_name,
              accode: item.accode,
              district_id: item.district_id,
            }));
            setDepartments(apiDepartments);
            setdepartmentslist(serviceCallRes.data.dataList);
          }
        }

        const kpiRes = role_cat_id === "112"
          ? await KpiService.dashboardKpiDataConstituencyWise(params44)
          : await KpiService.dashboardKpiData(paramss);

        if (kpiRes?.data) {
          const updatedData = groupIndicators(kpiRes.data?.dataList);
          setdashboardKpiData(updatedData);
          setdashboardMonthData(kpiRes.data?.dataList?.[0]);
        }
      } catch (err) {
        console.error("fetchDepartmentsAndKpi error", err);
      } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    };

    fetchDepartmentsAndKpi();
  }, [username, formik.values.year,
    apiMonthValue,
    formik.values.scoreCatId, suppressDataFetch]);


  const deptnoofIndicators = (detail, type, sec, dept,) => {
    let paramss = {
      "userId": username,
      "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      "type": type,
      "secId": sec,
      "deptId": dept,
      "districtId": selectedDistrict === null ? "0" : selectedDistrictId,
      "mandalId": selectedMandal === null ? "0" : selectedmandalcode,
      "ulbId": "0",
      typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
        ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
          (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
            : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
              : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",
    }

    let params5 = {
      userId: username, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      year: formik.values.year,
      typeDrill: "",
      type: type === "district" ? "const" : type,
      districtId: districtid,
      constId: assemblyid,
      mandalId: "0",
      ulbId: role_cat_id === "112" && (type === "ULB" || type === "District") ? detail.mandal_id : "0",
      secId: detail.secid,
      deptId: clickType === "" ? dept : "0",
    };



    const serviceCallKpiData = role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const") ? KpiService.dashboardIndicatorDrillDownConstituencyWise(params5) : KpiService.dashboardKpiData(paramss);
    store.dispatch({ type: "SHOW_SPINNER" });
    serviceCallKpiData.then((res) => {
      setShow(false); setIndicatormodal(true)
      if (res.data && res.data.dataList) { setdashboardDistrictWiseIndicatorDataScoreslist(res.data.dataList); }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })
  }

  const MandalData = (type, sec, dept, dist, detail) => {

    store.dispatch({ type: "SHOW_SPINNER" });
    let department = ["114", "113", "111"].includes(role_cat_id) ? deptid : dept
    let secretariat = ["114", "113", "115", "111"].includes(role_cat_id) ? secretariat_code : sec
    let typename = role_cat_id === "115" ? "hod" : role_cat_id === "113" ? "district" : role_cat_id === "115" ? "sec" : type
    setulbdept(department);
    let params =
    {
      "userId": username,
      "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      "type": typename,
      "secId": secretariat,
      "deptId": department,
      "districtId": dist,
      "mandalId": "0",
      "ulbId": role_cat_id === "111" ? (ulbdeptlist.includes(deptid) ? ulbid : "0") : (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? (ulbid === "null" ? "0" : ulbid) : "0",


    }
    let paramsmm = {
      "userId": username,
      "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      "type": clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "const",
      "districtId": dist,
      "constId": role_cat_id === "116" ? String(detail.accode) : assemblyid,
      "secId": secretariat,
      "deptId": department,
      mandalId: selectedMandal !== null ? selectedmandalcode : "0",
    }
    const serviceCall = role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const") ? KpiService.dashboardMandalDataConstituencyWise(paramsmm) : KpiService.dashboardDistrictWiseData(params);
    store.dispatch({ type: "SHOW_SPINNER" });
    serviceCall.then((res) => {
      setShow(true);
      if (res.data?.SCODE === "02") {
        setmandalScoreslist([]);
        setmandalScores({});
        ;
      }
      else if (res.data && res.data.dataList) {
        const scores = {};
        res.data.dataList?.forEach((item) => {
          const mandalname = ((ulbdeptlist.includes(department) || selectedsec === "MAU01") ? item.ulb_name : item.mandal_name)?.trim().toUpperCase();
          const isNoData = item.SCODE === "02"
          scores[mandalname] = {
            avg: isNoData ? "-" : item.averagescore,
            grade: isNoData ? "-" : item.grade,
            color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
            indicators: isNoData ? 0 : item.noofindicators,
          };
        });
        setmandalScores(scores);
        setmandalScoreslist(res.data.dataList);
      }

    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })

  }

  const handleDownloadAllConstuExcel = async () => {
    try {
      store.dispatch({ type: "SHOW_SPINNER" });
      const params = { userId: username, type: "allConstExcel", year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId, };

      const res = await KpiService.dashboardIndicatorDrillDownConstituencyWise(params);
      const list = res?.data?.dataList || [];
      if (!list || list.length === 0) { showAlertMessage("No data to export", "warning"); return; }

      const rows = list.map((it, idx) => ({
        "S.No": idx + 1, 
        // "District Name": it.district_name,
        "Constituency Name": it.acname, "Secretariat Department": it.sec_name , "HOD Name": it.dept_name, 
        "KPI": it.indicator_name, "Unit": it.unit_name , "Periodicity": it.periodic_name, "Entry Level": it.kpi_entry_level, "Time fraction": it.time_fraction,
        "Indicator nature": it.indicator_nature, "Target": it.target_value, "Achievement": it.achieved_value, "Score": it.achievedscore, "Grade": it.grade,
      }));
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(wb, ws, "All_Constituencies");
      const fileName = `KPI Performance_ALL_Constituencies_${formik.values.year || ""}_${getReadableTimeStamp()}.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (err) { console.error("Export  KPI Performance ALL Constituencies Excel failed:", err); showAlertMessage("Export failed", "error");
    } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  }


  const filteredIndicatorData = React.useMemo(() => {
    if (!search.trim()) return dashboardKpiData;

    const term = search.toLowerCase();

    return dashboardKpiData
      .map(sec => {
        const filteredDepartments = sec.departments
          .map(dept => {
            const filteredIndicators = dept.indicators.filter(ind =>
              Object.values(ind).some(val =>
                val?.toString().toLowerCase().includes(term)
              )
            );

            return filteredIndicators.length
              ? { ...dept, indicators: filteredIndicators }
              : null;
          })
          .filter(Boolean);

        return filteredDepartments.length
          ? { ...sec, departments: filteredDepartments }
          : null;
      })
      .filter(Boolean);
  }, [dashboardKpiData, search]);



  const districtMap = async (districtname, district_id) => {
    if (districtname) {
      setSelectedDistrictId(district_id);
      setSelectedDistrict(districtname);

      const { original, upper, capitalized } = formatDistrictFileName(districtname);
      const candidates = [original, upper, capitalized];

      let found = false;

      for (const dist of candidates) {
        // const filePaths = [
        //   `/Mandals/${dist}/${dist}_Mandals.geojson`,
        //   `/Mandals/${dist}/${dist}.geojson`
        // ];
        const filePaths = [`/28_Districts/${dist}.geojson`];

        for (const path of filePaths) {
          try {
            store.dispatch({ type: "SHOW_SPINNER" });
            const res = await fetch(path);
            if (res.ok) {
              const data = await res.json();
              setFilteredGeoData(data);
              setGeoData(null);
              found = true;
              break;
            }
          } catch (err) {
            console.warn(`❌ Failed to load ${path}`, err);
          } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
          }
        }
        if (found) break;
      }

      if (!found) {
        console.error("No valid geojson found for district:", candidates);
      }
    }
  }

  const mandalMap = async (mandalname, district, district_id, mandalCode, assemblyName, assemblyCode) => {
    if (!mandalname || !mandalCode) return;
    store.dispatch({ type: "SHOW_SPINNER" });

    setSelectedMandal(mandalname);
    setselectedmandalcode(mandalCode);

    const { original: dOrig, upper: dUpper, capitalized: dCap } = formatDistrictFileName(district);
    const districtCandidates = [dOrig, dUpper, dCap];

    let found = false;
    for (const dist of districtCandidates) {

      let paths = [];
      if (role_cat_id === "112") {
        paths = [`/Assem_Mandals_code/${assemblyName}/${mandalCode}.geojson`];
      } else {
        paths = [`/28_Dist_Mandal_Code/${district_id}/${mandalCode}.geojson`];
      }

      console.log("✅ Final Path:", paths);

      for (const path of paths) {
        try {
          console.log("Trying to fetch:", path);

          const geoRes = await fetch(path);

          if (geoRes.ok) {
            const data = await geoRes.json();

            console.log("✅ GeoJSON Loaded Successfully:", path);

            setFilteredGeoData(data);
            setGeoData(null);
            found = true;
            break;
          } else {
            console.log("❌ Not found:", path);
          }

        } catch (err) {
          console.warn(`❌ Failed to load ${path}`, err);
        } finally {
          store.dispatch({ type: "HIDE_SPINNER" });
        }
      }

      if (found) break;
    }
  };

  const assemblyMap = async (assemblyName, district, mandalid, assemblyCode) => {
    if (!assemblyName || !assemblyCode) return; store.dispatch({ type: "SHOW_SPINNER" });
    setSelectedAssembly(assemblyName); setSelectedAssemblyCode(assemblyCode);

    const { original: dOrig, upper: dUpper, capitalized: dCap } = formatDistrictFileName(district);
    const districtCandidates = [dOrig, dUpper, dCap];

    const sanitize = (s = "") => String(s || "").trim();
    const plain = sanitize(assemblyName); const noSpaces = plain.replace(/\s+/g, "");
    const underscore = plain.replace(/\s+/g, "_"); const lower = plain.toLowerCase();
    const noSpacesLower = noSpaces.toLowerCase(); const underscoreLower = underscore.toLowerCase();
    const alnumLower = plain.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

    const candidates = Array.from(new Set([plain, underscore, lower,
      underscoreLower, noSpacesLower, alnumLower, `cvapu_${alnumLower}`,])).filter(Boolean);
    let found = false;
    for (const dist of districtCandidates) {
      const paths = candidates.map(c => `/ConstuMaps/Assembly_${c}.geojson`);
      // try plain pattern too
      paths.unshift(`/ConstuMaps/Assembly_${plain}.geojson`);
      // attempt each path until one succeeds
      for (const path of paths) { try {
          console.log("Trying assembly geojson:", path); const geoRes = await fetch(path);
          if (geoRes.ok) { const data = await geoRes.json();
            const feat = data?.features?.[0]; const props = feat?.properties || {};
             const normalizeDistrict = (str = "") => str.toLowerCase().replace(/_/g, " ").replace(/\s+/g, " ").trim();
            const geoDistrict = normalizeDistrict(props.District || props.district || props.district_name || props.DHQ || props.RevenueD || "");
            const expectedDistrict = normalizeDistrict(dist || district || "");
            if (expectedDistrict && geoDistrict && geoDistrict.indexOf(expectedDistrict) === -1 && expectedDistrict.indexOf(geoDistrict) === -1) {
              console.log(`Loaded ${path} but district '${geoDistrict}' does not match expected '${expectedDistrict}', skipping.`);
              continue;
            } setFilteredGeoData(data); setGeoData(null); found = true; break; }
        } catch (err) {
          console.warn(`Failed to load ${path}`, err);
        } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
      }
      if (found) break;
    }

    if (!found) { console.error("No valid geojson found for:", assemblyName, district, mandalid, assemblyCode); }

    store.dispatch({ type: "HIDE_SPINNER" });

    if (!found) {
      console.error(`Assembly geojson not found for:`, assemblyName, district, mandalid, assemblyCode);
    }
  };

  useEffect(() => {

    const fetchData = async () => {
      try {
        store.dispatch({ type: "SHOW_SPINNER" });
        if (role_cat_id === "115" && username === "MAU01") { setGeoData(null); return; }
        if (["116", "114", "115"].includes(String(role_cat_id))) {
          const res = await fetch('/andhra_pradesh.geojson');
          const data = await res.json();
          setGeoData(data);
        } else if (["119", "113"].includes(String(role_cat_id))) {
          districtMap(localStorage.getItem("districtname"), localStorage.getItem("districtid"));
        }
        else if (["111", "117"].includes(String(role_cat_id))) {
          setSelectedDistrict(localStorage.getItem("districtname"));
          setSelectedMandal(localStorage.getItem("mandalname"));
          setselectedmandalcode(mandalid);
          setselectedmap("mandalmap");
          mandalMap(localStorage.getItem("mandalname"), localStorage.getItem("districtname"), localStorage.getItem("districtid"), localStorage.getItem("mandalid"), localStorage.getItem("assemblyname"), localStorage.getItem("assemblyid"));
        }
        else if (role_cat_id === "112") { assemblyMap(localStorage.getItem("assemblyname"), localStorage.getItem("districtname"), localStorage.getItem("mandalid"), localStorage.getItem("assemblyid")); }
      } catch (err) { console.error("GeoJSON fetch error:", err); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
    };
    fetchData();
  }, [role_cat_id]);


  const fitFeaturesToView = (features, width, height, padding = 20) => {
    const featureCollection = {
      type: "FeatureCollection",
      features: features,
    };

    const projection = d3.geoMercator().fitExtent(
      [
        [padding, padding],
        [width - padding, height - padding],
      ],
      featureCollection
    );

    const center = projection.invert([width / 2, height / 2]);
    const scale = projection.scale() * 0.9; // keep a small margin inside box

    return { center, scale };
  };


  useEffect(() => {
    let features = null;

    if (selectedMandal && filteredGeoData?.features?.length > 0) {
      features = filteredGeoData.features;
    } else if (selectedDistrict && filteredGeoData?.features?.length > 0) {
      features = filteredGeoData.features;
    } else if (geoData?.features?.length > 0) {
      features = geoData.features;
    } else if (role_cat_id === "112" && filteredGeoData?.features?.length > 0) {
      features = filteredGeoData.features;
    }

    if (!features) return;

    const padding = 20;
    const { center, scale } = fitFeaturesToView(features, 945, 500, padding);
    setMapCenter(center);
    setMapScale(scale);
  }, [selectedDistrict, selectedMandal, filteredGeoData, geoData, role_cat_id]);



  // useEffect(() => {
  //   if (formik.values.scoreCatId === "Monthly" && months?.length > 0) {
  //     const firstMonth =
  //       (months[0].month_code ||
  //         months[0].monthCode ||
  //         months[0].code)?.toString();

  //     formik.setFieldValue("scoreForMonth", firstMonth);
  //   }
  // }, [months, formik.values.scoreCatId]);

  const firstMonthIndex = formik.values.scoreForMonth || (months?.[0]?.month_code || months?.[0]?.monthCode || months?.[0]?.code);



  useEffect(() => {
    if (suppressDataFetch) return;
    // Monthly ayithe month empty unte first api call skip
    if (
      formik.values.scoreCatId === "Monthly" &&
      !formik.values.scoreForMonth
    ) {
      return;
    }

    const params = {
      userId: username,
      year: formik.values.year,
      scoreForMonth: apiMonthValue,
      scoreCatId: formik.values.scoreCatId,
      type: "mapSec",
      secId: "0",
      deptId: "0",
      districtId: selectedDistrictId ?? "0",
      mandalId: selectedmandalcode ?? "0",
      ulbId: "0",
    };

    if (role_cat_id === "116") {
      params.type = "mapSec";
    }
    else if (role_cat_id === "115") {
      params.type = "mapHod";
      params.secId = hod_id;
    }
    else if (role_cat_id === "114" || role_cat_id === "113") {
      params.type = "mapDistrict";
      params.secId = secretariat_code;
      params.deptId = deptid;
      params.districtId = districtid;
    }
    else if (role_cat_id === "119") {
      params.type = "mapSec";
      params.secId = "0";
      params.deptId = "0";
      params.districtId = districtid;
    }
    else if (role_cat_id === "111") {
      params.type = "mapMandal";
      params.secId = secretariat_code;
      params.deptId = deptid;
      params.districtId = districtid;
      params.mandalId =
        (ulbdeptlist.includes(deptid) || selectedsec === "MAU01")
          ? "0"
          : mandalid;

      params.ulbId =
        (ulbdeptlist.includes(deptid) || selectedsec === "MAU01")
          ? ulbid
          : "0";
    }
    else if (role_cat_id === "117") {
      params.type = "mapSec";
      params.secId = "0";
      params.deptId = "0";
      params.districtId = districtid;

      params.mandalId =
        (ulbdeptlist.includes(deptid) || selectedsec === "MAU01")
          ? "0"
          : mandalid;

      params.ulbId =
        (ulbdeptlist.includes(deptid) || selectedsec === "MAU01")
          ? ulbid
          : "0";
    }

    if (!["116", "117", "119"].includes(role_cat_id)) {
      setulbdept(deptid);
    }

    if (role_cat_id !== "112") {
      store.dispatch({ type: "SHOW_SPINNER" });

      KpiService.dashboardKpiScoresGardes(params)
        .then((res) => {
          if (res.data) {
            const scores = {};

            if (res.data?.SCODE === "02") {
              setDistrictScoreslist([]);
              setDistrictScores({});
              setnodistdata(true);
            } else {
              setnodistdata(false);

              res.data.dataList?.forEach((item) => {
                const districtName = item.district_name
                  ?.replace(/\s+/g, " ")
                  .trim()
                  .toUpperCase();

                const isNoData = item.SCODE === "02";

                scores[districtName] = {
                  avg: isNoData ? "-" : item.averagescore,
                  grade: isNoData ? "-" : item.grade,
                  color: isNoData
                    ? "#ccc"
                    : (item.color_code || "#ccc"),
                  indicators: isNoData
                    ? 0
                    : item.noofindicators,
                };
              });

              setDistrictScoreslist(res.data.dataList);
              setDistrictScores(scores);
            }
          }
        })
        .catch(() => {
          setDistrictScoreslist([]);
          setDistrictScores({});
          setnodistdata(true);
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }

  }, [
    formik.values.year,
    apiMonthValue,
    formik.values.scoreCatId, suppressDataFetch
  ]);



  const [selectedmap, setselectedmap] = useState("statemap");

  const mandaltabdata = (sec, dept, dist, forceMandal = false) => {

    store.dispatch({ type: "SHOW_SPINNER" });
    let secretariat = (["114", "115", "113", "111"].includes(role_cat_id)) ? secretariat_code : sec
    let department = (["114", "113", "111"].includes(role_cat_id)) ? deptid : dept;
    let district = selectedDistrictId !== null ? selectedDistrictId : dist;
    let mandalll = ["111", "117"].includes(role_cat_id) ? (ulbdeptlist.includes(role_cat_id === "117" ? ulbdept : deptid) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0";
    let ulb = ["111", "117"].includes(role_cat_id) ? (ulbdeptlist.includes(role_cat_id === "117" ? ulbdept : deptid) || selectedsec === "MAU01") ? ulbid : "0" : "0";
    setulbdept(department);

    let params = {
      "userId": username, "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      "type": clickType === "district" ? "const" : clickType,
      districtId: dist,
      "constId": assemblyid, "secId": sec ?? "0", "deptId": dept ?? "0",
      mandalId: selectedMandal !== null ? selectedmandalcode : "0",
    }

    let params1 = {
      "userId": username,
      "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      "secId": secretariat, "deptId": department, "districtId": district, "mandalId": mandalll, "ulbId": ulb
    }

    const serviceCall = role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const" && !forceMandal) ? KpiService.dashboardMandalDataConstituencyWise(params) : KpiService.dashboardMandalWiseIndicatorDataTab(params1);

    store.dispatch({ type: "SHOW_SPINNER" }); serviceCall.then((res) => {
      if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setmandalTabScores({}); setMandalalert(true); }
      if (res.data && res.data.dataList) {
        const scores = {}; setMandalalert(false);
        const mandalData = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01" || sec === "MAU01") ? res.data.dataList?.filter(item => item.type === "ULB") : res.data.dataList?.filter(item => item.type === "MANDAL");
        mandalData.forEach((item) => {
          const mandalname = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01" || sec === "MAU01") ? item.ulb_name : item.mandal_name?.trim().toUpperCase();
          const isNoData = item.SCODE === "02"; scores[mandalname] = {
            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
          };
        }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList);
      }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  }

  const normalizeDepartments = (dataList = []) =>
    dataList.map((item) => ({
      deptcode: (item.deptcode || item.secid || "").trim().toUpperCase(),
      dept_id: item.dept_id || item.secid,
      dept_name: item.dept_name || item.sec_name,
      secid: item.secid,
      secretariat_code: item.secretariat_code || "",
      averagescore: item.averagescore,
      grade: item.grade,
      color_code: item.color_code || item.color || null,
      noofindicators: item.noofindicators,
      district_id: item.district_id,
    }));

  const handleCircleClick = (dept) => {
    resetDrillToSecretariat(); resetPeriodicityFilter(); resetGradeFilter();
    setActiveDept(null);
    setActiveTab("Indicator");
    setIndicatorenb(true);
    if (clickType === "hod" && selectedDistrictId) { secretariatgradedata(dept.dept_id, selectedDistrictId, selectedMandal ? selectedmandalcode : "0") }
    setDeptenb(false); setActiveTab("Indicator"); setDistenb(false); setIndicatorenb(true); setMandalenb(false); setConstu(false);

    setdeptsearch("");
    setSearch(""); setdistsearch("");
    setSortConfig({ key: null, direction: "asc" });
    const normalizedDeptCode = dept.deptcode?.trim().toUpperCase();

    setDepartmentHistory((prev) => [
      ...prev,
      { departments, clickType, secEna: SecEna, hodEna, kpiEna: KpiEna },
    ]);
    let userDistrictId = ["119", "113", "117", "111"].includes(role_cat_id) ? districtid : (selectedDistrictId ?? "0")

    if (clickType === "") {
      return;
    }
    else if (clickType === "hod" && (["116", "115", "119", "117", "112"].includes(role_cat_id))) {
      mandaltabdata(dept.dept_id, "0", role_cat_id === "112" ? "0" : userDistrictId,)
      setselectedsec(dept.dept_id);
      setselecteddept("0")
      setSearchTerm("")
      setBackclick(true);
      setParentDept(dept);
      setSecid(dept?.deptcode)
      setClickType("district");

      let params = {
        userId: username,
        year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        type: "hod",
        secId: normalizedDeptCode,
        "deptId": "0",
        "districtId": selectedDistrict !== null ? selectedDistrictId : "0",
        mandalId: (["117", "111"].includes(role_cat_id)) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
        ulbId: (["117", "111"].includes(role_cat_id)) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
        typeDrill: (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "hod"
          : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
            : (["119", "113"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "District" : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
              : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Mandal"
                : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : ""
      };
      let params44 = {
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        "userId": username, "year": formik.values.year, "type": "hod",
        "constId": assemblyid, "secId": dept?.secid, "deptId": "0",
      }
      store.dispatch({ type: "SHOW_SPINNER" });
      const serviceCall = role_cat_id === "112" ? KpiService.dashboardKpiScoresGardesConstituencyWise(params44) : KpiService.dashboardKpiScoresGardes(params);
      serviceCall.then((res) => {
        if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]);; }
        else if (res.data && res.data.dataList) {
          const mapped = normalizeDepartments(res.data.dataList);
          setDepartments(mapped); setdepartmentslist(mapped);
        }

        if (role_cat_id === "116") {
          return KpiService.dashboardKpiScoresGardes(params).then((res) => {
            if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
            else if (res.data && res.data.dataList) {
              const apiDepartments = res.data.dataList.map((item) => ({
                deptcode: item.deptcode?.trim().toUpperCase(),
                dept_id: item.dept_id, dept_name: item.dept_name, secid: item.secretariat_code,
                secretariat_code: item.secretariat_code, sec_short_name: item.sec_short_name, averagescore: item.averagescore,
                grade: item.grade, noofindicators: item.noofindicators,
              }));
              setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);

            }
          });
        }
      }).then(() => {

        if (role_cat_id === "112" || role_cat_id === "116") {
          let params = {
            "userId": username,
            "year": formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
            "type": "main",
            "districtId": selectedDistrictId ?? "0",
            "constId": assemblyid, "secId": dept?.secid, deptId: "0",
          }
          const AdminConststats = role_cat_id === "116" ? KpiService.DashboardAdminDataConstituencyWise(params) :
            role_cat_id === "112" ? KpiService.dashboardDistrictDataConstituencyWise(params44) : ""
          return AdminConststats.then((res) => {
            if (res.data) {
              const scores = {};
              if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); } else {
                setnodistdata(false); res.data.dataList?.forEach((item) => {
                  const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase();
                  const isNoData = item.SCODE === "02"; scores[districtName] = {
                    avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade, color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
                    indicators: isNoData ? 0 : item.noofindicators,
                  };
                }); setConstScoreslist(res.data.dataList); setConstScores(scores);
              }
            }
          });
        }
      }).then(() => {


        if (role_cat_id !== "112") {
          const paramss = {
            scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
            userId: username, year: formik.values.year, secId: dept.dept_id, deptid: "0", type: "mapHod",
            districtId: selectedDistrict !== null ? selectedDistrictId : "0",
            mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
            ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
          };
          return KpiService.dashboardKpiScoresGardes(paramss).then((res) => {
            if (res.data) {
              const scores = {}; if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true); } else {
                setnodistdata(false); res.data.dataList?.forEach((item) => {
                  const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase(); const isNoData = item.SCODE === "02"
                  scores[districtName] = { avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade, color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators, };
                }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores);
              }
            }
          });
        }
      }).then(() => {

        let params11 = {
          scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
          userId: username, year: formik.values.year, secId: dept.dept_id, type: "hod",
          "deptId": "0", "districtId": selectedDistrict !== null ? selectedDistrictId : "0",
          mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
          ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
          typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
            ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
              (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
                : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                  : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",

        };
        const serviceCallkpidata = (role_cat_id === "112") ? KpiService.dashboardKpiDataConstituencyWise(params44) : KpiService.dashboardKpiData(params11);
        return serviceCallkpidata.then((res) => {
          if (res.data) {
            setdashboardMonthData(res.data?.dataList?.[0]);
            const updatedData = groupIndicators(res.data?.dataList);
            setdashboardKpiData(updatedData)
            setKpiEna(true);
            sethodEna(true);
            setSecEna(false);
          }
        });
      }).catch(() => { setDepartments([]); setdashboardKpiData([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }
    else if (clickType === "district") {

      setSearchTerm("");
      if (role_cat_id === "112") { setselectedsec(dept.secid); }
      setselecteddept(dept.dept_id); mandaltabdata(selectedsec, dept.dept_id, role_cat_id === "112" ? "0" : userDistrictId); setClickType("");
      if (role_cat_id === "115") {
        setParentDept(dept);
      }
      setBackclick(true);
      const params11 = {
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        userId: username, year: formik.values.year, type: "district", secId: dept.secretariat_code, deptId: dept.dept_id,
        "districtId": selectedDistrict !== null ? selectedDistrictId : "0",
        mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
        ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",


        typeDrill: (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "hod"
          : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
            : (["119", "113"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "District" : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
              : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Mandal"
                : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : ""
      };

      const params12 = {
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        userId: username, year: formik.values.year, type: "district", secId: dept.secretariat_code, deptId: dept.dept_id,
        "districtId": selectedDistrict !== null ? selectedDistrictId : "0",
        mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
        ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
        typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" : ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
          (role_cat_id === "111" || role_cat_id === "117") ? "Mandal" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
            : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",
      }
      let params44 = {
        "userId": username, "year": formik.values.year, "type": "const",
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        "constId": assemblyid, "secId": dept?.secid, "deptId": dept.dept_id,
      }; setSecid(dept?.deptcode)
      const serviceCall = role_cat_id === "112" ? KpiService.dashboardKpiScoresGardesConstituencyWise(params44) : KpiService.dashboardKpiScoresGardes(params11);
      store.dispatch({ type: "SHOW_SPINNER" });
      serviceCall.then((res) => {
        if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]);; }
        else { if (res.data && res.data.dataList) { setDepartments(res.data.dataList); setdepartmentslist(res.data.dataList); } }
      }).catch(() => {
        setDepartments([]); setdepartmentslist([]);
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

      if (role_cat_id === "116") {
        const service = KpiService.dashboardKpiScoresGardes(params11);
        store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
          if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
          else if (res.data && res.data.dataList) {
            const apiDepartments = res.data.dataList.map((item) => ({
              deptcode: item.deptcode?.trim().toUpperCase(),
              dept_id: item.dept_id, dept_name: item.dept_name, secid: item.secretariat_code,
              secretariat_code: item.secretariat_code, sec_short_name: item.sec_short_name, averagescore: item.averagescore,
              grade: item.grade, noofindicators: item.noofindicators,
            })); setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);
          }

        }).catch(() => { setDrillDepartments([]); setDrillDepartmentsList([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
      }

      const serviceCallkpidata = (role_cat_id === "112") ? KpiService.dashboardKpiDataConstituencyWise(params44) : KpiService.dashboardKpiData(params12);
      store.dispatch({ type: "SHOW_SPINNER" }); serviceCallkpidata.then((res) => {
        if (res.data && res.data.SCODE === "01") {
          const updatedData = groupIndicators(res.data?.dataList);
          setdashboardKpiData(updatedData)
          setdashboardMonthData(res.data?.dataList?.[0]); setKpiEna(true); sethodEna(false); setSecEna(false);
        }
      }).catch(() => { }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

      if (role_cat_id !== "112") {
        const paramss3 = {
          scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
          userId: username, year: formik.values.year, secId: dept.secretariat_code, deptId: dept.dept_id, type: "mapDistrict",
          districtId: selectedDistrict !== null ? selectedDistrictId : "0",
          mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
          ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
        };
        store.dispatch({ type: "SHOW_SPINNER" }); KpiService.dashboardKpiScoresGardes(paramss3).then((res) => {
          if (res.data) {
            const scores = {}; if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true); } else {
              setnodistdata(false); res.data.dataList?.forEach((item) => {
                const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase();
                const isNoData = item.SCODE === "02"; scores[districtName] = {
                  avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                  color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators, };
              }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores);
            } } }).catch(() => { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);
        }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }

      if (role_cat_id === "112" || role_cat_id === "116") {
        let params = {
          scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
          "userId": username, "year": formik.values.year,
          "type": "main",
          "districtId": selectedDistrictId ?? "0",
          "constId": assemblyid, secId: dept.secretariat_code, deptId: dept.dept_id,
        }
        store.dispatch({ type: "SHOW_SPINNER" });
        const AdminConststats = role_cat_id === "116" ? KpiService.DashboardAdminDataConstituencyWise(params) :
          role_cat_id === "112" ? KpiService.dashboardDistrictDataConstituencyWise(params44) : ""
        AdminConststats.then((res) => {
          if (res.data) {
            const scores = {};
            if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); } else {
              setnodistdata(false); res.data.dataList?.forEach((item) => {
                const districtName = item.acname?.trim().toUpperCase(); const isNoData = item.SCODE === "02";
                scores[districtName] = {
                  avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                  color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
                  indicators: isNoData ? 0 : item.noofindicators,
                };
              }); setConstScoreslist(res.data.dataList); setConstScores(scores);
            }
          }
        }).catch(() => {
          setConstScoreslist([]); setConstScores({}); setnodistdata(true);
        }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
      }
    }
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    } setSortConfig({ key, direction });
  };

  const gradeRank = (grade) => {
    switch (grade) {
      case "A+": return 5;
      case "A": return 4;
      case "B+": return 3;
      case "B": return 2;
      case "C": return 1;
      default: return 0;
    }
  };

  const gradeFilteredData = filteredIndicatorData.map((sec) => {
    const filteredDepartments = sec.departments
      .map((dept) => {
        const filteredIndicators = getSortedIndicators(
          dept.indicators,
          sortConfig,
          gradeRank
        ).filter((rec) => gradeFilter[rec?.achievedgrade]);

        return {
          ...dept,
          indicators: filteredIndicators,
        };
      })
      .filter((dept) => dept.indicators.length > 0); // remove empty departments

    return {
      ...sec,
      departments: filteredDepartments,
    };
  }).filter(sec => sec.departments.length > 0); // remove empty sections
  //added
  const finalIndicatorData = getFinalFilteredSDGData();
  const isNoIndicatorData = !finalIndicatorData || finalIndicatorData.length === 0;




  const finalFilteredSDGData = React.useMemo(() => {
    return gradeFilteredData
      ?.map((sec) => ({
        ...sec,
        departments: sec.departments
          ?.map((dept) => ({
            ...dept,
            indicators: applyPeriodicityScoreFilter(dept.indicators),
          }))
          ?.filter((dept) => dept.indicators.length > 0),
      }))
      ?.filter((sec) => sec.departments.length > 0);
  }, [gradeFilteredData, periodicityFilter]);

  const gradeFilteredDistData = React.useMemo(() => {
    if (!filteredDistData || filteredDistData.length === 0) return [];

    return filteredDistData.filter(
      (dist) => gradeFilter[dist?.grade] === true
    );
  }, [filteredDistData, gradeFilter]);


  const sortedDistrictScores = React.useMemo(() => {
    let sortableData = [...(gradeFilteredDistData || [])];
    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        const valA = sortConfig.key === "achievedscore" ? a.averagescore : sortConfig.key === "achievedgrade" ?
          gradeRank(a.grade) : sortConfig.key === "noofindicators" ? Number(a.noofindicators) :
            sortConfig.key === "target" ? a.target : sortConfig.key === "achivementvalue" ? a.achivementvalue : a.district_name;
        const valB = sortConfig.key === "achievedscore" ? b.averagescore : sortConfig.key === "achievedgrade" ? gradeRank(b.grade) : sortConfig.key === "noofindicators"
          ? Number(b.noofindicators) :
          sortConfig.key === "target" ? b.target : sortConfig.key === "achivementvalue" ? b.achivementvalue : b.district_name;
        if (valA === null || valA === undefined) return 1; if (valB === null || valB === undefined) return -1;
        if (sortConfig.key === "target") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achivementvalue") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achievedscore") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achievedgrade") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "noofindicators") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "district_name") {
          return sortConfig.direction === "asc" ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
        }
        return 0;
      });
    } return sortableData;
  }, [gradeFilteredDistData, sortConfig]);


  const gradeFilteredConstData = React.useMemo(() => {
    if (!filteredConstData || filteredConstData.length === 0) return [];

    return filteredConstData.filter(
      (item) => gradeFilter[item?.grade] === true
    );
  }, [filteredConstData, gradeFilter]);


  const sortedConstScores = React.useMemo(() => {
    let sortableData = [...(gradeFilteredConstData || [])]; if (sortConfig.key) {
      sortableData.sort((a, b) => {
        const valA = sortConfig.key === "achievedscore"
          ? a.averagescore : sortConfig.key === "achievedgrade" ? gradeRank(a.grade) : sortConfig.key === "noofindicators" ? Number(a.noofindicators) :
            sortConfig.key === "target" ? a.target : sortConfig.key === "achivementvalue" ? a.achivementvalue : a.district_name;
        const valB = sortConfig.key === "achievedscore" ? b.averagescore : sortConfig.key === "achievedgrade" ? gradeRank(b.grade) : sortConfig.key === "noofindicators" ? Number(b.noofindicators) :
          sortConfig.key === "target" ? b.target : sortConfig.key === "achivementvalue" ? b.achivementvalue : b.district_name;
        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;
        if (sortConfig.key === "target") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achivementvalue") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achievedscore") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achievedgrade") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "noofindicators") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "district_name") {
          return sortConfig.direction === "asc"
            ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
        } return 0;
      });
    } return sortableData;
  }, [gradeFilteredConstData, sortConfig]);

  const gradeFilteredMandalData = React.useMemo(() => {
    if (!filteredMandalData || filteredMandalData.length === 0) return [];

    return filteredMandalData.filter(
      (item) => gradeFilter[item?.grade] === true
    );
  }, [filteredMandalData, gradeFilter]);

  const sortedMandalScores = React.useMemo(() => {
    let sortableData = [...(gradeFilteredMandalData || [])];
    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        const valA =
          sortConfig.key === "achievedscore"
            ? a.averagescore
            : sortConfig.key === "achievedgrade"
              ? gradeRank(a.grade)
              : sortConfig.key === "noofindicators"
                ? Number(a.noofindicators) : sortConfig.key === "target" ? a.target : sortConfig.key === "achivementvalue" ? a.achivementvalue
                  : (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? a.ulb_name : a.mandal_name;

        const valB =
          sortConfig.key === "achievedscore"
            ? b.averagescore
            : sortConfig.key === "achievedgrade"
              ? gradeRank(b.grade)
              : sortConfig.key === "noofindicators"
                ? Number(b.noofindicators)
                : sortConfig.key === "target" ? a.target : sortConfig.key === "achivementvalue" ? a.achivementvalue :
                  (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? b.ulb_name : b.mandal_name;

        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;
        if (sortConfig.key === "target") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achivementvalue") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }

        if (sortConfig.key === "achievedscore") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }

        if (sortConfig.key === "achievedgrade") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }

        if (sortConfig.key === "noofindicators") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }

        if (sortConfig.key === "mandal_name") {
          return sortConfig.direction === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }

        return 0;
      });
    }
    return sortableData;
  }, [gradeFilteredMandalData, sortConfig]);
  //hai

  const gradeFilteredMandalTabScoresSorted = React.useMemo(() => {
    if (!filteredMandalTabScores || filteredMandalTabScores.length === 0) return [];

    return filteredMandalTabScores.filter(
      (item) => gradeFilter[item?.grade] === true
    );
  }, [filteredMandalTabScores, gradeFilter]);

  const MandalTabScoresSorted = React.useMemo(() => {
    let sortableData = [...(gradeFilteredMandalTabScoresSorted || [])];
    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        const valA =
          sortConfig.key === "achievedscore"
            ? a.averagescore
            : sortConfig.key === "achievedgrade"
              ? gradeRank(a.grade)
              : sortConfig.key === "noofindicators"
                ? Number(a.noofindicators) :
                sortConfig.key === "target" ? a.target : sortConfig.key === "achivementvalue" ? a.achivementvalue
                  : sortConfig.key === "mandal_name"
                    ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? a.ulb_name : a.mandal_name
                    : a.district_name;

        const valB =
          sortConfig.key === "achievedscore"
            ? b.averagescore
            : sortConfig.key === "achievedgrade"
              ? gradeRank(b.grade)
              : sortConfig.key === "noofindicators"
                ? Number(b.noofindicators) :
                sortConfig.key === "target" ? b.target : sortConfig.key === "achivementvalue" ? b.achivementvalue
                  : sortConfig.key === "mandal_name"
                    ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? b.ulb_name : b.mandal_name
                    : b.district_name;


        if (valA === null || valA === undefined) return 1; if (valB === null || valB === undefined) return -1; if (sortConfig.key === "achievedscore") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }
        if (sortConfig.key === "target") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }
        if (sortConfig.key === "achivementvalue") { return sortConfig.direction === "asc" ? valA - valB : valB - valA; }

        if (sortConfig.key === "achievedgrade") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }
        if (sortConfig.key === "noofindicators") {
          return sortConfig.direction === "asc" ?
            valA - valB : valB - valA;
        }
        if (sortConfig.key === "mandal_name") {
          return sortConfig.direction === "asc" ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
        } if (sortConfig.key === "district_name") {
          return sortConfig.direction === "asc" ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        } return 0;
      });
    }
    return sortableData;
  }, [gradeFilteredMandalTabScoresSorted, sortConfig]);

  // Sorted array for modal mandal chart (comes from `mandalScores` object)
  const sortedModalMandalScores = React.useMemo(() => {
    const arr = Object.entries(mandalScores || {}).map(([name, values]) => ({
      name,
      avg: values.avg ?? values.averagescore ?? values.score,
      grade: values.grade,
      indicators: values.indicators ?? values.noofindicators,
      color: values.color || values.color_code || "#dcdcdc",
    }));

    if (!sortConfig.key) return arr;

    const sorted = [...arr];
    sorted.sort((a, b) => {
      let valA, valB;
      if (sortConfig.key === "achievedscore") { valA = Number(a.avg); valB = Number(b.avg); }
      else if (sortConfig.key === "achievedgrade") { valA = gradeRank(a.grade); valB = gradeRank(b.grade); }
      else if (sortConfig.key === "noofindicators") { valA = Number(a.indicators); valB = Number(b.indicators); }
      else if (sortConfig.key === "mandal_name") { valA = a.name; valB = b.name; }
      else { valA = a.name; valB = b.name; }

      if (valA == null) return 1; if (valB == null) return -1;
      if (typeof valA === "string") return sortConfig.direction === "asc" ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    });

    return sorted;
  }, [mandalScores, sortConfig]);



  const filteredIndicatorsMandalData = Indicatormandalsearch.length > 0
    ? dashboardDistrictWiseIndicatorDataScoreslist?.filter((item) => (
      item && Object.keys(item).some((key) => {
        const value = item[key];
        return (value !== null && value.toString().toLowerCase().includes(Indicatormandalsearch.toLowerCase()));
      })
    ))
    : dashboardDistrictWiseIndicatorDataScoreslist;


  const sortedIndicatorsMandalScores = React.useMemo(() => {
    let sortableData = [...(filteredIndicatorsMandalData || [])];

    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        let valA, valB;

        switch (sortConfig.key) {
          case "achievedscore":
            valA = Number(a.achievedscore);
            valB = Number(b.achievedscore);
            break;

          case "grade": {
            const gradeA = activeTab === "Dept" ? a.achievedgrade : a.grade;
            const gradeB = activeTab === "Dept" ? b.achievedgrade : b.grade;
            valA = gradeRank(gradeA); valB = gradeRank(gradeB); break;
          }

          /* ✅ TARGET SORTING */
          case "target":
          case "target_value":
            valA = Number(a[sortConfig.key] ?? 0); valB = Number(b[sortConfig.key] ?? 0); break;

          /* ✅ ACHIEVEMENT SORTING */
          case "achivementvalue":
          case "achieved_value":
            valA = Number(a[sortConfig.key] ?? 0); valB = Number(b[sortConfig.key] ?? 0); break;

          case "noofindicators":
            valA = Number(a.noofindicators); valB = Number(b.noofindicators); break;

          case "mandal_name":
            valA = a.mandal_name ?? ""; valB = b.mandal_name ?? ""; break;

          default: return 0;
        }
        // null / undefined handling
        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;
        // string vs number sort
        if (typeof valA === "string" && typeof valB === "string") {
          return sortConfig.direction === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
        }
        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      });
    }

    return sortableData;
  }, [filteredIndicatorsMandalData, sortConfig, activeTab]);
  const isDrillActive = Deptenb && drillDepartments.length > 0;

  const deptTableData = isDrillActive ? drillDepartments : departments;
  const deptRawList = isDrillActive ? drillDepartmentsList : departmentslist;


  const filteredDeptData = React.useMemo(() => {
    if (!deptsearch.trim()) return deptTableData || [];

    const searchText = deptsearch.toLowerCase();

    return (deptTableData || []).filter((item) => {
      if (!item || typeof item !== "object") return false;

      return Object.values(item).some((value) => {
        if (
          value === null ||
          value === undefined ||
          (typeof value !== "string" && typeof value !== "number")
        ) {
          return false;
        }
        return value.toString().toLowerCase().includes(searchText);
      });
    });
  }, [deptsearch, deptTableData]);

  const gradeFilteredDeptData = React.useMemo(() => {
    if (!filteredDeptData || filteredDeptData.length === 0) return [];

    return filteredDeptData.filter((dept) =>
      gradeFilter[dept?.grade] === true
    );
  }, [filteredDeptData, gradeFilter]);


  const sortedDeptScores = React.useMemo(() => {
    let sortableData = [...gradeFilteredDeptData];

    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        const valA =
          sortConfig.key === "averagescore"
            ? a.averagescore
            : sortConfig.key === "grade"
              ? gradeRank(a.grade)
              : sortConfig.key === "noofindicators"
                ? Number(a.noofindicators)
                : a.dept_name;

        const valB =
          sortConfig.key === "averagescore"
            ? b.averagescore
            : sortConfig.key === "grade"
              ? gradeRank(b.grade)
              : sortConfig.key === "noofindicators"
                ? Number(b.noofindicators)
                : b.dept_name;

        if (valA == null) return 1;
        if (valB == null) return -1;

        if (sortConfig.key === "dept_name") {
          return sortConfig.direction === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }

        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      });
    }

    return sortableData;
  }, [gradeFilteredDeptData, sortConfig]);


  const renderStatusRing = (score, maxScore = 100, size = 40, strokeWidth = 6) => {

    let parsedScore = parseFloat(score);
    if (isNaN(parsedScore) || parsedScore < 0) {
      parsedScore = 0;
    }

    const normalizedScore = Math.min(parsedScore, maxScore);
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const progress = (normalizedScore / maxScore) * circumference;
    const ringColor = getRingColor(normalizedScore);

    return (
      <svg width={size} height={size} style={{ display: "block" }}>
        <circle stroke="#e6e6e6" fill="transparent" strokeWidth={strokeWidth} r={radius} cx={size / 2} cy={size / 2} />
        <circle stroke={ringColor} fill="transparent" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference - progress} strokeLinecap="round" r={radius} cx={size / 2} cy={size / 2} />
        <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#333" fontWeight="bold" fontSize={size / 4.3} >
          {normalizedScore}
        </text>
      </svg>
    );
  };

  const deptIconPrefixes = {
    AGC: "/../images/KeyIcons/key-agriculture.png",
    AHF: "/../images/KeyIcons/key-animal.png",
    BCW: "/../images/KeyIcons/key-backward.png",
    EFS: "/../images/KeyIcons/key-environment.png",
    ENE: "/../images/KeyIcons/key-energy.png",
    EHE: "/../images/KeyIcons/key-higher-education.png",
    ESE: "/../images/KeyIcons/key-secondary-education.png",
    FCS: "/../images/KeyIcons/key-food-civil.png",
    FIN: "/../images/KeyIcons/key-finance.png",
    HMF: "/../images/KeyIcons/key-health-medical.png",
    GAD: "/home.png",
    HOM: "/../images/KeyIcons/key-home-secretariat.png",
    HOU: "/../images/KeyIcons/key-housing-secretariat.png",
    ICD: "/../images/KeyIcons/key-water-resources.png",
    INC: "/../images/KeyIcons/key-industries-commerce.png",
    INI: "/../images/KeyIcons/key-infra-investment.png",
    ITC: "/../images/KeyIcons/key-information-technology-electronics.png",
    LAE: "/../images/KeyIcons/key-labour-employment.png",
    LAW: "/Labour.png",
    MAU: "/../images/KeyIcons/key-municipal-urban-development.png",
    MNW: "/../images/KeyIcons/key-minorities-welfare.png",
    PLG: "/../images/KeyIcons/key-planning-secretariat.png",
    PRR: "/../images/KeyIcons/key-panchayat-raj.png",
    REV: "/../images/KeyIcons/key-revenue.png",
    SEI: "/../images/KeyIcons/key-skill-development.png",
    SOW: "/../images/KeyIcons/key-social-welfare.png",
    TBW: "/../images/KeyIcons/key-tribal-welfare.png",
    TRB: "/../images/KeyIcons/key-transport-roads.png",
    WDC: "/../images/KeyIcons/key-women-children-senior.png",
    YTC: "/../images/KeyIcons/key-youth-sports.png",
  };




  const formatDistrictFileName = (name) => {
    if (!name) return { original: "", upper: "", capitalized: "" };

    const cleaned = name.trim().replace(/\s+/g, "_").replace(/[^\w\-]/g, "");
    // Capitalize each word separated by underscore
    const capitalized = cleaned
      .toLowerCase()
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join("_");

    return {
      original: cleaned,        // as it comes
      upper: cleaned.toUpperCase(), // FULL CAPS
      capitalized,              // Capitalize each part
    };
  };


  const getColor = (score) => {
    const num = Number(score);
    if (!isNaN(num)) {
      if (num >= 90) return "#9ED286";
      if (num >= 75 && num < 90) return "#FFCD1E";
      if (num >= 50 && num < 75) return "#3DD9FF";
      if (num < 50) return "#FF6E74";
    }
    return "#dcdcdc";
  };

  const getGradeColor = (grade) => {
    switch ((grade || "").toString().trim()) {
      case "A+": return "#9ED286";
      case "A": return "#FFCD1E";
      case "B": return "#3DD9FF";
      case "C": return "#FF6E74";
      default: return "#dcdcdc";
    }
  };
  const getRingColor = (num) => {
    if (num >= 90 && num <= 100) return "#9ED286";
    if (num >= 75 && num < 90) return "#FFCD1E";
    if (num >= 50 && num < 75) return "#3DD9FF";
    if (num >= 0 && num < 50) return "#FF6E74";
    return "#dcdcdc";
  };
  const [currentdate, setcurrentdate] = useState(''); const [currenttime, setcurrenttime] = useState('');
  useEffect(() => { datetime(setcurrentdate, setcurrenttime); }, []);
  useEffect(() => {
    
    if (!departments || departments.length === 0) return;
    setDepartments([...departments]); // force re-render
  }, [clickType]);

  const [inddistenb, setinddistenb] = useState(false);
  const BackFunct = () => {
    setinddistenb(false);
    DisttabNoofIndicators(
      "Indicator", "District",
      clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
      (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
      selectedDistrict === null ? "0" : selectedDistrictId,
      "0",
      selectedind?.indicatorid, selectedind?.sec_id, selectedind
    );


  }
  const [selectedind, setselectedind] = useState();
  const DisttabNoofIndicators = (type, typedrill, sec, dept, dist, mandal, indicatorid, sec_id, detail) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    let depart = ["111", "113", "114"].includes(role_cat_id) ? deptid : ulbdept

    const isUlb = mandal?.toString().length === 6;

    let params = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      type: type,
      typeDrill: isUlb ? "ULB" : typedrill,
      userId: username,
      year: formik.values.year,

      secId: (["114", "115", "113", "111"].includes(role_cat_id))
        ? localStorage.getItem("secretariat_code")
        : sec,

      deptId: (["114", "113", "111"].includes(role_cat_id))
        ? deptid
        : dept,

      districtId: dist,

      mandalId:
        (activeTab === "Indicator" || activeTab === "Mandal" || activeTab === "District")
          ? (isUlb ? "0" : mandal)
          : (["111", "117"].includes(role_cat_id) ? mandalid : mandal),

      indicatorId: indicatorid ?? "0",

      ...(activeTab === "Indicator" || activeTab === "Mandal" || activeTab === "District")
        ? { ulbId: isUlb ? mandal : "0" }
        : {}
    };
    setulbdept((["114", "113", "111"].includes(role_cat_id)) ? deptid : dept);
    const isULB = mandal && String(mandal).length === 6;
    let params5 = {
      userId: username,
      year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      // typeDrill: activeTab !== "Indicator" ? (isULB ? "ULB" : typedrill) : "Indicator",
      typeDrill: isULB ? "ULB" : typedrill,
      // type: clickType === "district" ? "hod" : clickType === "hod" ? "sec" : "const",
      type: role_cat_id === "112" && (!mandal || activeTab === "Indicator") ? "constInd" : clickType === "district" ? "hod" : clickType === "hod" ? "sec" : "const",

      // type: clickType === "district" ? "hod" : clickType === "hod" ? (role_cat_id === "112" && !mandal ? "constInd" : "sec") : "const",
      districtId: dist,
      constId: role_cat_id === "116" ? String(detail.accode) : assemblyid,
      // mandalId: mandal,
      mandalId: typedrill === "District" ? "0" : (isULB ? "0" : mandal),
      ulbId: isULB ? mandal : "0",
      secId: clickType === "hod" ? "0" : selectedsec,
      deptId: clickType === "" ? selecteddept : "0",
      "indicatorId": activeTab === "Indicator" ? indicatorid : "0",
    };

    const serviceCall = role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const") ? KpiService.dashboardIndicatorDrillDownConstituencyWise(params5)
      : KpiService.dashboardDistrictWiseIndicatorData(params);
    store.dispatch({ type: "SHOW_SPINNER" });
    serviceCall.then((res) => {
      setShow(false); setIndicatormodal(true);
      if (res.data?.SCODE === "02") { setdashboardDistrictWiseIndicatorDataScoreslist([]); }
      else if (res.data && res.data.dataList) { setdashboardDistrictWiseIndicatorDataScoreslist(res.data.dataList); }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })
  }

  const getColSpan = () => {
    let count = 0;

    count += 1; // S.No
    count += 1; // Secretariat Department
    count += 1; // HOD Name
    count += 1; // KPI
    count += 1; // Unit
    count += 1; // Periodicity
    count += 1; // Entry Level
    count += 1; // Time fraction
    count += 1; // Indicator nature
    count += 1; // Target
    count += 1; // Achievement
    count += 1; // Score
    count += 1; // Grade

    // Conditional columns
    if (activeTab === "Indicator") {
      count += 1; // District Name
      if (inddistenb) count += 1; // Mandal Name
    }

    return count;
  };

  const DistrictDrilDown = async (districtname, districtid) => {
    if (role_cat_id === "112") { return }
    resetDrillToSecretariat(); resetPeriodicityFilter(); resetGradeFilter();
    // prevent role 112 from triggering a drill change or forcing the Indicator tab
    setActiveTab("Indicator");
    setIndicatorenb(true);

    secretariatgradedata(clickType === "hod" ? "0" : selectedsec, districtid, selectedMandal ? selectedmandalcode : "0");
    setselectedmap("districtmap");
    setBackclickMap(true);

    formik.setFieldValue("district_id", districtid);
    districtMap(districtname, districtid);
    let param1 = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year, type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district",
      secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", districtId: districtid, mandalId: "0", ulbId: "0",
      typeDrill: "District",

    };
    let param = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year, type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district",
      secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", districtId: districtid, mandalId: "0", ulbId: "0",
      typeDrill: "District",

    };

    const params = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year,
      type: clickType === "hod" ? "mapSec" : clickType === "district" ? "mapHod" : "mapDistrict",
      secId: clickType === "hod" ? "0" : selectedsec,
      deptId: clickType === "" ? selecteddept : "0", districtId: districtid, mandalId: "0", ulbId: "0"
    };
    let MandalWiseparams = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year, secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0",
      districtId: districtid, mandalId: "0", ulbId: "0"
    }
    store.dispatch({ type: "SHOW_SPINNER" }); KpiService.dashboardKpiData(param1).then((res) => {
      if (res.data) {
        const updatedData = groupIndicators(res.data?.dataList);
        setdashboardKpiData(updatedData); setdashboardMonthData(res.data?.dataList?.[0]);
      }
    }).catch(() => { }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.dashboardKpiScoresGardes(param).then((res) => {
      if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]); }
      else if (res.data && res.data.dataList) {
        const apiDepartments = res.data.dataList.map((item) => ({
          deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
          dept_id: clickType === "hod" ? item.secid : item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
          secId: item.secid, sec_short_name: item.sec_short_name, secretariat_code: item.secretariat_code || "",
          averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
        })); setDepartments(apiDepartments); setdepartmentslist(res.data.dataList);
      }
    }).catch(() => { setDepartments([]); setdepartmentslist([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    if (role_cat_id === "116") { const service = KpiService.dashboardKpiScoresGardes(param);
      store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
        if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
        else if (res.data && res.data.dataList) {
          const apiDepartments = res.data.dataList.map((item) => ({
            deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
            dept_id: item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
            secid: clickType === "hod" ? item.secid : item.secretariat_code,
            secretariat_code: clickType === "hod" ? item.secid : item.secretariat_code,
            sec_short_name: item.sec_short_name, averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
          })); setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);
        } }).catch(() => { setDrillDepartments([]); setDrillDepartmentsList([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }

    store.dispatch({ type: "SHOW_SPINNER" }); KpiService.dashboardKpiScoresGardes(params).then((res) => {
      if (res.data) { const scores = {};
        if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);; }
        else { setnodistdata(false); res.data.dataList?.forEach((item) => {
            const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase(); const isNoData = item.SCODE === "02"
            scores[districtName] = {
              avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
              color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
            }; }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores); } }
    }).catch(() => { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.dashboardMandalWiseIndicatorDataTab(MandalWiseparams).then((res) => {
      if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setmandalTabScores({}); setMandalalert(true); }
      if (res.data && res.data.dataList) {
        const scores = {}; setMandalalert(false);
        const mandalData = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01") ? res.data.dataList?.filter(item => item.type === "ULB") : res.data.dataList?.filter(item => item.type === "MANDAL");

        mandalData.forEach((item) => {
          const mandalname = item.mandal_name?.trim().toUpperCase(); const isNoData = item.SCODE === "02"
          scores[mandalname] = {
            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
          };
        }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList);
      }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    if (role_cat_id === "116") {
      let params = {
        scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
        "userId": username, "year": formik.values.year, "type": "main", "districtId": districtid,
        secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", "constId": "0",
      }
      store.dispatch({ type: "SHOW_SPINNER" }); const AdminConststats = KpiService.DashboardAdminDataConstituencyWise(params)
      AdminConststats.then((res) => { if (res.data) { const scores = {};
          if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }
          else { setnodistdata(false); res.data.dataList?.forEach((item) => {
              const districtName = item.acname?.trim().toUpperCase(); const isNoData = item.SCODE === "02"
              scores[districtName] = { avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
              }; }); setConstScoreslist(res.data.dataList); setConstScores(scores); } }
      }).catch(() => { setConstScoreslist([]); setConstScores({}); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    } }

  const [selectedmandalcode, setselectedmandalcode] = useState();
  const MandalDrillDown = async (mandalname, district, district_id, assemblyName, assemblyCode) => {
    if (role_cat_id === "112") { return }
    resetDrillToSecretariat(); resetPeriodicityFilter(); resetGradeFilter();
    if (selectedmandalcode) { return }
    // for certain roles we shouldn't change the active tab or perform a drill
    if (role_cat_id === "117" || role_cat_id === "111") { return; }
    setActiveTab("Indicator");
    setIndicatorenb(true);
    setselectedmap("mandalmap");
    setActiveTab("Mandal"); setDistenb(false); setMandalenb(true); setIndicatorenb(false); setDeptenb(false);

    let params66 = { userId: username, mandalName: mandalname };
    const respo = await KpiService.MandalCodeFromMandalName(params66);
    const mandalCode = respo?.data?.dataList && respo.data.dataList.length > 0
      ? respo.data.dataList[0]?.mandal_code
      : (respo?.data?.mandal_code || respo?.data?.mandalCode || null);

    if (!mandalCode) {
      console.error("Mandal code not found in response", respo);
      // Avoid proceeding if we can't determine mandal code to prevent runtime errors
      store.dispatch({ type: "HIDE_SPINNER" });
      return;
    }

    setselectedmandalcode(mandalCode);
    mandalMap(mandalname, district, district_id, mandalCode, assemblyName, assemblyCode);
    secretariatgradedata(clickType === "hod" ? "0" : selectedsec, selectedDistrictId, mandalCode);

    setBackclickMap(true);

    store.dispatch({ type: "SHOW_SPINNER" });
    formik.setFieldValue("district_id", districtid);
    let param1 = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year,
      type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district", secId: clickType === "hod" ? "0" : selectedsec,
      deptId: clickType === "" ? selecteddept : "0", districtId: selectedDistrictId, mandalId: mandalCode, ulbId: "0",
      typeDrill: "Mandal"
    };
    let param = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year,
      type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district", secId: clickType === "hod" ? "0" : selectedsec,
      deptId: clickType === "" ? selecteddept : "0", districtId: selectedDistrictId, mandalId: mandalCode, ulbId: "0",
      typeDrill: "Mandal"

    };
    const params = {
      scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      userId: username, year: formik.values.year,
      type: clickType === "hod" ? "mapSec" : clickType === "district" ? "mapHod" : "mapDistrict",
      secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", districtId: selectedDistrictId, mandalId: mandalCode, ulbId: "0"
    };
    if (role_cat_id === "115" || role_cat_id === "114") {
      params.type = "mapHod";

    }
    let MandalWiseparams = {
      userId: username, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      year: formik.values.year, secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", districtId: selectedDistrictId, mandalId: mandalCode, ulbId: "0"
    }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.dashboardKpiData(param1).then((res) => {
      if (res.data) {
        const updatedData = groupIndicators(res.data?.dataList);
        setdashboardKpiData(updatedData); setdashboardMonthData(res.data?.dataList?.[0]);
      }
    }).catch(() => { }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.dashboardKpiScoresGardes(param).then((res) => {
      if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]);; }
      else if (res.data && res.data.dataList) {
        const apiDepartments = res.data.dataList.map((item) => ({
          deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
          dept_id: clickType === "hod" ? item.secid : item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
          secId: item.secid, sec_short_name: item.sec_short_name, secretariat_code: item.secretariat_code || "",
          averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
        })); setDepartments(apiDepartments); setdepartmentslist(res.data.dataList);

      }
    }).catch(() => {
      setDepartments([]); setdepartmentslist([]);
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    if (role_cat_id === "116") {
      const service = KpiService.dashboardKpiScoresGardes(param); store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
        if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
        else if (res.data && res.data.dataList) { const apiDepartments = res.data.dataList.map((item) => ({
            deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
            dept_id: item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
            secid: clickType === "hod" ? item.secid : item.secretariat_code,
            secretariat_code: clickType === "hod" ? item.secid : item.secretariat_code,
            sec_short_name: item.sec_short_name, averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
          })); setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);
        } }).catch(() => { setDrillDepartments([]); setDrillDepartmentsList([]);
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }
    store.dispatch({ type: "SHOW_SPINNER" }); KpiService.dashboardKpiScoresGardes(params).then((res) => {
      if (res.data) { const scores = {};
        if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);; }
        else { setnodistdata(false); res.data.dataList?.forEach((item) => {
            const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase(); const isNoData = item.SCODE === "02"
            scores[districtName] = {
              avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
              color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
            }; }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores); } }
    }).catch(() => { setDepartments([]); setdepartmentslist([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.dashboardMandalWiseIndicatorDataTab(MandalWiseparams).then((res) => {
      if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setmandalTabScores({}); setMandalalert(true); }
      if (res.data && res.data.dataList) { const scores = {}; setMandalalert(false);
        const mandalData = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01") ? res.data.dataList?.filter(item => item.type === "ULB") : res.data.dataList?.filter(item => item.type === "MANDAL");
        mandalData.forEach((item) => {
          const mandalname = item.mandal_name?.trim().toUpperCase();
          const isNoData = item.SCODE === "02"; const color = isNoData ? "#ccc" : (item.color_code || "#ccc");
          scores[mandalname] = { avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
            color: color, indicators: isNoData ? 0 : item.noofindicators,
          }; }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList);
      } }).catch(() => { setmandalTabScoreslist([]); setmandalTabScores({}) }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); };

  const getECOFileName = (type = "xlsx") => { return `${getECOBaseName()}_${getReadableTimeStamp()}.${type}`; };
  // const getECOBaseName = () => {
  //   if (clickType === "hod") { return "Key Performance Indicators (KPIs)"; } if (clickType === "district") {
  //     return ["116", "115", "119", "112"].includes(role_cat_id) ? `${parentDept?.deptcode} - ${parentDept?.dept_name} (KPIs)` : `${SectariatcodeName} (KPIs)`;
  //   }
  //   if (clickType === "") { return ["114", "113", "111", "117"].includes(role_cat_id) ? `${deptcodeName} (KPIs)` : `${departments?.[0]?.deptcode} - ${departments?.[0]?.dept_name} (KPIs)`; }
  //   return "KPIs";
  // };
  const getECOBaseName = () => {
    const locationPrefix = [
      selectedDistrict
        ? `${selectedDistrict} (District)`
        : "",

      selectedMandal
        ? `${selectedMandal} (Mandal)`
        : ""
    ]
      .filter(Boolean)
      .join(" - ");

    const addPrefix = (name) =>
      locationPrefix
        ? `${locationPrefix} - ${name}`
        : name;

    if (clickType === "hod") {
      return addPrefix("Key Performance Indicators (KPIs)");
    }

    if (clickType === "district") {
      return addPrefix(
        ["116", "115", "119", "112"].includes(role_cat_id)
          ? `${parentDept?.deptcode} - ${parentDept?.dept_name} (KPIs)`
          : `${SectariatcodeName} (KPIs)`
      );
    }

    if (clickType === "") {
      return addPrefix(
        ["114", "113", "111", "117"].includes(role_cat_id)
          ? `${deptcodeName} (KPIs)`
          : `${departments?.[0]?.deptcode} - ${departments?.[0]?.dept_name} (KPIs)`
      );
    }

    return addPrefix("KPIs");
  };

  const handleAllDepartmentsExcel = () => {
    const allRows = [];
    const filteredData = getFinalFilteredSDGData();

    filteredData?.forEach((sec) => {
      sec?.departments?.forEach((dept) => {
        dept?.indicators?.forEach((rec) => {
          allRows.push({
            Section: sec?.secname, Department: dept?.departmentName, KPI: rec?.indicatorname, Unit: rec?.unitname,
            Periodicity: rec?.periodic_name, "Entry Level": rec?.kpi_entry_level, "Time Fraction": rec?.time_fraction, "Indicator Nature": rec?.indicatornature, "Target ": rec?.target, Achievement: rec?.achivementvalue, Score: rec?.achievedscore, Grade: rec?.achievedgrade,
          });
        });
      });
    });

    if (allRows.length === 0) {
      const worksheet = XLSX.utils.aoa_to_sheet([
        ["No data available for selected filters"]
      ]);

      worksheet["A1"].s = { font: { bold: true }, alignment: { horizontal: "center" } };
      worksheet["!cols"] = [{ wch: 45 }];

      const workbook = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(workbook, worksheet, "Message"); XLSX.writeFile(workbook, getECOFileName("xlsx")); return;
    }
    const worksheet = XLSX.utils.json_to_sheet(allRows);
    Object.keys(worksheet).filter(cell => cell.endsWith("1"))
      .forEach(cell => worksheet[cell] && (worksheet[cell].s = { font: { bold: true } }));
    Object.keys(worksheet).forEach(cell => {
      if (cell.startsWith("A") && worksheet[cell]) { worksheet[cell].s = { font: { bold: true } }; }
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All KPIs");
    XLSX.writeFile(workbook, getECOFileName("xlsx"));
  };

  const handleAllDepartmentsPDF = () => {
    const doc = new jsPDF("p", "pt", "a4"); const rows = []; const filteredData = getFinalFilteredSDGData();
    if (!filteredData || filteredData.length === 0) {
      doc.setFontSize(14);
      doc.text("No data available for selected filters", 40, 50); doc.save(getECOFileName("pdf")); return;
    }
    let slNo = 1;
    filteredData.forEach((sec) => {
      sec?.departments?.forEach((dept) => {
        dept?.indicators?.forEach((rec) => {
          rows.push([
            slNo++,
            sec?.secname,
            dept?.departmentName,
            rec?.indicatorname,
            rec?.unitname,
            rec?.periodic_name,
            rec?.kpi_entry_level,
            rec?.time_fraction,
            rec?.indicatornature,
            rec?.target,
            rec?.achivementvalue,
            rec?.achievedscore,
            rec?.achievedgrade,
          ]);
        });
      });
    });

    const title = getECOBaseName();

    doc.setFontSize(14);
    doc.text(title, 40, 30);

    doc.autoTable({
      head: [[
        "Sl.No",
        "Section",
        "Department",
        "KPI",
        "Unit",
        "Periodicity",
        "Entry Level",
        "Time Fraction",
        "Indicator Nature",
        "Target ",
        "Achievement",
        "Score",
        "Grade",
      ]],
      body: rows,
      startY: 50,
      theme: "grid",
      headStyles: {
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      styles: { fontSize: 8, cellPadding: 3 },
      columnStyles: { 0: { fontStyle: "bold" }, 1: { fontStyle: "bold" } },
    });

    doc.save(getECOFileName("pdf"));
  };

  let deptCounter = 0;

  const resetDrillToSecretariat = () => {
    if (drillType === "hod") {
      setDrillType("sec");
      formik.setFieldValue("drilldown", "0"); // set dropdown to Secretariat
    }
  };

  const handleDrillDownChangenew = async (value) => {
    // Update drill type dynamically

    let params = {
      userId: username,
      year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      type: "hod",
      districtId: selectedDistrictId ?? "0",
      secId: clickType === "hod" ? "0" : selectedsec ?? "0",
      deptId: clickType === "" ? selecteddept : "0",
      mandalId: selectedmandalcode ?? "0",
      ulbId: "0",
      typeDrill: selectedMandal !== null ? "Mandal" : selectedDistrict !== null ? "District" : "Sec"

    };
    let params1 = {
      userId: username, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
      year: formik.values.year,
      type: clickType === "hod" ? "sec" : (clickType === "district" ? "hod" : "district"),
      districtId: selectedDistrictId ?? "0",
      secId: clickType === "hod" ? "0" : selectedsec ?? "0",
      deptId: clickType === "" ? selecteddept : "0",
      mandalId: selectedmandalcode ?? "0",
      ulbId: "0",
      typeDrill: selectedMandal !== null ? "Mandal" : selectedDistrict !== null ? "District" : clickType === "hod" ? "Sec" : "hod"
    };


    store.dispatch({ type: "SHOW_SPINNER" });

    try {
      let res;
      if (value === "1") { res = await KpiService.dashboardKpiScoresHodGrades(params); }
      else { res = await KpiService.dashboardKpiScoresGardes(params1); }
      if (res?.data?.SCODE === "02") {
        setDrillDepartments([]);
        setDrillDepartmentsList([]);
      }

      else if (res.data && res.data.dataList) {
        const apiDepartments = res.data.dataList.map((item) => ({
          deptcode: item.deptcode?.trim().toUpperCase(),
          dept_id: (value === "0" && clickType === "hod") ? item.secid : item.dept_id,
          dept_name: value === "0" ? item.sec_name || item.dept_name : item.dept_name,
          secid: (value === "0" && (clickType === "district" || clickType === "")) ? item.secretariat_code : item.secid,
          sec_short_name: item.sec_short_name,
          secretariat_code: item.secretariat_code || "",
          averagescore: item.averagescore,
          grade: item.grade,
          noofindicators: item.noofindicators,
          assembly_name: item.assembly_name,
          accode: item.accode,
          district_id: item.district_id,
        }));

        setDrillDepartments(apiDepartments);
        setDrillDepartmentsList(res.data.dataList);
      }

    } catch (err) {
      console.error("Drilldown API Error:", err);
      setDrillDepartments([]);
      setDrillDepartmentsList([]);

    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const BAR_HEIGHT = 32;
  const MIN_CHART_HEIGHT = 160;
  const chartHeight = Math.max(
    sortedDeptScores.length * BAR_HEIGHT,
    MIN_CHART_HEIGHT
  );



  useEffect(() => {
    setActiveDept(null);
  }, [periodicityFilter.monthlyLowScore, periodicityFilter.quarterlyLowScore]);

  return (
    <>
      <Menubar />
      <Container fluid className="outer-page-content-container new-mapdash">
        <div className="map-header">
          <div className='persa-title d-flex justify-content-between'> <h2>Performance<span> Dashboard </span></h2>


            <h3
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px", // space between icon and text
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >

              {/* Blinking Icon */}
              <FaRegHandPointRight
                style={{
                  color: "red",
                  animation: "blink 1s step-start infinite",
                }}
              />

              {/* Normal Text */}
              <h6>
                <span style={{
                  color: "green"
                }}> Scores – Generated upto </span>
                {apiMonthValue
                  ? [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ][Number(apiMonthValue) - 1]
                  : ""}{" "}
                Month
              </h6>

              {/* Keyframes for blinking */}
              <style>
                {`
      @keyframes blink {
        50% { opacity: 0; }
      }
    `}
              </style>
            </h3>

          </div>


        </div>

        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className="container-fluid">
              <div className="row align-items-center g-3">

                {/* Legend */}
                {/* <div className="col-12 col-lg-12 col-md-12 col-xl-8 col-xxl-8 col-sm-12 col-xs-12"> */}
                <div className="col-12 col-lg-12 col-md-12 col-xl-8 col-xxl-8 col-sm-12 col-xs-12">
                  <div className="row  color-header">
                    <div className="col-md-6 col-lg-3 px-0">
                      <div className="category">
                        <div className="round poor"></div>
                        <h5 className="category-spe mb-0">Aspirant (C) &lt;50%</h5>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3 px-0">
                      <div className="category">
                        <div className="round moderate"></div>
                        <h5 className="category-spe mb-0">Performer (B) 50% – 74%</h5>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3 px-0">
                      <div className="category">
                        <div className="round good"></div>
                        <h5 className="category-spe mb-0">Front Runner (A) 75% – 89%</h5>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3 px-0">
                      <div className="category">
                        <div className="round excel"></div>
                        <h5 className="category-spe mb-0">Achiever (A+) 90% – 100%</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-12 col-md-12 col-xl-12 col-xxl-12 col-sm-12 col-xs-12">
                  <div className="row g-2 align-items-center">


                    {(
                      (clickType === "hod" && role_cat_id === "116") ||
                      (clickType === "district" && role_cat_id === "115") ||
                      (clickType === "" && role_cat_id === "114") ||
                      (clickType === "hod" && role_cat_id === "119") ||
                      (clickType === "" && role_cat_id === "111") ||
                      (clickType === "" && role_cat_id === "113") ||
                      (clickType === "hod" && role_cat_id === "117") ||
                      (clickType === "hod" && role_cat_id === "112")
                    ) && (
                        <>
                          <div className="col-12">
                            <div className="row g-2 align-items-end sdg-dash">

                              {/* Score Category */}
                              <div className="col-12 col-md-2">
                                <label className="mb-0">Score-Cat <span style={{ color: "red" }}>*</span></label>
                                <Field className="form-select" component="select" name="scoreCatId" >
                                  <option value="Monthly">Monthly</option>
                                  <option value="Provisionally">Provisional</option>
                                  <option value="Annually">Annual</option>
                                </Field>
                              </div>

                              {/* Year */}
                              <div className="col-12 col-md-2">
                                <label className="mb-0">Year <span style={{ color: "red" }}>*</span></label>
                                {/* <Field className="form-select" component="select" name="year" > */}
                                <Field
                                  className="form-select"
                                  component="select"
                                  name="year"
                                  onChange={(e) => {
                                    formik.setFieldValue("scoreForMonth", "");
                                    formik.setFieldValue("year", e.target.value);
                                  }}
                                >
                                  <option value="">--select--</option>
                                  <option value="2025-26">2025-26</option>
                                  <option value="2026-27">2026-27</option>
                                </Field>
                              </div>

                              {/* Month */}
                              {formik.values.scoreCatId === "Monthly" && (
                                <div className="col-12 col-md-2">
                                  <label className="mb-0">Month <span style={{ color: "red" }}>*</span></label>
                                  <Field
                                    as="select"
                                    className="form-select"
                                    name="scoreForMonth"
                                    value={formik.values.scoreForMonth}
                                    onChange={(e) => { setSearchTerm(""); formik.setFieldValue("scoreForMonth", e.target.value) }}
                                  >
                                    {months?.length === 0 && (
                                      <option value="0">{monthsErrorMessage || "Select"}</option>
                                    )}
                                    {months?.map((m) => {
                                      const value = (m.month_code || m.monthCode || m.code)?.toString();
                                      return (
                                        <option key={value} value={value}>
                                          {m.month_name}
                                        </option>
                                      );
                                    })}
                                  </Field>
                                </div>
                              )}


                              {/* Search */}
                              <div className="col-12 col-md-2 ms-md-auto">
                                <label className="mb-0">Search</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search Department..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                />
                              </div>

                            </div>
                          </div>
                        </>
                      )}


                    {/* Back Button */}

                    <div className="col-12 col-md-2 ms-md-auto mb-1">
                      {Backclick && (<>
                        <button
                          type="button"
                          className="btn btn-warning float-end"
                          onClick={() => {
                            resetDrillToSecretariat(); resetPeriodicityFilter(); resetGradeFilter();
                            setDeptenb(false); setActiveTab("Indicator"); setDistenb(false); setIndicatorenb(true); setMandalenb(false); setConstu(false);
                            setdeptsearch(""); setSearch(""); setdistsearch("");
                            if (departmentHistory.length > 0) {
                              const lastState = departmentHistory[departmentHistory.length - 1]; setDepartments(lastState.departments);
                              setSortConfig({ key: null, direction: "asc" }); setDepartments([]); setdepartmentslist([]);
                              if (clickType === "district") {
                                setselectedsec("")
                                setBackclick(false); setSearchTerm(""); setClickType("hod");
                                if (role_cat_id !== "112") {

                                  mandaltabdata("0", "0", "0");
                                  const params = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    userId: username, year: formik.values.year, type: "mapSec", districtId: selectedDistrict === null ? "0" : selectedDistrictId, secId: "0",
                                    deptId: "0", mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) ||
                                      selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                    ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  };
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  KpiService.dashboardKpiScoresGardes(params).then((res) => {
                                    if (res.data) {
                                      const scores = {};
                                      if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);; } else {
                                        setnodistdata(false);
                                        res.data.dataList?.forEach((item) => {
                                          const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase();
                                          const isNoData = item.SCODE === "02"

                                          scores[districtName] = {
                                            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade, color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                          };
                                        }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores);
                                      }
                                    }
                                  }).catch(() => {
                                    // showAlertMessage("Internal Server Error", "warning", () => {
                                    setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);
                                    // })
                                  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }

                                let params11 = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  userId: username, year: formik.values.year, type: "sec", "secId": "0", "deptId": "0", "districtId": selectedDistrict === null ? "0" : selectedDistrictId, mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                  ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  typeDrill: (["116"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Sec" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "hod"
                                    : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
                                      : (["119", "113"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "District" : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                        : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Mandal"
                                          : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : ""
                                };
                                let params12 = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  userId: username, year: formik.values.year, type: "sec", "secId": "0", "deptId": "0", "districtId": selectedDistrict === null ? "0" : selectedDistrictId, mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                  ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
                                    ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
                                      (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
                                        : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                          : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",
                                }
                                let params44 = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  "userId": username, "year": formik.values.year, "type": "sec",
                                  // "districtId": districtid, 
                                  "constId": assemblyid, secId: "0", deptId: "0",
                                }
                                if (role_cat_id === "112" || role_cat_id === "116") {
                                  let params = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    "userId": username, "year": formik.values.year, "type": "main",
                                    "districtId": selectedDistrictId ?? "0",
                                    "constId": assemblyid, "secId": "0", "deptId": "0",
                                  }
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  const AdminConststats = role_cat_id === "116" ? KpiService.DashboardAdminDataConstituencyWise(params) :
                                    role_cat_id === "112" ? KpiService.dashboardDistrictDataConstituencyWise(params44) : ""
                                  AdminConststats.then((res) => { if (res.data) { const scores = {};
                                      if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }
                                      else { setnodistdata(false); res.data.dataList?.forEach((item) => {
                                          const districtName = item.acname?.trim().toUpperCase(); const isNoData = item.SCODE === "02"
                                          scores[districtName] = { avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                          }; }); setConstScoreslist(res.data.dataList); setConstScores(scores); } }
                                  }).catch(() => { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }
                                if (role_cat_id === "112") {
                                  let params = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    "userId": username, "year": formik.values.year, "type": "sec",
                                    //  "districtId": districtid, 
                                    districtId: "0", "constId": assemblyid, "secId": "0", "deptId": "0",
                                    mandalId: selectedMandal !== null ? selectedmandalcode : "0",
                                  }
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  KpiService.dashboardMandalDataConstituencyWise(params).then((res) => {
                                    if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setmandalTabScores({}); setMandalalert(true); }
                                    if (res.data && res.data.dataList) {
                                      const scores = {}; setMandalalert(false);
                                      const mandalData = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01") ? res.data.dataList?.filter(item => item.type === "ULB") : res.data.dataList?.filter(item => item.type === "MANDAL");

                                      mandalData.forEach((item) => {
                                        const mandalname = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01" || username === "MAU01") ? item.ulb_name : item.mandal_name?.trim().toUpperCase();
                                        const isNoData = item.SCODE === "02"; scores[mandalname] = {
                                          avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                          color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                        };
                                      }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList);
                                    }
                                  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }
                                const serviceCall = role_cat_id === "112" ? KpiService.dashboardKpiScoresGardesConstituencyWise(params44) : KpiService.dashboardKpiScoresGardes(params11);
                                store.dispatch({ type: "SHOW_SPINNER" });
                                serviceCall.then((res) => {
                                  if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]); }
                                  else if (res.data && res.data.dataList) {
                                    const apiDepartments = res.data.dataList.map((item) => ({
                                      deptcode: (["116", "119", "117", "112"].includes(role_cat_id)) ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
                                      dept_id: (["116", "119", "117", "112"].includes(role_cat_id)) ? item.secid : item.dept_id,
                                      dept_name: (["116", "119", "117", "112"].includes(role_cat_id)) ? item.sec_name : item.dept_name,
                                      secid: item.secid, sec_short_name: item.sec_short_name,
                                      averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
                                    })); setDepartments(apiDepartments); setdepartmentslist(res.data.dataList);
                                  }

                                }).catch(() => { setDepartments([]); setdepartmentslist([]); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                if (role_cat_id === "116") {
                                  const service = KpiService.dashboardKpiScoresGardes(params11);
                                  store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
                                    if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
                                    else if (res.data && res.data.dataList) {
                                      const apiDepartments = res.data.dataList.map((item) => ({
                                        deptcode: (["116"].includes(role_cat_id)) ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
                                        dept_id: item.dept_id, dept_name: item.sec_name, secid: item.secid,
                                        sec_short_name: item.sec_short_name, averagescore: item.averagescore,
                                        grade: item.grade, noofindicators: item.noofindicators,
                                      }));
                                      setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);

                                    }
                                  }).catch(() => {
                                    setDrillDepartments([]); setDrillDepartmentsList([]);
                                  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }

                                const serviceCallkpidata = (role_cat_id === "112") ? KpiService.dashboardKpiDataConstituencyWise(params44) : KpiService.dashboardKpiData(params12);
                                store.dispatch({ type: "SHOW_SPINNER" });
                                serviceCallkpidata.then((res) => {
                                  if (res.data) {
                                    const updatedData = groupIndicators(res.data?.dataList);
                                    setdashboardKpiData(updatedData)
                                    setdashboardMonthData(res.data?.dataList?.[0]);
                                    setKpiEna(true); sethodEna(true); setSecEna(true);
                                  }
                                }).catch(() => {
                                  // showAlertMessage("Internal Server Error", "warning")
                                }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

                              }
                              else if (clickType === "") {
                                setSearchTerm("");
                                setClickType("district");
                                if (role_cat_id === "115") {
                                  setBackclick(false)
                                }
                                if (role_cat_id !== "112") {
                                  mandaltabdata((["116", "119", "117"].includes(role_cat_id)) ? selectedsec : secretariat_code, "0", "0",)
                                  const paramss = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    userId: username, year: formik.values.year, secId: ["116", "119", "117"].includes(role_cat_id) ? selectedsec : secretariat_code, deptid: "0", type: "mapHod", districtId: selectedDistrict === null ? "0" : selectedDistrictId, mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                    ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  };
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  KpiService.dashboardKpiScoresGardes(paramss).then((res) => {
                                    if (res.data) {
                                      const scores = {};

                                      if (res.data?.SCODE === "02" || res.data?.SCODE == "500") {
                                        setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);
                                      }
                                      else { setnodistdata(false); res.data.dataList?.forEach((item) => {
                                          const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase(); const isNoData = item.SCODE === "02"
                                          scores[districtName] = {
                                            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                          }; }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores); } }
                                  }).catch(() => { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }
                                const params = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  userId: username, year: formik.values.year, type: "hod", secId: ["116", "119", "117"].includes(role_cat_id) ? selectedsec : secretariat_code, "deptId": "0",
                                  "districtId": selectedDistrict === null ? "0" : selectedDistrictId,
                                  mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                  ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  typeDrill: (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "hod" : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                    : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : (["119", "113"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "District"
                                      : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District" : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
                                        : (["111", "117"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Mandal" : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                          : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : ""
                                };
                                const params1 = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  userId: username, year: formik.values.year, type: "hod", secId: ["116", "119", "117"].includes(role_cat_id) ? selectedsec : secretariat_code, "deptId": "0",
                                  "districtId": selectedDistrict === null ? "0" : selectedDistrictId,
                                  mandalId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid : selectedMandal !== null ? selectedmandalcode : "0",
                                  ulbId: ["117", "111"].includes(role_cat_id) ? (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
                                  typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
                                    ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "Mandal" :
                                      (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
                                        : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                          : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : "Sec",
                                }
                                let params44 = {
                                  "userId": username, "year": formik.values.year, "type": "hod",
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  "constId": assemblyid, secId: selectedsec, deptId: "0",
                                }
                                if (role_cat_id === "112" || role_cat_id === "116") {
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  let params = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    "userId": username, "year": formik.values.year, "type": "main",
                                    "districtId": selectedDistrictId ?? "0",
                                    "constId": assemblyid, secId: ["116", "119", "117"].includes(role_cat_id) ? selectedsec : secretariat_code, "deptId": "0",
                                  }
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  const AdminConststats = role_cat_id === "116" ? KpiService.DashboardAdminDataConstituencyWise(params) :
                                    role_cat_id === "112" ? KpiService.dashboardDistrictDataConstituencyWise(params44) : ""
                                  AdminConststats.then((res) => { if (res.data) { const scores = {};
                                      if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }
                                      else { setnodistdata(false); res.data.dataList?.forEach((item) => {
                                          const districtName = item.acname?.trim().toUpperCase(); const isNoData = item.SCODE === "02"
                                          scores[districtName] = {
                                            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                          }; }); setConstScoreslist(res.data.dataList); setConstScores(scores); } }
                                  }).catch(() => { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }
                                if (role_cat_id === "112") {
                                  let params = { "userId": username, "year": formik.values.year, "type": "hod",
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    districtId: "0", "constId": assemblyid, "secId": selectedsec, "deptId": "0",
                                    mandalId: selectedMandal !== null ? selectedmandalcode : "0",
                                  }
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  KpiService.dashboardMandalDataConstituencyWise(params).then((res) => {
                                    if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setmandalTabScores({}); setMandalalert(true); }
                                    if (res.data && res.data.dataList) { const scores = {}; setMandalalert(false);
                                      res.data.dataList?.forEach((item) => {
                                        const mandalname = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? item.ulb_name : item.mandal_name?.trim().toUpperCase();
                                        const isNoData = item.SCODE === "02"
                                        scores[mandalname] = {
                                          avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                          color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
                                          indicators: isNoData ? 0 : item.noofindicators,
                                        }; }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList); }
                                  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }

                                const serviceCall = role_cat_id === "112" ? KpiService.dashboardKpiScoresGardesConstituencyWise(params44) : KpiService.dashboardKpiScoresGardes(params);
                                store.dispatch({ type: "SHOW_SPINNER" });
                                serviceCall.then((res) => {


                                  if (res.data?.SCODE === "02") {
                                    setDepartments([]);
                                    setdepartmentslist([]);;
                                  }
                                  else if (res.data && res.data.dataList) {
                                    const apiDepartments = res.data.dataList.map((item) => ({
                                      deptcode: item.deptcode?.trim().toUpperCase(),
                                      dept_id: item.dept_id,
                                      dept_name: item.dept_name,
                                      secid: item.secid,
                                      sec_short_name: item.sec_short_name,
                                      secretariat_code: item.secretariat_code,
                                      averagescore: item.averagescore,
                                      grade: item.grade,
                                      noofindicators: item.noofindicators,
                                    })); setDepartments(apiDepartments); setdepartmentslist(res.data.dataList);
                                  }

                                }).catch(() => {
                                  setDepartments([]); setdepartmentslist([]);
                                }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

                                if (role_cat_id === "116") {
                                  const service = KpiService.dashboardKpiScoresGardes(params);
                                  store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
                                    if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
                                    else if (res.data && res.data.dataList) {
                                      const apiDepartments = res.data.dataList.map((item) => ({
                                        deptcode: item.deptcode?.trim().toUpperCase(),
                                        dept_id: item.dept_id, dept_name: item.dept_name, secid: item.secretariat_code,
                                        secretariat_code: item.secretariat_code, sec_short_name: item.sec_short_name,
                                        averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
                                      })); setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);
                                    }

                                  }).catch(() => {
                                    setDrillDepartments([]); setDrillDepartmentsList([]);
                                  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }

                                const serviceCallkpidata = (role_cat_id === "112") ? KpiService.dashboardKpiDataConstituencyWise(params44) : KpiService.dashboardKpiData(params1);
                                store.dispatch({ type: "SHOW_SPINNER" });
                                serviceCallkpidata.then((res) => {
                                  if (res.data) {
                                    const updatedData = groupIndicators(res.data?.dataList);
                                    setdashboardKpiData(updatedData)
                                    setdashboardMonthData(res.data?.dataList?.[0]);
                                    setKpiEna(true); sethodEna(true); setSecEna(false);
                                  }
                                }).catch(() => {
                                  // showAlertMessage("Internal Server Error", "warning")
                                }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });


                              }
                            }
                          }}
                        >
                          ← Back
                        </button></>)}
                    </div>
                  </div>
                </div>
                <div className="map-ranks">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>

                      {BackclickMap && (
                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={() => {
                            resetDrillToSecretariat();
                            setActiveTab("Indicator"); resetPeriodicityFilter(); resetGradeFilter();
                            setIndicatorenb(true);
                            secretariatgradedata(clickType === "hod" ? "0" : selectedsec, selectedmap === "districtmap" ? "0" : selectedDistrictId, "0");
                            setSelectedMandal(null);
                            setselectedmandalcode(null);
                            if ((["116", "115", "114", "119", "117", "113"].includes(role_cat_id)) && selectedDistrict !== null) {
                              setFilteredGeoData(null);

                              // ✅ Determine next map level BEFORE changing state
                              let nextMapLevel = selectedmap === "mandalmap" ? "districtmap" : "statemap";

                              // ✅ Update map level states based on nextMapLevel
                              if (nextMapLevel === "statemap") {
                                setSelectedDistrictId(null);
                                setSelectedDistrict(null)
                                if (role_cat_id === "116") {
                                  let params = {
                                    scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                    "userId": username, "year": formik.values.year, "type": "main",
                                    "districtId": "0",
                                    secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", "constId": "0",
                                  }
                                  store.dispatch({ type: "SHOW_SPINNER" });
                                  const AdminConststats = KpiService.DashboardAdminDataConstituencyWise(params)
                                  AdminConststats.then((res) => {
                                    if (res.data) {
                                      const scores = {};
                                      if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }
                                      else {
                                        setnodistdata(false); res.data.dataList?.forEach((item) => {
                                          const districtName = item.acname?.trim().toUpperCase();
                                          const isNoData = item.SCODE === "02"; scores[districtName] = {
                                            avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                            color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                          };
                                        }); setConstScoreslist(res.data.dataList); setConstScores(scores);
                                      }
                                    }
                                  }).catch(() => { setConstScoreslist([]); setConstScores({}); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                                }

                                setselectedmap("statemap");
                                setBackclickMap(false);
                                store.dispatch({ type: "SHOW_SPINNER" });
                                fetch('/andhra_pradesh.geojson')
                                  .then((response) => response.json())
                                  .then((data) => {
                                    setGeoData(data);
                                    store.dispatch({ type: "SHOW_SPINNER" });
                                    KpiService.dashboardKpiScoresGardes(params).then((res) => {
                                      if (res.data) {
                                        if (res.data?.SCODE === "02") {
                                          setDistrictScoreslist([]);
                                          setDistrictScores({}); setnodistdata(true);;
                                        }
                                        else {
                                          setnodistdata(false);
                                          const scores = {};
                                          res.data.dataList?.forEach((item) => {
                                            const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase();
                                            const isNoData = item.SCODE === "02";
                                            scores[districtName] = {
                                              avg: isNoData ? "-" : item.averagescore,
                                              grade: isNoData ? "-" : item.grade,
                                              color: isNoData ? "#ccc" : (item.color_code || "#ccc"),
                                              indicators: isNoData ? 0 : item.noofindicators,
                                            };
                                          });
                                          setDistrictScores(scores);
                                          setDistrictScoreslist(res.data.dataList);
                                        }
                                      }
                                    }).catch(() => {
                                      // showAlertMessage("Internal Server Error", "warning", () => {
                                      setDistrictScoreslist([]);
                                      setDistrictScores({}); setnodistdata(true);
                                      // })
                                    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });


                                  })
                                  .catch((err) => console.error('Error loading GeoJSON:', err)).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                              } else if (nextMapLevel === "districtmap") {
                                if ((["119", "113"].includes(role_cat_id))) { setBackclickMap(false); } else { setBackclickMap(true); }
                                setselectedmap("districtmap"); districtMap(selectedDistrict, selectedDistrictId);
                              }
                              if (role_cat_id === "116") {
                                let params = {
                                  scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                  "userId": username, "year": formik.values.year, "type": "main",
                                  "districtId": nextMapLevel === "districtmap" ? selectedDistrictId : "0",
                                  secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0", "constId": "0",
                                }
                                store.dispatch({ type: "SHOW_SPINNER" });
                                const AdminConststats = KpiService.DashboardAdminDataConstituencyWise(params); AdminConststats.then((res) => {
                                  if (res.data) { const scores = {};
                                    if (res.data?.SCODE === "02") { setConstScoreslist([]); setConstScores({}); setnodistdata(true); }
                                    else { setnodistdata(false); res.data.dataList?.forEach((item) => {
                                        const districtName = item.acname?.trim().toUpperCase(); const isNoData = item.SCODE === "02"
                                        scores[districtName] = {
                                          avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                          color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                        }; }); setConstScoreslist(res.data.dataList); setConstScores(scores); } }
                                }).catch(() => { setConstScoreslist([]); setConstScores({});
                                }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }
                              let param1 = {
                                userId: username, year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district",
                                secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0",
                                districtId: nextMapLevel === "districtmap" ? selectedDistrictId : "0",
                                mandalId: nextMapLevel === "mandalmap" ? selectedmandalcode : "0", ulbId: "0",
                                typeDrill: ((role_cat_id === "119" || role_cat_id === "113") && !selectedMandal) ? "District" :
                                  ((role_cat_id === "119" || role_cat_id === "113") && selectedMandal) ? "District" :
                                    (role_cat_id === "111" || role_cat_id === "117") ? "Mandal"
                                      : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "Sec"
                                        : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "District" : "Sec",
                              };

                              let param = {
                                userId: username, year: formik.values.year, scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId,
                                type: clickType === "hod" ? "sec" : clickType === "district" ? "hod" : "district",
                                secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0",
                                districtId: nextMapLevel === "districtmap" ? selectedDistrictId : "0",
                                mandalId: nextMapLevel === "mandalmap" ? selectedmandalcode : "0", ulbId: "0",
                                typeDrill: (["116"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "Sec"
                                  : (["115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "hod"
                                    : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "District"
                                      : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                        : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "District"
                                          : (["117", "111"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "Mandal"
                                            : (["117", "111"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "District" : ""
                              }
                              if (role_cat_id === "116") {
                                if (!selectedMandal) { if (clickType === "hod") { param.typeDrill = "Sec" } else { param.typeDrill = "hod" } }
                                else { param.typeDrill = "District" } }
                              const params = {
                                scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId, userId: username, year: formik.values.year,
                                type: clickType === "hod" ? "mapSec" : clickType === "district" ? "mapHod" : "mapDistrict",
                                secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0",
                                districtId: nextMapLevel === "districtmap" ? selectedDistrictId : "0",
                                mandalId: nextMapLevel === "mandalmap" ? selectedmandalcode : "0", ulbId: "0",
                              };
                              const MandalWiseparams = {
                                scoreForMonth: apiMonthValue, scoreCatId: formik.values.scoreCatId, userId: username, year: formik.values.year,
                                secId: clickType === "hod" ? "0" : selectedsec, deptId: clickType === "" ? selecteddept : "0",
                                districtId: nextMapLevel === "districtmap" ? selectedDistrictId : "0",
                                mandalId: nextMapLevel === "mandalmap" ? selectedmandalcode : "0", ulbId: "0"
                              }; console.log("nextMapLevel", nextMapLevel)

                              // Call APIs as-is
                              store.dispatch({ type: "SHOW_SPINNER" });
                              KpiService.dashboardKpiData(param1).then((res) => {
                                if (res.data) { const updatedData = groupIndicators(res.data?.dataList); setdashboardKpiData(updatedData) }
                                setdashboardMonthData(res.data?.dataList?.[0]);
                              }).catch(() => {
                              }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                              store.dispatch({ type: "SHOW_SPINNER" });
                              KpiService.dashboardKpiScoresGardes(param).then((res) => {
                                if (res.data?.SCODE === "02") { setDepartments([]); setdepartmentslist([]);; }
                                else if (res.data && res.data.dataList) {
                                  const apiDepartments = res.data.dataList.map((item) => ({
                                    deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
                                    dept_id: clickType === "hod" ? item.secid : item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
                                    secid: item.secid, sec_short_name: item.sec_short_name, secretariat_code: item.secretariat_code || "",
                                    averagescore: item.averagescore, grade: item.grade, noofindicators: item.noofindicators,
                                  })); setDepartments(apiDepartments); setdepartmentslist(res.data.dataList);
                                }

                              }).catch(() => {
                                setDepartments([]); setdepartmentslist([]);
                              }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); store.dispatch({ type: "SHOW_SPINNER" });

                              if (role_cat_id === "116") {
                                const service = KpiService.dashboardKpiScoresGardes(param);
                                store.dispatch({ type: "SHOW_SPINNER" }); service.then((res) => {
                                  if (res.data?.SCODE === "02") { setDrillDepartments([]); setDrillDepartmentsList([]); }
                                  else if (res.data && res.data.dataList) { const apiDepartments = res.data.dataList.map((item) => ({
                                      deptcode: clickType === "hod" ? item.secid?.trim().toUpperCase() : item.deptcode?.trim().toUpperCase(),
                                      dept_id: item.dept_id, dept_name: clickType === "hod" ? item.sec_name : item.dept_name,
                                      secid: clickType === "hod" ? item.secid : item.secretariat_code,
                                      secretariat_code: clickType === "hod" ? item.secid : item.secretariat_code,
                                      sec_short_name: item.sec_short_name, averagescore: item.averagescore, grade: item.grade,
                                      noofindicators: item.noofindicators,
                                    })); setDrillDepartments(apiDepartments); setDrillDepartmentsList(res.data.dataList);
                                  } }).catch(() => { setDrillDepartments([]); setDrillDepartmentsList([]);
                                }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); }
                              KpiService.dashboardKpiScoresGardes(params).then((res) => {
                                if (res.data) { const scores = {};
                                  if (res.data?.SCODE === "02") { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);; }
                                  else { setnodistdata(false); res.data.dataList?.forEach((item) => {
                                      const districtName = item.district_name?.replace(/\s+/g, " ").trim().toUpperCase();
                                      const isNoData = item.SCODE === "02"; scores[districtName] = {
                                        avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                        color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                      }; }); setDistrictScoreslist(res.data.dataList); setDistrictScores(scores); } }
                              }).catch(() => { setDistrictScoreslist([]); setDistrictScores({}); setnodistdata(true);
                              }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); store.dispatch({ type: "SHOW_SPINNER" });
                              KpiService.dashboardMandalWiseIndicatorDataTab(MandalWiseparams).then((res) => {
                                if (res.data?.SCODE === "02") { setmandalTabScoreslist([]); setMandalalert(true); setmandalTabScores({});; }
                                if (res.data && res.data.dataList) {
                                  const scores = {}; setMandalalert(false);
                                  const mandalData = (ulbdeptlist.includes(ulbdept2) || selectedsec === "MAU01" || username === "MAU01") ? res.data.dataList?.filter(item => item.type === "ULB") : res.data.dataList?.filter(item => item.type === "MANDAL");
                                  mandalData.forEach((item) => {
                                    const mandalname = (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01" || username === "MAU01") ? item.ulb_name : item.mandal_name?.trim().toUpperCase();
                                    const isNoData = item.SCODE === "02";
                                    scores[mandalname] = {
                                      avg: isNoData ? "-" : item.averagescore, grade: isNoData ? "-" : item.grade,
                                      color: isNoData ? "#ccc" : (item.color_code || "#ccc"), indicators: isNoData ? 0 : item.noofindicators,
                                    };
                                  }); setmandalTabScores(scores); setmandalTabScoreslist(res.data.dataList);
                                }
                              }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
                            }
                          }} >
                          ← Back </button>)}
                      <div className="district-map m-auto" style={{ padding: "100px 0px", position: "relative" }}>
                        {(selectedDistrict || selectedMandal) && (
                          <div style={{
                            position: "absolute", top: "10px", left: "20px", background: "#fff",
                            padding: "8px 16px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)", fontWeight: "600",
                            zIndex: 10, display: "flex", alignItems: "center", gap: "15px"
                          }} >
                            {selectedDistrict && (
                              <div style={{ fontSize: "16px", color: "#333" }}>
                                {role_cat_id === "111" && ulbdeptlist.includes(deptid) ? (
                                  <span style={{ color: "red" }}>Map Not Available</span>
                                ) : (
                                  <span style={{ color: "#0B4C66" }}>
                                    {selectedDistrict} <span style={{ color: "red" }}>(Dist)</span>
                                  </span>)}
                              </div>
                            )}

                            {selectedMandal && (
                              <div style={{ fontSize: "16px", color: "#333" }}>
                                <span style={{ color: "#0B4C66" }}>- {selectedMandal}<span style={{ color: "red" }}>(Mand)</span></span>
                              </div>
                            )}
                          </div>
                        )}

                        {(geoData || filteredGeoData) && (
                          <ComposableMap
                            projection="geoMercator"
                            projectionConfig={{
                              scale: mapScale,
                              center: mapCenter,
                            }}
                            width={600}
                            height={500}
                            style={{ width: "100%", height: "100%" }}
                          >

                            <Geographies geography={(selectedDistrict || role_cat_id === "112") ? filteredGeoData : geoData}>
                              {({ geographies, projection }) =>
                                geographies.map((geo) => {
                                  const centroid = geoCentroid(geo);

                                  const districtRaw = getGeoProp(geo.properties, [
                                    'district', 'District', 'DISTRICT', 'district_name', 'DISTRICT_NAME', 'districtName', 'DistrictName', 'ASSEM_NAME', 'District'
                                  ]);
                                  const districtKey = (districtRaw || "").trim().toUpperCase();

                                  const nameRaw = getGeoProp(geo.properties, [
                                    'mandal_name', 'MANDAL', 'Mandal', 'Mandal_Na', 'ASSEM_NAME', 'name', 'Name', 'MANDAL_NA', 'DISTRICT'
                                  ]);

                                  const nameKey = (nameRaw || "").trim().toUpperCase();

                                  let info = { avg: "-", grade: "-", color: "#ccc", indicators: 0 };

                                  const tryFindMandalScore = () => {
                                    const candidatesRaw = [nameKey, nameRaw, districtRaw,
                                      getGeoProp(geo.properties, ['ASSEM_NAME', 'acname', 'AC_NAME', 'ac_name', 'assembly_name', 'accode']),
                                      geo.properties?.mandal_id, geo.properties?.MandalCode, geo.properties?.mandalcode, geo.properties?.LGD_Code];
                                    const candidates = Array.from(new Set(candidatesRaw.filter(Boolean).map(c => String(c).trim().toUpperCase())));

                                    for (const k of candidates) {
                                      if (mandalTabScores && mandalTabScores[k]) return mandalTabScores[k];
                                      if (mandalScores && mandalScores[k]) return mandalScores[k];
                                      if (ConstScores && ConstScores[k]) return ConstScores[k];
                                      if (districtScores && districtScores[k]) return districtScores[k];
                                    }
                                    return null;
                                  };

                                  if (selectedDistrict === null) {
                                    if (districtScores && districtScores[districtKey]) {
                                      info = districtScores[districtKey];
                                    } else {
                                      const c = tryFindMandalScore(); if (c) info = c;
                                    }
                                  } else {
                                    if (mandalTabScores && mandalTabScores[nameKey]) {
                                      info = mandalTabScores[nameKey];
                                    } else {
                                      const c = tryFindMandalScore(); if (c) info = c;
                                    }
                                  }

                                  const selDistrictKey = selectedDistrict?.trim().toUpperCase();
                                  const selMandalKey = selectedMandal?.trim().toUpperCase();

                                  let fillColor = "#ccc";
                                  if ((selDistrictKey && selDistrictKey === districtKey) ||
                                    (selMandalKey && selMandalKey === nameKey)) { fillColor = "#f0f0f0"; }

                                  else if (selectedDistrict !== null) {
                                    if (role_cat_id === "112") {
                                      const c = tryFindMandalScore(); if (c && c.color) { fillColor = c.color; }
                                    }
                                    else if (
                                      info &&
                                      info.avg !== "-" &&
                                      info.grade !== "-" &&
                                      info.color &&
                                      info.color.trim() !== "" &&
                                      info.color !== "#ccc"
                                    ) {
                                      fillColor = info.color;
                                    }
                                    else if (
                                      districtScores &&
                                      districtScores[districtKey] &&
                                      districtScores[districtKey].color
                                    ) {
                                      fillColor = districtScores[districtKey].color;
                                    }
                                  }
                                  else {
                                    if (
                                      info &&
                                      info.avg !== "-" &&
                                      info.grade !== "-" &&
                                      info.color &&
                                      info.color.trim() !== ""
                                    ) {
                                      fillColor = info.color;
                                    }
                                    else {
                                      fillColor = "#ccc"
                                    }
                                  }
                                  return (
                                    <React.Fragment key={geo.rsmKey}>
                                      <Geography
                                        geography={geo}
                                        style={{
                                          default: { fill: selectedDistrict !== null && Mandalalert ? "#ccc" : (info.color || "#ccc"), stroke: "#fff", strokeWidth: 1, outline: "none" },
                                          hover: { fill: selectedDistrict !== null && Mandalalert ? "#ccc" : (info.color || "#ccc"), stroke: "#fff", strokeWidth: 1, outline: "none", cursor: "pointer" },
                                          pressed: { fill: selectedDistrict !== null && Mandalalert ? "#ccc" : (info.color || "#ccc"), stroke: "#fff", strokeWidth: 1, outline: "none" },
                                        }}
                                        onMouseDown={(evt) => {
                                          if (selectedDistrict === null && role_cat_id !== "112") {
                                            const districtname = districtRaw || getGeoProp(geo.properties, ['ASSEM_NAME', 'district', 'District']) || "Unknown";
                                            const districtid = geo.properties.district_id || geo.properties.DstCodeAP || geo.properties.LGD_Code || "Unknown";
                                            DistrictDrilDown(districtname, districtid);
                                          } else {
                                            // For role 112 (constituency view) we want clicking to drill into mandals
                                            const Mandalname = nameRaw || getGeoProp(geo.properties, ['ASSEM_NAME', 'name', 'MANDAL_NA']) || "Unknown";
                                            const districtParam = role_cat_id === "112" ? (getGeoProp(geo.properties, ['ASSEM_NAME', 'district', 'District']) || "Unknown") : selectedDistrict;
                                            const districtIdParam = role_cat_id === "112" ? (geo.properties.district_id || geo.properties.DstCodeAP || geo.properties.LGD_Code || "Unknown") : selectedDistrictId;
                                            const assemblyName = role_cat_id === "112" ? (getGeoProp(geo.properties, ['ASSEM_NAME', 'name', 'Assembly']) || "Unknown") : null;
                                            const assemblyCode = role_cat_id === "112" ? (geo.properties.assembly_id || geo.properties.AssemCodeAP || geo.properties.LGD_Code || "Unknown") : null;
                                            MandalDrillDown(Mandalname, districtParam, districtIdParam, assemblyName, assemblyCode);
                                          }
                                        }}
                                        onMouseEnter={(evt) => {
                                          // const avg = info.avg ?? "NA";
                                          // const grade = info.grade ?? "NA";
                                          // const indicators = info.indicators ?? "NA";

                                           const avg = selectedDistrict !== null && Mandalalert ? "-" : (info.avg ?? "NA");
                                           const grade = selectedDistrict !== null && Mandalalert ? "-" : (info.grade ?? "NA");
                                           const indicators = selectedDistrict !== null && Mandalalert ? "-" : (info.indicators ?? "NA");

                                          const label = role_cat_id === "112" ? (nameRaw || districtRaw) : (selectedDistrict === null ? (districtRaw || getGeoProp(geo.properties, ['ASSEM_NAME', 'district', 'District'])) : nameRaw);
                                          // console.log("label", label);
                                          setTooltipContent(
                                            `${label}\nScore: ${avg}\nGrade: ${grade}\nIndicators: ${indicators}`
                                          );
                                          setShowTooltip(true);
                                          handleMouseMove(evt);
                                        }}
                                        onMouseLeave={() => setShowTooltip(false)}
                                        onMouseMove={handleMouseMove}
                                      />

                                      {projection && (
                                        <text
                                          x={projection(centroid)[0]}
                                          y={projection(centroid)[1]}
                                          textAnchor="middle"
                                          alignmentBaseline="central"
                                          fill="#111"
                                          fontWeight="bold"
                                          fontSize={Math.min(18, Math.max(10, mapScale / 3000))}
                                          style={{ pointerEvents: "none" }}
                                        >
                                          {role_cat_id === "112" ? (nameRaw || districtRaw) : (selectedDistrict === null ? (districtRaw || getGeoProp(geo.properties, ['ASSEM_NAME', 'district', 'District'])) : nameRaw)}
                                        </text>
                                      )}
                                    </React.Fragment>
                                  );
                                })
                              }
                            </Geographies>
                          </ComposableMap>
                        )}

                        {showTooltip && (
                          <div
                            style={{
                              position: "fixed",
                              top: tooltipPos.y,
                              left: tooltipPos.x,
                              background: "rgba(0,0,0,0.7)",
                              color: "#fff",
                              padding: "4px 8px",
                              borderRadius: 4,
                              pointerEvents: "none",
                              fontSize: 12,
                              whiteSpace: "pre-line",
                              zIndex: 1000,
                              transform: "translate(-50%, -100%)",
                            }}
                          >
                            {tooltipContent}
                          </div>
                        )}
                      </div>

                    </Col>

                    <Col xs={12} sm={12} md={12} lg={10} xl={8} xxl={8}>


                      <div className="district-mapranks">
                        {clickType === "hod" && (
                          <div
                            className="secretariat-heading d-flex justify-content-between align-items-center"
                            style={{ padding: "0.5rem 1.5rem" }}
                          >
                            <h6>
                              <b>{departments?.length}</b> SECRETARIAT DEPARTMENTS
                            </h6>

                            <div className="d-flex align-items-center">
                              <b>
                                <span style={{ marginRight: "0.5rem", fontWeight: "600", fontSize: "15px" }}>
                                  {role_cat_id === "112" ? "Constituency Performance :" : ((selectedDistrict !== null && selectedMandal === null) ? "District Performance :" : (selectedMandal !== null) ? "Mandal Performance :" : "")}
                                </span>
                                <span style={{ color: role_cat_id === "112" ? ConstScoreslist[0]?.color_code : (selectedDistrict !== null && selectedMandal === null) ? districtScoreslist[0]?.color_code : (selectedMandal !== null) ? mandalTabScoreslist[0]?.color_code : "", fontWeight: "700", fontSize: "15px" }}>
                                  {/* {role_cat_id === "112" ? ConstScoreslist[0]?.averagescore : (selectedDistrict !== null && selectedMandal === null) ? districtScoreslist[0]?.averagescore : (selectedMandal !== null) ? mandalTabScoreslist[0]?.averagescore : ""} */}
                                {(() => {
                                  const data = role_cat_id === "112" ? ConstScoreslist?.[0] : selectedDistrict !== null && selectedMandal === null ? districtScoreslist?.[0] : selectedMandal !== null ? mandalTabScoreslist?.[0] : null;
                                  if (!data?.averagescore && !data?.grade) { return ""; } if (!data?.grade) { return data.averagescore; } if (!data?.averagescore) { return data.grade; } return `${data.averagescore} (${data.grade})`; })()}
                                </span>
                              </b>
                            </div>
                          </div>
                        )}


                        {clickType !== "hod" && (
                          (["114", "119", "115", "113", "111", "117", "112"].includes(role_cat_id) ||
                            (["119", "116"].includes(role_cat_id) && parentDept && Backclick)) && (
                            <div className="topranks-div">
                              <div className="top-head">
                                <img
                                  src={
                                    deptIconPrefixes[
                                    ["114", "115", "113", "111",].includes(role_cat_id)
                                      ? SectariatcodeName?.slice(0, 3)?.toUpperCase()
                                      : secgrade ? secgrade?.secid?.slice(0, 3)?.toUpperCase() : parentDept?.deptcode?.slice(0, 3)?.toUpperCase()
                                    ] || "/default.png"
                                  }
                                  alt=""
                                  className="img-fluid"
                                />
                                <h5 className="mb-0">
                                  {["114", "115", "113", "111",].includes(role_cat_id)
                                    ? SectariatcodeName
                                    : secgrade ? `${secgrade?.secid}-${secgrade?.sec_name}` : `${parentDept?.deptcode}-${parentDept?.dept_name}`}
                                </h5>

                              </div>

                              {/* {parentDept && (
                                <div
                                  className="score-box"
                                  style={{ backgroundColor: getColor(parentDept.averagescore) }}
                                >
                                  <div className="left">
                                    <p className="mb-0">{parentDept.averagescore}</p>
                                  </div>
                                  <div className="divider"></div>
                                  <div className="right">
                                    <p className="mb-0">{parentDept.grade}</p>
                                  </div>
                                </div>
                              )} */}
                              {(parentDept && selectedDistrictId === null && !["115", "114", "112"].includes(role_cat_id)) && (
                                <div
                                  className="score-box"
                                  style={{ backgroundColor: getColor(parentDept.averagescore ? parentDept.averagescore : "") }}
                                >
                                  <div className="left">
                                    <p className="mb-0">{parentDept.averagescore ? parentDept.averagescore : ""}</p>
                                  </div>
                                  <div className="divider"></div>
                                  <div className="right">
                                    <p className="mb-0">{parentDept.grade ? parentDept.grade : ""}</p>
                                  </div>
                                </div>
                              )}

                              {(secgrade) && (
                                <div
                                  className="score-box"
                                  style={{ backgroundColor: getColor(secgrade?.averagescore ? secgrade?.averagescore : "") }}
                                >
                                  <div className="left">
                                    <p className="mb-0">{secgrade?.averagescore ? secgrade?.averagescore : ""}</p>
                                  </div>
                                  <div className="divider"></div>
                                  <div className="right">
                                    <p className="mb-0">{secgrade?.grade ? secgrade?.grade : ""}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          )
                        )}

                        <div className="map-rankcards">
                          <Row>

                            {departments
                              .filter(
                                (dept) =>
                                  (dept.deptcode?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
                                  (dept.dept_name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
                                  (dept.sec_short_name?.toLowerCase() || "").includes(searchTerm.toLowerCase())
                              )
                              .map((dept) => {
                                const iconKey = dept?.deptcode ? dept.deptcode?.trim().toUpperCase() : "";
                                const iconPrefix = iconKey.slice(0, 3);

                                return (
                                  <Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3} key={dept.deptcode} >

                                    <div role="button" tabIndex={0} className={clickType === "hod" ? "dept-rankcard" : "sub-card"} onClick={() => { handleCircleClick(dept) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { handleCircleClick(dept); } }} style={{ cursor: "pointer" }} data-tip data-for={`tooltip-info-${dept.deptcode?.trim().toUpperCase()}`} >
                                      {(clickType === "hod") ? (
                                        <>
                                          <div className="dept-code">
                                            <h5 className="mb-0">{dept?.sec_short_name}</h5>
                                          </div>
                                          <div
                                            className="score-box"
                                            style={{ backgroundColor: getColor(dept.averagescore) }}
                                          >
                                            <div className="left">
                                              <p className="mb-0">{dept.averagescore}</p>
                                            </div>
                                            <div className="divider"></div>
                                            <div className="right">
                                              <p className="mb-0">{dept.grade}</p>
                                            </div>
                                          </div>

                                          {/* <Tooltip

                                            id={`tooltip-info-${dept.deptcode?.trim().toUpperCase()}`}
                                            place="top"
                                            effect="solid"
                                            className=""
                                          >
                                            {dept?.dept_name}
                                          </Tooltip
> */}
                                        </>
                                      ) : (
                                        <>
                                          <div className="sub-deptinfo">
                                            <h5 className="mb-0">
                                              {dept?.deptcode}-{dept?.dept_name}
                                            </h5>
                                            <p className="mb-0">
                                              <span>{dept.noofindicators}</span> Indicators
                                            </p>
                                          </div>

                                          <div className="subdept-rank">
                                            {/* SCORE box with color */}
                                            <h5
                                              className="mb-0"
                                              style={{
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                color: getColor(dept.averagescore),
                                              }}
                                            >
                                              {dept.averagescore}
                                            </h5>

                                            {/* GRADE box with same color */}
                                            <div
                                              className="rank-circle"
                                              style={{
                                                backgroundColor: getColor(dept.averagescore),
                                                color: "#fff",
                                              }}
                                            >
                                              <p className="mb-0">{dept.grade}</p>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>


                                  </Col>
                                );
                              })}
                          </Row>
                        </div>
                      </div>

                    </Col>
                  </Row>
                </div>
                <hr />
                <div className='all-tabs p-0'>
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <div className='d-md-flex head-tabs px-sm-3'>
                      <Nav variant="pills" className="flex-colmn tabs-btn m-auto">
                        <Nav.Item>
                          <Nav.Link activeKey={activeTab} className={`broadsector-tab broadsector-tab1 ${activeTab === "Indicator" ? "active" : ""}`} onClick={() => {
                            resetPeriodicityFilter(); resetGradeFilter(); setActiveTab('Indicator'); setdeptsearch(""); setSearch(""); setIndicatormandalsearch(""); setinddistenb(false);
                            setdistsearch(""); setIndicatorenb(true); setDistenb(false); setMandalenb(false); setDeptenb(false); setConstu(false)
                          }}>
                            <img src='../images/indicator-stats.svg' className='img-fluid' /><span>Indicator Stats</span>
                          </Nav.Link>
                        </Nav.Item>


                        {(role_cat_id === "116") && (<Nav.Item>
                          <Nav.Link activeKey={activeTab} className={`broadsector-tab broadsector-tab2 ${activeTab === "Dept" ? "active" : ""}`} onClick={() => {
                            resetGradeFilter(); setdeptsearch(""); setSearch(""); setdistsearch(""); setActiveTab('Dept');
                            setDeptenb(true); setIndicatorenb(false); setDistenb(false); setMandalenb(false); setIndicatormandalsearch(""); setinddistenb(false); setConstu(false)
                          }} >
                            <img src='../images/broadsector-tab4.svg' className='img-fluid' /><span> Department Stats</span>
                          </Nav.Link>
                        </Nav.Item>)}

                        {(!["111", "117", "112"].includes(role_cat_id) && selectedmap !== "mandalmap") && <Nav.Item>
                          <Nav.Link activeKey={activeTab} className={`broadsector-tab broadsector-tab3 ${activeTab === "District" ? "active" : ""}`} onClick={() => {
                            resetGradeFilter(); setActiveTab('District'); setdeptsearch(""); setinddistenb(false); setMandalenb(false); setSearch(""); setIndicatormandalsearch(""); setdistsearch(""); setDistenb(true); setIndicatorenb(false); setConstu(false)
                            setDeptenb(false);
                          }}>
                            <img src='../images/broadsector-tab5.svg' className='img-fluid' /><span> District Stats</span>
                          </Nav.Link>
                        </Nav.Item>}


                        {(["116", "112"].includes(role_cat_id) && !selectedMandal && username !== "SEC_PLG_MON") &&
                          <Nav.Item>
                            <Nav.Link activeKey={activeTab} className={`broadsector-tab broadsector-tab4 ${activeTab === "Const" ? "active" : ""}`} onClick={() => {
                              resetGradeFilter(); setActiveTab('Const'); setdeptsearch(""); setinddistenb(false); setMandalenb(false); setSearch(""); setIndicatormandalsearch(""); setdistsearch(""); setDistenb(false); setIndicatorenb(false); setConstu(true)
                              setDeptenb(false);
                            }}>
                              <img src='../images/broadsector-tab7.svg' className='img-fluid' /><span> Constituency Stats</span>
                            </Nav.Link>
                          </Nav.Item>}
                        <Nav.Item>
                          <Nav.Link activeKey={activeTab} className={`broadsector-tab broadsector-tab5 ${activeTab === "Mandal" ? "active" : ""}`} onClick={() => {
                            resetGradeFilter(); setmandaltabsearch("");
                            setActiveTab('Mandal'); setdeptsearch(""); setSearch(""); setinddistenb(false);

                            if (role_cat_id === "116" && !selectedDistrict) {
                              formik.setFieldValue("district_id", "0");
                              mandaltabdata(clickType === "hod" ? "0" : selectedsec, clickType === "" ? selecteddept : "0", "0", true)
                            }
                            setdistsearch(""); setIndicatorenb(false); setMandalenb(true); setIndicatormandalsearch(""); setDistenb(false); setDeptenb(false); setConstu(false)
                          }}>
                            <img src='../images/broadsector-tab6.svg' className='img-fluid' /><span> {(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"} Stats</span>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                    <div className="table-section mb-3" style={{ width: "96%", display: "inline-block" }} >


                      {Indicatorenb && <>
                        <div
                          className="table-section-wrapper"
                          style={{ textAlign: "center", }}
                        >
                          <div className="table-section" style={{ width: "96%", display: "inline-block" }} >
                            {/* ===== Grade Filter Checkboxes ===== */}
                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                alignItems: "center",
                                marginBottom: "10px",
                                paddingLeft: "10px",
                              }}
                            >
                              <GradeFilter
                                gradeFilter={gradeFilter}
                                onChange={handleGradeChange}
                              />
                              <div style={{ display: "flex", gap: "20px", alignItems: "center", marginBottom: "10px", paddingLeft: "10px", }} >
                                <label>
                                  <input type="checkbox"
                                    checked={periodicityFilter.monthlyLowScore}
                                    onChange={(e) => setPeriodicityFilter((prev) => ({ ...prev, monthlyLowScore: e.target.checked, }))} />
                                  <span style={{ marginLeft: "6px", color: "red" }}>
                                    Monthly &lt; 75 </span>
                                </label>

                                <label>
                                  <input
                                    type="checkbox"
                                    checked={periodicityFilter.quarterlyLowScore}
                                    onChange={(e) =>
                                      setPeriodicityFilter((prev) => ({ ...prev, quarterlyLowScore: e.target.checked, }))} />
                                  <span style={{ marginLeft: "6px", color: "orange" }}>
                                    Quarterly  &lt; 75 </span> </label>
                              </div>
                            </div>

                            <Row className="align-items-center mb-2">

                              {/* Search (small width) */}
                              <Col xs={12} md="auto">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  style={{ width: "250px" }}
                                  value={search}
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                              </Col>

                              {/* push buttons to right side */}
                              <Col className="ms-auto text-end">
                                <Button style={{ backgroundColor: "#4EA53C" }}
                                  variant="success"
                                  size="sm"
                                  className="mx-2"
                                  onClick={handleAllDepartmentsExcel}
                                >
                                  <RiFileExcel2Line />
                                </Button>

                                <Button style={{ backgroundColor: "#C54435" }}
                                  variant="danger"
                                  size="sm"
                                  onClick={handleAllDepartmentsPDF}
                                >
                                  <GrDocumentPdf />
                                </Button>
                              </Col>

                            </Row>







                            <div className="department-table"  >
                              <div
                                className="performancesa-title"
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "auto 1fr auto",
                                  alignItems: "center",
                                  width: "100%",
                                  gap: "10px",
                                }}
                              >

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {selectedDistrict && (
                                    <div style={{ color: "#111", fontSize: "14px" }}>
                                      {selectedDistrict} <span style={{ color: "red" }}>(Dist)</span>
                                    </div>
                                  )}

                                  {selectedMandal && (
                                    <div style={{ color: "#111", fontSize: "14px" }}>
                                      {selectedMandal} <span style={{ color: "red" }}>(Mandal)</span>
                                    </div>
                                  )}
                                </div>

                                <h2
                                  style={{
                                    textAlign: "center",
                                    margin: 0,
                                    width: "100%",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {clickType === "hod" && <>Key Performance <span>Indicators (KPIs)</span></>}
                                  {clickType === "district" && (
                                    <>
                                      {["116", "119", "112"].includes(role_cat_id)
                                        ? `${parentDept?.deptcode} - ${parentDept?.dept_name}`
                                        : SectariatcodeName}
                                      <span> (KPIs)</span>
                                    </>
                                  )}
                                  {clickType === "" && (
                                    <>
                                      {["114", "113", "119", "115",].includes(role_cat_id)
                                        ? deptcodeName
                                        : `${departments[0]?.deptcode} - ${departments[0]?.dept_name}`}
                                      <span> (KPIs)</span>
                                    </>
                                  )}
                                </h2>

                                <h6
                                  style={{
                                    margin: 0,
                                    textAlign: "right",
                                    whiteSpace: "nowrap",
                                    color: "red",
                                    fontWeight: 500,
                                  }}
                                >
                                  Achievements – Last Financial year values are{" "}
                                  <span>considered for Annual indicators</span>
                                </h6>

                              </div>
                              <div className="grey-strip">
                                <Row> <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}> <div className="grey-striphead">
                                  <h5 className="mb-0 grey-marg">Secretariat Department</h5> </div> </Col>
                                  <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}>
                                    <div className="grey-striphead">
                                      <h5 className="mb-0">HOD Name</h5>
                                    </div> </Col> </Row> </div>
                              <div
                                className="kpi-accordion-scroll"
                                style={{
                                  maxHeight: "calc(100vh - 200px)", // adjust as needed
                                  overflowY: "auto",
                                  overflowX: "hidden"
                                }}
                              >
                                {isNoIndicatorData ? (<div className="text-center mt-4">
                                  <h5 style={{ color: "red" }}>No Data Found</h5> </div>)
                                  : (finalFilteredSDGData
                                    ?.map((sec) =>
                                      sec?.departments
                                        ?.filter(
                                          (dept) => {
                                            const deptString =
                                              JSON.stringify(dept).toLowerCase();
                                            return deptString.includes(search.toLowerCase());
                                          })?.map((dept) => {
                                            deptCounter++; return (
                                              <Accordion activeKey={activeDept} onSelect={(key) => setActiveDept(key)} className="kpi-accord" key={deptCounter}>
                                                <Accordion.Item eventKey={String(deptCounter)}> <Accordion.Header>
                                                  <div className="kpi-header"> <Row>
                                                    <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}> <div className="left-sec">
                                                      <span className="collapse-arrow"></span> <span className="serial">{deptCounter}</span> <span className="title">
                                                        {dept?.secname} </span> </div> </Col>
                                                    <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}> <div className="middle-sec"> <span>{dept?.departmentName}</span> </div> </Col>
                                                    <Col xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}> <div className="right-sec">
                                                      <p className="mb-0">
                                                        <span>{dept?.indicators?.length} </span>
                                                        Indicators </p> </div> </Col> </Row> </div>
                                                </Accordion.Header>
                                                  <Accordion.Body>
                                                    <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "calc(100vh - 300px)" }}>
                                                      <Table striped hover className="kpi-table">
                                                        <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "#fff" }}>
                                                          <tr>
                                                            <th>Sl.No</th>
                                                            {role_cat_id === "112" && <th style={{ backgroundColor: "#4e835c", }}>Constituency Name</th>}
                                                            {KpiEna && <> <th >
                                                              KPI{" "}
                                                              <button type="button"
                                                                style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                                                onClick={() => handleSort("indicatorname")}
                                                              >
                                                                {sortConfig.key === "indicatorname"
                                                                  ? sortConfig.direction === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                  : "↕"}
                                                              </button>
                                                            </th></>}
                                                            <th>Unit</th>
                                                            <th>Periodicity</th>
                                                            <th>Entry Level</th>
                                                            <th>Time Fraction</th>
                                                            <th>Indicator Nature</th>
                                                            <th>Target 
                                                              <button
                                                                style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                                                onClick={() => handleSort("target")}
                                                              >
                                                                {sortConfig.key === "target"
                                                                  ? sortConfig.direction === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                  : "↕"}
                                                              </button>
                                                            </th>
                                                            <th>Achievement
                                                              <button
                                                                style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                                                onClick={() => handleSort("achivementvalue")}
                                                              >
                                                                {sortConfig.key === "achivementvalue"
                                                                  ? sortConfig.direction === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                  : "↕"}
                                                              </button>
                                                            </th>
                                                            <th >
                                                              Score{" "}
                                                              <button
                                                                style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                                                onClick={() => handleSort("achievedscore")}
                                                              >
                                                                {sortConfig.key === "achievedscore"
                                                                  ? sortConfig.direction === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                  : "↕"}
                                                              </button>
                                                            </th>

                                                            <th >
                                                              Grade{" "}
                                                              <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("achievedgrade")} >
                                                                {sortConfig.key === "achievedgrade" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"}
                                                              </button></th> </tr> </thead> <tbody>
                                                          {getSortedIndicators(dept?.indicators, sortConfig, gradeRank).map((rec, index) => (
                                                            <tr key={index}>
                                                              <td>{index + 1}</td>
                                                              {/* {role_cat_id === "112" && <td>{rec?.acname}</td>} */}

                                                              {role_cat_id === "112" && <td onClick={() => {
                                                                DisttabNoofIndicators("District", "District",
                                                                  clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                                                  (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                                                  districtid, "0", rec.indicatorid, clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "", rec);
                                                              }}
                                                              > <Link>{rec?.acname}</Link> </td>}

                                                              {KpiEna && (
                                                                <td>
                                                                  {rec?.kpi_entry_level === "HOD" ||
                                                                    rec?.kpi_entry_level === "Secretariat"
                                                                    || (role_cat_id === "112" && rec?.kpi_entry_level === "Mandal")
                                                                    ||(role_cat_id !== "112" && rec?.kpi_entry_level === "District")
                                                                    ? (
                                                                      rec?.indicatorname
                                                                    ) : selectedMandal !== null ? (
                                                                      <span>{rec?.indicatorname}</span>
                                                                    ) : (
                                                                      <span
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        style={{
                                                                          cursor: "pointer",
                                                                          color: "#0d6efd",
                                                                          textDecoration: "underline",
                                                                        }}
                                                                        onClick={() => {
                                                                          setselectedind(rec);
                                                                          DisttabNoofIndicators(
                                                                            "Indicator",
                                                                            "District",
                                                                            clickType === "hod"
                                                                              ? "0"
                                                                              : clickType === "district" || clickType === ""
                                                                                ? selectedsec
                                                                                : "",
                                                                            clickType === "sec" || clickType === "hod" || clickType === "district"
                                                                              ? "0"
                                                                              : selecteddept,
                                                                            selectedDistrict === null ? "0" : selectedDistrictId,
                                                                            "0",
                                                                            rec?.indicatorid,
                                                                            rec?.sec_id,
                                                                            rec
                                                                          );
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                          if (e.key === "Enter" || e.key === " ") {
                                                                            e.preventDefault();
                                                                            setselectedind(rec);
                                                                            DisttabNoofIndicators(
                                                                              "Indicator",
                                                                              "District",
                                                                              clickType === "hod"
                                                                                ? "0"
                                                                                : clickType === "district" || clickType === ""
                                                                                  ? selectedsec
                                                                                  : "",
                                                                              clickType === "sec" || clickType === "hod" || clickType === "district"
                                                                                ? "0"
                                                                                : selecteddept,
                                                                              selectedDistrict === null ? "0" : selectedDistrictId,
                                                                              "0",
                                                                              rec?.indicatorid,
                                                                              rec?.sec_id,
                                                                              rec
                                                                            );
                                                                          }
                                                                        }}
                                                                      >
                                                                        {rec?.indicatorname}
                                                                      </span>

                                                                    )}
                                                                </td>
                                                              )}



                                                              <td>{rec?.unitname}</td>
                                                              <td>{rec?.periodic_name}</td>
                                                              <td>{rec?.kpi_entry_level}</td>
                                                              <td style={{ textAlign: "right" }}>{rec?.time_fraction}</td>
                                                              <td>{rec?.indicatornature}</td>
                                                              <td style={{ textAlign: "right" }}>
                                                                {formatNumberIndianWithDecimal(rec?.target)}
                                                              </td>
                                                              <td style={{ textAlign: "right" }}>
                                                                {rec?.achivementvalue
                                                                  ? formatNumberIndianWithDecimal(rec?.achivementvalue)
                                                                  : "0.00"
                                                                }
                                                              </td>
                                                              <td style={{ textAlign: "center" }}>
                                                                {renderStatusRing(rec?.achievedscore, 100, 40, 6)}
                                                              </td>
                                                              <td style={{ textAlign: "center" }}>{rec?.achievedgrade}</td>
                                                            </tr>
                                                          ))}
                                                        </tbody>

                                                      </Table>
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            )
                                          })
                                    ))}</div>
                            </div>
                          </div>
                        </div>
                      </>}

                      {Deptenb && <>
                        <Row className="d-flex justify-content-start mt-2">
                          {deptRawList && deptRawList.length > 0 ? (
                            <>
                              <div className='performancesa-title' style={{ textAlign: "left" }}> <h2> Department Wise <span className="title-highlight"> Scores & Grades </span></h2>
                                <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "10px", marginBottom: "15px", }} >
                                  <GradeFilter gradeFilter={gradeFilter} onChange={handleGradeChange} /> </div> </div>
                              {["116"].includes(role_cat_id) &&
                                <div className="d-flex align-items-center gap-2">
                                  <Field as="select" name="drilldown" className="form-control"
                                    style={{ fontWeight: "bold", width: "250px", marginTop: "20px" }}
                                    onChange={(e) => {
                                      const value = e.target.value; formik.setFieldValue("drilldown", value);
                                      setDrillType(value === "1" ? "hod" : "sec"); handleDrillDownChangenew(value);
                                    }} >
                                    <option value="0">Secretariat</option>
                                    <option value="1">HOD</option>
                                  </Field> </div>}
                              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="mt-4">
                                <div
                                  style={{
                                    height: "600px",
                                    overflowY: "auto",   // ✅ ENABLE vertical scroll
                                    overflowX: "hidden",
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "6px"
                                  }}
                                >

                                  {/* <ResponsiveContainer width="100%" id="my-chart" key={chartKey} className="border p-1 rounded shadow-sm chartinner-div" style={{ background: "#fff", overflow: "auto", overflowY: "scroll" }} maxHeight={600}> */}
                                  <ResponsiveContainer width="100%" height={chartHeight} id="my-chart1" key={chartKey}
                                    className="border p-1 rounded shadow-sm chartinner-div" style={{ background: "#fff" }} >
                                    <BarChart
                                      layout="vertical"
                                      margin={{ top: 20, right: 20, left: 10, bottom: 0 }}
                                      barCategoryGap="15%"
                                      data={sortedDeptScores.map((item) => ({
                                        // name: item.deptcode,
                                        name: drillType === "sec" ? item.secid : item.deptcode,
                                        avg: item.averagescore,
                                        grade: item.grade,
                                        noofindicators: item.noofindicators,
                                        color: item.color_code,
                                      }))}
                                    >
                                      <CartesianGrid horizontal={false} vertical={false} />

                                      <XAxis
                                        type="number"
                                        stroke="black"
                                        tick={{ fontSize: 10, fontWeight: 600 }}
                                        domain={[0, 100]}
                                      />

                                      <YAxis
                                        type="category"
                                        dataKey="name"
                                        stroke="black"
                                        tick={{
                                          fontSize: 11,
                                          fontWeight: 600,
                                          fill: "#000",
                                        }}
                                        width={100}
                                        interval={0}
                                        minTickGap={0}
                                        tickFormatter={(value) => (value ? value : "")}
                                      />

                                      <RechartsTooltip content={({ active, payload }) => {
                                        if (active && payload && payload.length) {
                                          const data = payload[0].payload; const avg = data.avg ?? data.averagescore ?? data.score;
                                          const tooltipColor = getGradeColor(data.grade) || getColor(avg);
                                          return (
                                            <div style={{ background: "#fff", border: "1px solid #ccc", borderRadius: "6px", padding: "8px", fontSize: "11px", }} >
                                              <div style={{ display: "flex", alignItems: "center", marginBottom: "4px", }} >
                                                <div style={{ width: "12px", height: "12px", backgroundColor: tooltipColor, marginRight: "6px", borderRadius: "2px", }} ></div>
                                                {data.name} </div> <div>Score: {avg}%</div>
                                              <div>Grade: {data.grade}</div> <div>Indicators: {data.noofindicators}</div>
                                            </div>);
                                        } return null;
                                      }} />
                                      <Bar dataKey="avg" barSize={14} isAnimationActive={true} animationDuration={2500} animationEasing="ease-in-out"
                                        label={{ position: "right", formatter: (value) => `${value}%`, fill: "#000", fontSize: 11, }} >
                                        {sortedDeptScores.map((item, index) => (
                                          <Cell key={`cell-${index}`} fill={getGradeColor(item?.grade) || getColor(item?.averagescore)} />
                                        ))} </Bar> </BarChart> </ResponsiveContainer></div></Col>

                              {/* ✅ Right side table */}
                              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                                <Row>
                                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-2">
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <div className="input-group-text group_txt11" id="btnGroupAddon">
                                          <AiOutlineSearch />
                                        </div>
                                      </div>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={deptsearch}
                                        onChange={(e) => {
                                          setdeptsearch(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </Col>
                                  <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end">
                                    <Button
                                      className="btn btn-danger btn-sm mx-2 pdf-btn"
                                      onClick={() => generatedashPdf("my-table3", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                        }KPI-Department Wise Scores & Grades Dashboard`, 5, "my-chart1", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                        }KPI-Department Wise Scores & Grades Dashboard`,)}

                                      style={{ float: "right", marginLeft: "3px" }}
                                    >
                                      <GrDocumentPdf />
                                    </Button>
                                    <Button
                                      variant="success"
                                      size="sm"
                                      className="btn mx-2 excel-btn"
                                      style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                                      onClick={() => exportTodashExcel("my-table3", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""}KPI-Department Wise Scores & Grades Dashboard`)}
                                    >
                                      <span style={{ color: "white" }}>
                                        <RiFileExcel2Line style={{ fontSize: "18px" }} />
                                      </span>
                                    </Button>
                                  </Col>
                                </Row>

                                <div className="department-table">
                                  <div style={{ width: "100%", overflowX: "auto", overflowY: "auto", maxHeight: "600px" }}>
                                    <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table3">
                                      <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                                        <tr className="text-center only-export"> <th colSpan={5} className="text-center"> <span >Department Wise Scores & Grades</span> </th> </tr>

                                        <tr>
                                          <th style={{ backgroundColor: "#4e835c" }}>S.No</th>
                                          <th style={{ backgroundColor: "#4e835c" }} className="indicator-column">
                                            Department Name
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("dept_name")} >
                                              {sortConfig.key === "dept_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          {role_cat_id === "112" && <th style={{ backgroundColor: "#4e835c" }}>
                                            Constituency Name{" "} <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                              onClick={() => handleSort("assembly_name")} >
                                              {sortConfig.key === "assembly_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>}
                                          <th style={{ backgroundColor: "#4e835c" }}> No of Indicators{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("noofindicators")} >
                                              {sortConfig.key === "noofindicators" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          <th style={{ backgroundColor: "#4e835c" }}> Score{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("averagescore")} >
                                              {sortConfig.key === "averagescore" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          <th style={{ backgroundColor: "#4e835c" }}> Grade{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("grade")} >
                                              {sortConfig.key === "grade" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                        </tr> </thead> <tbody>
                                        {sortedDeptScores?.length === 0 ? (
                                          <tr>
                                            <td className="text-center" colSpan="5">
                                              <b style={{ color: "red" }}>Details Not Found</b>
                                            </td>
                                          </tr>
                                        ) : (
                                          sortedDeptScores.map((detail, i) => (
                                            <tr key={i} style={{ textAlign: "left" }}>
                                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                                              {/* <td style={{ fontSize: "14px", fontWeight: 600 }}>{detail?.deptcode}-{detail?.dept_name}</td> */}
                                              <td style={{ fontSize: "14px", fontWeight: 600 }}>
                                                {drillType === "hod" ? `${detail?.deptcode} - ${detail?.dept_name}` : `${detail?.secid || detail.secretariat_code}  - ${detail?.dept_name || detail?.sec_name}`} </td>
                                              {role_cat_id === "112" && <td>{detail?.assembly_name}</td>}
                                              <td style={{ textAlign: "right" }}
                                                onClick={() => {
                                                  if (drillType === "hod") {
                                                    deptnoofIndicators(detail,
                                                      clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                                      (clickType === "district" && clickType === "") ? "0" : detail.secid,
                                                      detail.dept_id
                                                    );
                                                  }
                                                  else {
                                                    deptnoofIndicators(detail,
                                                      clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                                      clickType === "hod" ? (drillType === "sec" ? detail.secid : detail.dept_id) : detail.secretariat_code,
                                                      clickType === "hod" ? "0" : detail.dept_id,);
                                                  }
                                                }} >
                                                <Link >{detail?.noofindicators}</Link>
                                              </td>
                                              <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                {renderStatusRing(detail?.averagescore, 100, 40, 6)}
                                              </td>
                                              <td style={{ textAlign: "center", fontWeight: 700 }}>{detail?.grade}</td>
                                            </tr>
                                          )))} </tbody> </table> </div> </div> </Col> </>)
                            : (<>
                              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                <Alert variant="danger">
                                  Departments are Not Available
                                </Alert> </Col> </>)} </Row> </>}
                      {Distenb && <>
                        <Row className="d-flex justify-content-start mt-3">
                          {districtScores && Object.keys(districtScores).length > 0 ? (
                            <> <div className='performancesa-title' style={{ textAlign: "left" }}>
                              <h2> District Wise <span className="title-highlight"> Scores & Grades </span></h2>
                              <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "10px", marginBottom: "15px", }} >
                                <GradeFilter gradeFilter={gradeFilter} onChange={handleGradeChange} /> </div> </div>
                              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="mt-4">
                                <ResponsiveContainer width="100%" id="my-chart" key={chartKey} className="border p-1 rounded shadow-sm chartinner-div" style={{ background: "#fff", overflow: "auto", overflowY: "scroll" }} maxHeight={600}>
                                  <BarChart layout="vertical" margin={{ top: 20, right: 50, left: 70, bottom: 0 }} barCategoryGap="60%"
                                    data={sortedDistrictScores.map((item) => ({
                                      district: item.district_name || item.district || item.acname || item.name,
                                      avg: item.averagescore ?? item.avg ?? item.score,
                                      grade: item.grade,
                                      indicators: item.noofindicators ?? item.indicators,
                                      color: item.color || item.color_code || "#dcdcdc",
                                    }))} >
                                    <CartesianGrid horizontal={false} vertical={false} />
                                    <XAxis type="number" stroke="black" tick={{ fontSize: 10, fontWeight: 600 }} domain={[0, 100]} />
                                    <YAxis type="category" dataKey="district" stroke="black"
                                      tick={{ fontSize: 11, fontWeight: 600, whiteSpace: "nowrap", }}
                                      width={150} interval={0} minTickGap={0} />
                                    <RechartsTooltip content={({ active, payload }) => {
                                      if (active && payload && payload.length) {
                                        const data = payload[0].payload;
                                        const avg = data.avg ?? data.averagescore ?? data.score;
                                        const tooltipColor = getGradeColor(data.grade) || getColor(avg);
                                        return (
                                          <div style={{ background: "#fff", border: "1px solid #ccc", borderRadius: "6px", padding: "8px", fontSize: "10px", }} >
                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px", }} >
                                              <div style={{ width: "12px", height: "12px", backgroundColor: tooltipColor, marginRight: "6px", borderRadius: "2px", }} ></div>
                                              {data?.district} </div> <div>Score: {avg}%</div> <div>Grade: {data?.grade}</div> <div>Indicators:{data?.indicators}</div> </div>);
                                      } return null;
                                    }} />

                                    <Bar
                                      dataKey="avg"
                                      barSize={13}
                                      isAnimationActive={true}
                                      animationDuration={3000}
                                      animationEasing="ease-in-out"
                                      label={{
                                        position: "right",
                                        formatter: (value) => `${value}%`,
                                        fill: "#000",
                                        fontSize: 9,
                                      }}
                                    >
                                      {sortedDistrictScores.map((values, index) => (
                                        <Cell key={`cell-${index}`} fill={getGradeColor(values.grade) || getColor(values.avg)} />
                                      ))}
                                    </Bar>
                                  </BarChart>
                                </ResponsiveContainer>

                              </Col>

                              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                                <Row>
                                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1">
                                    <div className="input-group">
                                      <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                                      <input type="text" className="form-control" placeholder="Search" value={distsearch} onChange={(e) => { setdistsearch(e.target.value) }} />
                                    </div>
                                  </Col>
                                  <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="mb-1 float-end" >
                                    {/* <Button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatedashPdf("my-table2", "KPI-District Wise Scores & Grades Dashboard", 5, "my-chart", "KPI-District Wise Scores & Grades Dashboard")} style={{ float: "right", marginLeft: "3px" }} >  <GrDocumentPdf /> </Button>
                                    <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportTodashExcel("my-table2", getECOBaseName())}> */}
                                    <Button
                                      className="btn btn-danger btn-sm mx-2 pdf-btn"
                                      onClick={() =>
                                        generatedashPdf(
                                          "my-table2",

                                          `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                          }KPI-District Wise Scores & Grades Dashboard`,

                                          5,
                                          "my-chart",

                                          `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                          }KPI-District Wise Scores & Grades Dashboard`
                                        )
                                      }
                                      style={{
                                        float: "right",
                                        marginLeft: "3px"
                                      }}
                                    >
                                      <GrDocumentPdf />
                                    </Button>

                                    <Button
                                      variant="success"
                                      size="sm"
                                      className="btn mx-2 excel-btn"
                                      style={{
                                        float: "right",
                                        color: "#ffffff",
                                        marginLeft: "3px"
                                      }}
                                      onClick={() =>
                                        exportTodashExcel(
                                          "my-table2",

                                          `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                          }KPI-District Wise Scores & Grades Dashboard`
                                        )
                                      }
                                    >
                                      <span style={{ color: "white" }}>

                                        <RiFileExcel2Line style={{ fontSize: "18px" }} />
                                      </span>
                                    </Button>
                                  </Col>
                                </Row>

                                <div className="department-table" >
                                  <div style={{ width: " 100%", overflow: "auto", maxHeight: "600px", overflowY: "scroll" }}>
                                    <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table2">
                                      <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                                        <tr className="text-center only-export"> <th colSpan={5} className="text-center"> <span >District Wise Scores & Grades</span> </th> </tr>
                                        <tr>
                                          <th style={{ backgroundColor: "#4e835c", }}>S.No</th>
                                          <th style={{ backgroundColor: "#4e835c" }}> District Name{" "} <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => { handleSort("district_name") }} > {sortConfig.key === "district_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          <th style={{ backgroundColor: "#4e835c" }}> No of Indicators{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("noofindicators")} >
                                              {sortConfig.key === "noofindicators" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          <th style={{ backgroundColor: "#4e835c" }}> Score{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("achievedscore")} >
                                              {sortConfig.key === "achievedscore" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                          <th style={{ backgroundColor: "#4e835c" }}> Grade{" "}
                                            <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("achievedgrade")} >
                                              {sortConfig.key === "achievedgrade" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button>
                                          </th> </tr> </thead> <tbody>
                                        {sortedDistrictScores?.length === 0 ? (<tr> <td className="text-center" colSpan="5">
                                          <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>) : (
                                          sortedDistrictScores.map((detail, i) => (<tr key={i} style={{ textAlign: "left" }}>
                                            <td style={{ textAlign: "center" }}>{i + 1}</td> <td onClick={() => {
                                              MandalData(
                                                clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                                clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                                (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                                detail.district_id, detail
                                              );
                                            }} >
                                              <Link>{detail?.district_name}</Link> </td>
                                            <td style={{ textAlign: "right" }} onClick={() => {
                                              DisttabNoofIndicators("District", "District",
                                                clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                                (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                                detail.district_id, "0", detail?.indicatorid, detail?.sec_id, detail);
                                            }}
                                            > <Link>{detail?.noofindicators}</Link> </td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                              {renderStatusRing(detail?.averagescore, 100, 40, 6)}
                                            </td> <td style={{ textAlign: "center" }}>{detail?.grade}</td>
                                          </tr>)))} </tbody> </table>
                                  </div> </div></Col>
                            </>) : (<Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              <Alert variant="danger"> District Level Indicators are Not Available </Alert></Col>)} </Row> </>}
                      {Constu && <> <Row className="d-flex justify-content-start mt-3">
                        {ConstScores && Object.keys(ConstScores).length > 0 ? <>
                          <div className='performancesa-title' style={{ textAlign: "left" }}>
                            <h2> constituency Wise <span className="title-highlight"> Scores & Grades </span></h2>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "10px", marginBottom: "15px", }} >
                              <GradeFilter gradeFilter={gradeFilter} onChange={handleGradeChange} /> </div> </div>
                          <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="mt-4">
                            <ResponsiveContainer width="100%" id="my-chart" height={Math.max((sortedConstScores || []).length * 35, 300)}
                              key={chartKey} className="border p-1 rounded shadow-sm chartinner-div" style={{ background: "#fff", overflow: "auto", overflowY: "scroll" }} maxHeight={600}>
                              <BarChart layout="vertical" margin={{ top: 20, right: 50, left: 70, bottom: 0 }} barCategoryGap="120%"
                                data={(sortedConstScores || []).map((item) => ({
                                  district: item.acname || item.district_name || item.acname || item.name,
                                  avg: item.averagescore ?? item.avg ?? item.score,
                                  grade: item.grade,
                                  indicators: item.noofindicators ?? item.indicators,
                                  color: item.color || item.color_code || "#dcdcdc",
                                }))} >
                                <CartesianGrid horizontal={false} vertical={false} />
                                <XAxis type="number" stroke="black" tick={{ fontSize: 10, fontWeight: 600 }} domain={[0, 100]} />
                                <YAxis type="category" dataKey="district" stroke="black"
                                  tick={{ fontSize: 11, fontWeight: 600, whiteSpace: "nowrap", }} width={150} interval={0} minTickGap={0} />
                                <RechartsTooltip
                                  content={({ active, payload }) => {
                                    if (active && payload && payload.length) {
                                      const data = payload[0].payload;
                                      const avg = data.avg ?? data.averagescore ?? data.score;
                                      const tooltipColor = getGradeColor(data.grade) || getColor(avg);
                                      return (
                                        <div style={{ background: "#fff", border: "1px solid #ccc", borderRadius: "6px", padding: "8px", fontSize: "10px", }} >
                                          <div style={{ display: "flex", alignItems: "center", marginBottom: "4px", }} >
                                            <div style={{ width: "12px", height: "12px", backgroundColor: tooltipColor, marginRight: "6px", borderRadius: "2px", }} ></div> {data?.acname} </div>
                                          <div>Score: {avg}%</div> <div>Grade: {data?.grade}</div>
                                          <div>Indicators:{data?.indicators}</div>
                                        </div>);
                                    } return null;
                                  }} />
                                <Bar dataKey="avg" barSize={13} isAnimationActive={true} animationDuration={3000}
                                  animationEasing="ease-in-out" label={{ position: "right", formatter: (value) => `${value}%`, fill: "#000", fontSize: 9, }} >
                                  {(sortedConstScores || []).map((values, index) => (
                                    <Cell key={`cell-${index}`} fill={getGradeColor(values.grade) || getColor(values.avg)} />
                                  ))} </Bar> </BarChart> </ResponsiveContainer> </Col>
                          <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}> <Row> <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1">
                            <div className="input-group">
                              <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                              <input type="text" className="form-control" placeholder="Search" value={distsearch} onChange={(e) => { setdistsearch(e.target.value) }} />
                            </div> </Col>
                            <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="mb-1 float-end" >
                              <Button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatedashPdf("my-table2", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                }KPI-Constituency Wise Scores & Grades Dashboard`, 7, "my-chart", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                }KPI-Constituency Wise Scores & Grades Dashboard`)} style={{ float: "right", marginLeft: "3px" }} >  <GrDocumentPdf /> </Button>
                            
                              <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportTodashExcel("my-table2", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                }KPI-Constituency Wise Scores & Grades Dashboard`)}>
                                <span style={{ color: "white" }}>
                                  <RiFileExcel2Line style={{ fontSize: "18px" }} /> </span> </Button>
                                  <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => handleDownloadAllConstuExcel()}>
                                <span style={{ color: "white" }}>ALL Constituencies <RiFileExcel2Line style={{ fontSize: "16px", marginLeft: "6px" }} /> </span>
                              </Button>  
                                  
                                   </Col> </Row>
                            <div className="department-table" >
                              <div style={{ width: " 100%", overflow: "auto", maxHeight: "600px", overflowY: "scroll" }}>
                                <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table2">
                                  <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                                    <tr className="text-center only-export"> <th colSpan={6} className="text-center"> <span >Constituency Wise Scores & Grades</span> </th> </tr> <tr>
                                      <th style={{ backgroundColor: "#4e835c", }}>S.No</th>
                                      <th style={{ backgroundColor: "#4e835c" }}> District Name{" "} <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => { handleSort("district_name") }} > {sortConfig.key === "district_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                      <th style={{ backgroundColor: "#4e835c" }}> Constituency Name{" "} <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                        onClick={() => { handleSort("assembly_name") }} >
                                        {sortConfig.key === "assembly_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                      <th style={{ backgroundColor: "#4e835c" }}>
                                        No of Indicators{" "} <button style={{ border: "none", background: "transparent", cursor: "pointer" }} onClick={() => handleSort("noofindicators")} >
                                          {sortConfig.key === "noofindicators"
                                            ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                      <th style={{ backgroundColor: "#4e835c" }}>
                                        Score{" "}
                                        <button
                                          style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                          onClick={() => handleSort("achievedscore")}
                                        >
                                          {sortConfig.key === "achievedscore" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>

                                      <th style={{ backgroundColor: "#4e835c" }}>
                                        Grade{" "}
                                        <button
                                          style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                          onClick={() => handleSort("achievedgrade")}
                                        >
                                          {sortConfig.key === "achievedgrade"
                                            ? sortConfig.direction === "asc"
                                              ? "▲"
                                              : "▼"
                                            : "↕"}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {sortedConstScores?.length === 0 ? (
                                      <tr>
                                        <td className="text-center" colSpan="5">
                                          <b style={{ color: "red" }}>Details Not Found</b>
                                        </td>
                                      </tr>
                                    ) : (sortedConstScores.map((detail, i) => (
                                      <tr key={i} style={{ textAlign: "left" }}> <td style={{ textAlign: "center" }}>{i + 1}</td>
                                        <td style={{ textAlign: "left" }}>{detail?.district_name}</td>   <td onClick={() => {
                                          MandalData(
                                            clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                            clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                            (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                            detail.district_id, detail
                                          );
                                        }} >
                                          <Link>{detail?.acname}</Link> </td>
                                        <td style={{ textAlign: "right" }} onClick={() => {
                                          DisttabNoofIndicators("District", "District",
                                            clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                            (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                            detail.district_id, role_cat_id === "112" ? detail.mandal_id : "0", detail?.indicatorid, detail?.sec_id, detail);
                                        }}
                                        > <Link>{detail?.noofindicators}</Link> </td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                          {renderStatusRing(detail?.averagescore, 100, 40, 6)}
                                        </td> <td style={{ textAlign: "center" }}>{detail?.grade}</td> </tr>)))} </tbody>
                                </table> </div> </div></Col>
                        </> : <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          <Alert variant="danger"> Const Level Indicators are Not Available </Alert></Col>}
                      </Row> </>}
                      {Mandalenb && <> <div className='performancesa-title' style={{ textAlign: "left" }}>
                        <h2> Mandal Wise <span className="title-highlight"> Scores & Grades </span></h2>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "10px", marginBottom: "15px", }} >
                          <GradeFilter gradeFilter={gradeFilter} onChange={handleGradeChange} /> </div> </div>
                        {(!["111", "117"].includes(role_cat_id) && selectedmap !== "mandalmap") &&
                          <div className="d-flex align-items-center gap-2">
                            <label className="fw-bold mb-0 ms-2" style={{ marginTop: "15px" }}>
                              DISTRICT <span style={{ color: "red" }}>*</span>
                            </label>
                            <Field
                              as="select"
                              name="district_id"
                              className="form-control"
                              style={{ fontWeight: "bold", width: "250px", marginTop: "20px" }}
                              value={["119", "113", "112"].includes(role_cat_id) ? districtid : selectedmap === "districtmap" ? selectedDistrictId : formik.values.district_id}
                              // disabled={["119", "113"].includes(role_cat_id) ? true : false}
                              disabled={(selectedDistrict !== null) || (role_cat_id === "112") ? true : false}
                              onChange={(e) => {
                                const selectedDist = e.target.value;
                                formik.setFieldValue("district_id", selectedDist);
                                if (selectedDist) {
                                  mandaltabdata(clickType === "hod" ? "0" : selectedsec, clickType === "" ? selecteddept : "0", selectedDist);
                                } formik.handleChange(e);

                              }}
                            >
                              <option value="0">All</option>
                              {distlist?.map((dist) => (<option key={dist.id} value={dist.id}> {dist.value} </option>))}

                            </Field>
                          </div>}

                        <Row className="d-flex justify-content-start mt-3">
                          {mandalTabScores && Object.keys(mandalTabScores).length > 0 ? (<>
                            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="mt-4">
                              <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: "6px", padding: "8px", maxHeight: "600px", overflowY: "auto", }} >
                                <ResponsiveContainer width="100%" height={Math.max(MandalTabScoresSorted.length * 40, 200)} id="mandal-chart" key={chartKey} >
                                  <BarChart layout="vertical"
                                    margin={{ top: 20, right: 50, left: 70, bottom: 0 }}
                                    data={MandalTabScoresSorted.map((item) => ({
                                      mandal_name: (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? item.ulb_name : item.mandal_name,
                                      avg: item.averagescore, grade: item.grade, indicators: item.noofindicators,
                                      color: item.color_code || "#ccc",
                                    }))} >
                                    <CartesianGrid horizontal={false} vertical={false} />
                                    <XAxis type="number" stroke="black" domain={[0, 100]} tickFormatter={(value) => `${value}%`} tick={{ fontSize: 10, fontWeight: 600 }} />
                                    <YAxis type="category" dataKey="mandal_name" stroke="black" width={150} interval={0} minTickGap={0} tick={{ fontSize: 12, fontWeight: 600, fill: "#000", }} />
                                    <RechartsTooltip content={({ active, payload }) => {
                                      if (active && payload && payload.length) {
                                        const data = payload[0].payload;
                                        const avg = data.avg ?? data.averagescore ?? data.score;
                                        const tooltipColor = getGradeColor(data.grade) || getColor(avg); return (
                                          <div style={{ background: "#fff", border: "1px solid #ccc", borderRadius: "6px", padding: "8px", fontSize: "11px", }} >
                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px", }} >
                                              <div style={{ width: "12px", height: "12px", backgroundColor: tooltipColor, marginRight: "6px", borderRadius: "2px", }} ></div>
                                              {data?.mandal_name}
                                            </div> <div>Score: {avg}%</div> <div>Grade: {data?.grade}</div> <div>Indicators: {data?.indicators}</div>
                                          </div>);
                                      } return null;
                                    }} />
                                    <Bar dataKey="avg" barSize={14} isAnimationActive={true}
                                      animationDuration={3000}
                                      animationEasing="ease-in-out"
                                      label={{
                                        position: "right",
                                        formatter: (value) => `${value}%`,
                                        fill: "#000",
                                        fontSize: 9,
                                      }}>
                                      {MandalTabScoresSorted.map((item, index) => (
                                        <Cell key={index} fill={getGradeColor(item.grade) || getColor(item.averagescore)} />
                                      ))}

                                      {/* ✅ Display average score at the end of bar */}
                                      {/* <LabelList
          dataKey="avg"
          position="right"
          formatter={(val) => `${val}%`}
          style={{ fontSize: 12, fontWeight: 600, fill: "#333" }}
        /> */}
                                    </Bar>
                                  </BarChart>
                                </ResponsiveContainer>
                              </div>

                            </Col>



                            {/* Right Side Table */}
                            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                              <Row>
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={3}
                                  lg={3}
                                  xl={3}
                                  xxl={3}
                                  className="mb-1"
                                >
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <div
                                        className="input-group-text group_txt11"
                                        id="btnGroupAddon"
                                      >
                                        <AiOutlineSearch />
                                      </div>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search"
                                      value={mandaltabsearch}
                                      onChange={(e) => setmandaltabsearch(e.target.value)}
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={9}
                                  lg={9}
                                  xl={9}
                                  xxl={9}
                                  className="mb-1 float-end"
                                >
                                  <Button
                                    className="btn btn-danger btn-sm mx-2 pdf-btn"
                                    onClick={() =>
                                      formik.values.district_id === "0" ? generateindPdf("my-mandaltab4", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                        }KPI-Mandal Wise Scores & Grades Dashboard`, 6, "mandal-chart",
                                        `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                        }KPI-Mandal Wise Scores & Grades Dashboard`) :
                                        generatedashPdf("my-mandaltab4", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                          }KPI-Mandal Wise Scores & Grades Dashboard`, 6, "mandal-chart", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                          }KPI-Mandal Wise Scores & Grades Dashboard`)
                                    }
                                    style={{ float: "right", marginLeft: "3px" }}
                                  >
                                    <GrDocumentPdf />
                                  </Button>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    className="btn mx-2 excel-btn"
                                    style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                                    onClick={() => exportTodashExcel("my-mandaltab4", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                                      }KPI-Mandal Wise Scores & Grades Dashboard`)} >
                                    <span style={{ color: "white" }}> <RiFileExcel2Line style={{ fontSize: "18px" }} /> </span> </Button>
                                </Col>
                              </Row>

                              <div className="department-table">
                                <div
                                  style={{
                                    width: "100%",
                                    overflow: "auto",
                                    maxHeight: "600px",
                                    overflowY: "scroll"
                                  }}
                                >
                                  <table
                                    className="table table-bordered custom-table table-responsive sticky-table"
                                    id="my-mandaltab4"
                                  >
                                    <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                                      <tr className="text-center only-export">
                                        <th colSpan={6} className="text-center">
                                          <span>{(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"}{" "} Wise Scores & Grades</span>
                                        </th>
                                      </tr>
                                      <tr>
                                        <th style={{ backgroundColor: "#4e835c" }}>S.No</th>
                                        <th style={{ backgroundColor: "#4e835c" }}>
                                          District Name{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("district_name")} >
                                            {sortConfig.key === "district_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                        {role_cat_id === "112" && <th style={{ backgroundColor: "#4e835c" }}>
                                          Constituency Name{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("assembly_name")} >
                                            {sortConfig.key === "assembly_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>}
                                        <th style={{ backgroundColor: "#4e835c" }}>
                                          {(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"} Name{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("mandal_name")} >
                                            {sortConfig.key === "mandal_name" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                        <th style={{ backgroundColor: "#4e835c" }}> Type{" "}
                                          {/* <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("type")} >
                                            {sortConfig.key === "type" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> */}
                                        </th>
                                        <th style={{ backgroundColor: "#4e835c" }}> No of Indicators{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("noofindicators")} >
                                            {sortConfig.key === "noofindicators" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                        <th style={{ backgroundColor: "#4e835c" }}> Score{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("achievedscore")} >
                                            {sortConfig.key === "achievedscore" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                        <th style={{ backgroundColor: "#4e835c" }}> Grade{" "}
                                          <button style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            onClick={() => handleSort("achievedgrade")} >
                                            {sortConfig.key === "achievedgrade" ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button>
                                        </th> </tr> </thead> <tbody>
                                      {MandalTabScoresSorted?.length === 0 ? (
                                        <tr>
                                          <td className="text-center" colSpan="5">
                                            <b style={{ color: "red" }}>Details Not Found</b>
                                          </td>
                                        </tr>
                                      ) : (
                                        MandalTabScoresSorted.map((detail, i) => (
                                          <tr key={i} style={{ textAlign: "left" }}>
                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                            <td>{detail?.district_name}</td>
                                            {role_cat_id === "112" && <td>{detail?.acname}</td>}
                                            <td>{role_cat_id === "112" ? detail?.mandal_name : ((ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? detail?.ulb_name : detail?.mandal_name)}</td>
                                            <td style={{ textAlign: "left" }}>{detail?.type}</td>
                                            <td
                                              style={{ textAlign: "right" }}
                                              onClick={() => {

                                                const isULB = detail?.ulb_id && detail?.ulb_id.length === 6;

                                                const drillType = isULB ? "ULB" : "Mandal";

                                                const id = isULB ? detail?.ulb_id : detail?.mandal_id;

                                                DisttabNoofIndicators(drillType, drillType,
                                                  (clickType === "district" || clickType === "") ? selectedsec : "0",
                                                  (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                                  detail?.district_id,
                                                  id,              // mandal or ulb goes here
                                                  "0", detail?.sec_id, detail);

                                              }}
                                            >
                                              <Link>{detail?.noofindicators}</Link>
                                            </td>


                                            <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                              }}
                                            >
                                              {renderStatusRing(
                                                detail.averagescore,
                                                100,
                                                40,
                                                6
                                              )}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              {detail.grade}
                                            </td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </Col>


                          </>
                          ) : (<>
                            {Mandalalert &&
                              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                <Alert variant="danger">
                                  Mandal Level Indicators are Not Available
                                </Alert>
                              </Col>
                            }
                          </>)}

                        </Row>

                      </>}
                    </div>
                  </Tab.Container>

                </div>
              </div>

            </div>
          </Form>

        </FormikProvider>

        <Modal
          show={show}
          onHide={() => { setmandalsearch(""); setShow(false); setinddistenb(false); setdistindenb(false); }}
          dialogClassName="modal-xl" // custom large modal
          centered
          scrollable
          className="mandalmodel"
        >
          <Modal.Header className="justify-content-center" closeButton>
            <Modal.Title className="text-center">
              <div
                className="performancesa-title"
                style={{ textAlign: "center" }}
              >
                <h2>
                  {modalDistrictName}{modalDistrictName && modalSubName ? " - " : ""}{modalSubName}
                  {" "}
                  <span className="title-highlight">
                    {activeTab === "Const" ? "Constituency " : "Mandal "}Wise Scores & Grades
                  </span>
                </h2>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="d-flex justify-content-start mt-2">
              {mandalScores && Object.keys(mandalScores).length > 0 ? (
                <>

                  {/* Left Side Chart */}
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="mt-4"
                  >
                    <ResponsiveContainer
                      width="100%"
                      id="my-chartman"
                      key={chartKey}
                      className="border p-1 rounded shadow-sm"
                      style={{
                        background: "#fff",
                        overflow: "auto",
                        overflowY: "scroll"
                      }}
                      maxHeight={600}
                    >
                      <BarChart
                        layout="vertical"
                        margin={{ top: 20, right: 50, left: 70, bottom: 0 }}
                        barCategoryGap="60%"
                        data={sortedModalMandalScores.map((item) => ({
                          district: item.name,
                          avg: item.avg,
                          grade: item.grade,
                          indicators: item.indicators,
                          color: item.color,
                        }))}
                      >
                        <CartesianGrid horizontal={false} vertical={false} />

                        <XAxis
                          type="number"
                          stroke="black"
                          tick={{ fontSize: 10, fontWeight: 600 }}
                          domain={[0, 100]}
                        />

                        <YAxis
                          type="category"
                          dataKey="district"
                          stroke="black"
                          tick={{
                            fontSize: 11,
                            fontWeight: 600,
                            whiteSpace: "nowrap"
                          }}
                          width={150}
                          interval={0}
                          minTickGap={0}
                        />

                        <RechartsTooltip
                          content={({ active, payload }) => {
                            if (active && payload && payload.length) {
                              const data = payload[0].payload;
                              return (
                                <div
                                  style={{
                                    background: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    padding: "8px",
                                    fontSize: "10px"
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "4px"
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: (getGradeColor(data.grade) || getColor(data.avg ?? data.averagescore ?? data.score)),
                                        marginRight: "6px",
                                        borderRadius: "2px"
                                      }}
                                    ></div>
                                    {data?.district}
                                  </div>
                                  <div>Score: {data?.avg}%</div>
                                  <div>Grade: {data?.grade}</div>
                                  <div>Indicators: {data?.indicators}</div>
                                </div>
                              );
                            }
                            return null;
                          }}
                        />

                        <Bar
                          dataKey="avg"
                          barSize={13}
                          isAnimationActive={true}
                          animationDuration={3000}
                          animationEasing="ease-in-out"
                          label={{
                            position: "right",
                            formatter: (value) => `${value}%`,
                            fill: "#000",
                            fontSize: 9
                          }}
                        >
                          {sortedModalMandalScores.map((values, index) => (
                            <Cell key={`cell-${index}`} fill={getGradeColor(values.grade) || getColor(values.avg)} />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </Col>

                  {/* Right Side Table */}
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={3}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className="mb-1"
                      >
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div
                              className="input-group-text group_txt11"
                              id="btnGroupAddon"
                            >
                              <AiOutlineSearch />
                            </div>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={mandalsearch}
                            onChange={(e) => setmandalsearch(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={9}
                        lg={9}
                        xl={9}
                        xxl={9}
                        className="mb-1 float-end"
                      >
                        <Button
                          className="btn btn-danger btn-sm mx-2 pdf-btn"
                          onClick={() =>
                            generatedashPdf(
                              "my-table4", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""
                              }KPI Dashboard`, 5, "my-chartman",
                              `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""}KPI Dashboard`
                            )
                          }
                          style={{ float: "right", marginLeft: "3px" }}
                        >
                          <GrDocumentPdf />
                        </Button>
                        <Button
                          variant="success"
                          size="sm"
                          className="btn mx-2 excel-btn"
                          style={{
                            float: "right",
                            color: "#ffffff",
                            marginLeft: "3px"
                          }}
                          onClick={() => exportTodashExcel("my-table4", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""}KPI Dashboard`)}
                        >
                          <span style={{ color: "white" }}>

                            <RiFileExcel2Line style={{ fontSize: "18px" }} />
                          </span>
                        </Button>
                      </Col>
                    </Row>

                    <div className="department-table">
                      <div
                        style={{
                          width: "100%",
                          overflow: "auto",
                          maxHeight: "600px",
                          overflowY: "scroll"
                        }}
                      >
                        <table
                          className="table table-bordered custom-table table-responsive sticky-table"
                          id="my-table4"
                        >
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                            <tr className="text-center only-export">
                              <th colSpan={5} className="text-center">
                                <span>{(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"}{" "} Wise Scores & Grades</span>
                              </th>
                            </tr>
                            <tr>
                              <th style={{ backgroundColor: "#4e835c" }}>S.No</th>
                              {(role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const")) && <th style={{ backgroundColor: "#4e835c" }}>Constituency Name</th>}
                              <th style={{ backgroundColor: "#4e835c" }}>
                                {(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"} Name{" "}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => handleSort("mandal_name")}
                                >
                                  {sortConfig.key === "mandal_name"
                                    ? sortConfig.direction === "asc"
                                      ? "▲"
                                      : "▼"
                                    : "↕"}
                                </button>
                              </th>
                              <th style={{ backgroundColor: "#4e835c" }}>
                                No of Indicators{" "}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => handleSort("noofindicators")}
                                >
                                  {sortConfig.key === "noofindicators"
                                    ? sortConfig.direction === "asc"
                                      ? "▲"
                                      : "▼"
                                    : "↕"}
                                </button>
                              </th>
                              <th style={{ backgroundColor: "#4e835c" }}>
                                Score{" "}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => handleSort("achievedscore")}
                                >
                                  {sortConfig.key === "achievedscore"
                                    ? sortConfig.direction === "asc"
                                      ? "▲"
                                      : "▼"
                                    : "↕"}
                                </button>
                              </th>
                              <th style={{ backgroundColor: "#4e835c" }}>
                                Grade{" "}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => handleSort("achievedgrade")}
                                >
                                  {sortConfig.key === "achievedgrade"
                                    ? sortConfig.direction === "asc"
                                      ? "▲"
                                      : "▼"
                                    : "↕"}
                                </button>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedMandalScores?.length === 0 ? (
                              <tr>
                                <td className="text-center" colSpan="5">
                                  <b style={{ color: "red" }}>Details Not Found</b>
                                </td>
                              </tr>
                            ) : (
                              sortedMandalScores.map((detail, i) => (
                                <tr key={i} style={{ textAlign: "left" }}>
                                  <td style={{ textAlign: "center" }}>{i + 1}</td>
                                  {(role_cat_id === "112" || (role_cat_id === "116" && activeTab === "Const")) && <td style={{ textAlign: "left" }}>{detail?.acname}</td>}
                                  <td>{(role_cat_id === "112" || (role_cat_id === "116" && (activeTab === "Const" || (activeTab === "District" && !(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01"))))) ? detail?.mandal_name : ((ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? detail?.ulb_name : detail?.mandal_name)}</td>

                                  {/* <td>{detail?.noofindicators}</td> */}
                                  <td style={{ textAlign: "right" }}
                                    onClick={() => {
                                      setdistindenb(true);

                                      const mandalIdValue = detail?.mandal_id;
                                      const isULB = mandalIdValue?.length === 6;

                                      const drillType = isULB ? "ULB" : "Mandal";

                                      DisttabNoofIndicators(
                                        drillType,              // type
                                        drillType,              // typedrill
                                        (clickType === "district" || clickType === "")
                                          ? selectedsec
                                          : "0",
                                        (clickType === "sec" || clickType === "hod" || clickType === "district")
                                          ? "0"
                                          : selecteddept,
                                        detail.district_id,
                                        (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? detail?.ulb_id : mandalIdValue,          // ✅ ALWAYS pass real id
                                        "0",
                                        detail?.sec_id,
                                        detail
                                      );
                                    }}>
                                    <Link>{detail?.noofindicators}</Link> </td>
                                  <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }} >
                                    {renderStatusRing(detail?.averagescore, 100, 40, 6)} </td>
                                  <td style={{ textAlign: "center" }}>
                                    {detail?.grade}
                                  </td> </tr>)))} </tbody> </table> </div> </div> </Col> </>) : (
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Alert variant="danger">
                    Mandal Level Indicators are Not Available
                  </Alert>
                </Col>
              )}
            </Row>
          </Modal.Body>

          <Modal.Footer style={{ marginBottom: "20px" }}>
            <Button variant="danger" style={{ padding: "8px 20px", borderRadius: "30px" }} onClick={() => { setmandalsearch(""); setdistindenb(false); setShow(false); setIndicatorenb(false); }} className="mb-3">
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Indicator stats tab lo No.of KPI Onclick Modal */}
        <Modal
          show={Indicatormodal}
          onHide={() => { setIndicatormandalsearch(""); setdistindenb(false); setIndicatormodal(false); setinddistenb(false); setdashboardDistrictWiseIndicatorDataScoreslist([]); }}
          dialogClassName="modal-xl" // custom large modal
          centered
          scrollable
          className="mandalmodel"
        >
          <Modal.Header className="justify-content-center" closeButton>
            <Modal.Title className="text-center">
              <div
                className="performancesa-title"
                style={{ textAlign: "center" }}
              >
                <h2>
                  {(indicatorModalDistrictName || indicatorModalSubName) && (
                    `${indicatorModalDistrictName}${indicatorModalDistrictName && indicatorModalSubName ? ' - ' : ''}${indicatorModalSubName} `
                  )}
                  <span className="title-highlight">
                    Indicator Wise Scores & Grades
                  </span>
                </h2>

              </div></Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="">
              {dashboardDistrictWiseIndicatorDataScoreslist && Object.keys(dashboardDistrictWiseIndicatorDataScoreslist).length > 0 ? (
                <>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="mb-1"
                    >
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div
                            className="input-group-text group_txt11"
                            id="btnGroupAddon"
                          >
                            <AiOutlineSearch />
                          </div>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          value={Indicatormandalsearch}
                          onChange={(e) => setIndicatormandalsearch(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      sm={12}
                      md={9}
                      lg={9}
                      xl={9}
                      xxl={9}
                      className="mb-1"
                    >
                      <div className="d-flex justify-content-end gap-2">
                        {/* Back button when inddistenb true */}
                        {inddistenb && (
                          <Button variant="warning" size="sm" className="btn btn-warning" onClick={() => BackFunct()} >
                            <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </Button>)}

                        {(activeTab === "District" || activeTab === "Const" && distindenb) && (
                          <button type="button" size="sm" className="btn btn-warning"
                            onClick={() => {
                              setIndicatormodal(false);
                              MandalData(clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                dashboardDistrictWiseIndicatorDataScoreslist[0]?.district_id, dashboardDistrictWiseIndicatorDataScoreslist[0]);
                            }} >
                            <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>)}
                        {/* PDF button */}
                        <Button
                          className="btn btn-danger btn-sm pdf-btn"
                          onClick={() =>
                            // generateindPdf("my-tableIndicatorMandal", "Dashboard", getColSpan())
                            // generatedashPdf("my-tableIndicatorMandal", "KPI-Scores & Grades Dashboard", 14, "mandal-chart", "KPI-Scores & Grades Dashboard")
                            generateindPdf("my-tableIndicatorMandal", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""}KPI-Scores & Grades Dashboard`, getColSpan())
                          }
                        >
                          <GrDocumentPdf />
                        </Button>

                        {/* Excel button */}
                        <Button
                          variant="success"
                          size="sm"
                          className="excel-btn"
                          onClick={() => exportTodashExcel("my-tableIndicatorMandal", `${selectedDistrict ? `${selectedDistrict}_District_` : ""}${selectedMandal ? `${selectedMandal}_Mandal_` : ""}KPI-Scores & Grades Dashboard`)}
                        >
                          <span style={{ color: "white" }}>
                            <RiFileExcel2Line style={{ fontSize: "18px" }} />
                          </span>
                        </Button>
                      </div>
                    </Col>





                  </Row>
                  <div style={{ width: " 100%", overflow: "auto", maxHeight: "450px", overflowY: "scroll" }}>

                    <table
                      className="table table-bordered custom-table sticky-table"
                      id="my-tableIndicatorMandal"
                      style={{ width: "100%" }}
                    >
                      <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                        <tr className="text-center only-export">
                          <th colSpan={getColSpan()} className="text-center">
                            <span>Indicator wise data</span>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ backgroundColor: "#4e835c" }}>S.No</th>
                          <th style={{ backgroundColor: "#4e835c", }}>Secretariat Department</th>
                          <th style={{ backgroundColor: "#4e835c", }}>HOD Name</th>
                          {(activeTab === "Indicator") && (
                            <th style={{ backgroundColor: "#4e835c" }}>District Name</th>
                          )}
                          {((activeTab === "Indicator" && inddistenb)) && (<>


                            <th style={{ backgroundColor: "#4e835c" }}>
                              {
                                (
                                  ulbdeptlist.includes(ulbdept) ||
                                  selectedsec === "MAU01" ||
                                  (role_cat_id === "116" && sortedIndicatorsMandalScores && sortedIndicatorsMandalScores[0]?.mandal_name === null)
                                )
                                  ? "ULB"
                                  : "Mandal"
                              } Name
                            </th></>)}

                          {((activeTab === "Indicator" && role_cat_id === "112")) && (
                            <th style={{ backgroundColor: "#4e835c" }}>{(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal"} Name</th>
                          )}
                          <th style={{ backgroundColor: "#4e835c", }}>KPI</th>
                          {role_cat_id === "112" && <th style={{ backgroundColor: "#4e835c", }}>Constituency Name</th>}
                          <th style={{ backgroundColor: "#4e835c", }}>Unit</th>
                          <th style={{ backgroundColor: "#4e835c", }}>Periodicity</th>
                          <th style={{ backgroundColor: "#4e835c", }}>Entry Level</th>
                          <th style={{ backgroundColor: "#4e835c", }}>Time fraction</th>
                          <th style={{ backgroundColor: "#4e835c", }}>Indicator nature</th>
                          <th style={{ backgroundColor: "#4e835c" }}>
                            Target 
                            <button
                              style={{ border: "none", background: "transparent", cursor: "pointer" }}
                              onClick={() =>
                                handleSort(activeTab === "Dept" ? "target" : "target_value")
                              }
                            >
                              {sortConfig.key === (activeTab === "Dept" ? "target" : "target_value")
                                ? sortConfig.direction === "asc"
                                  ? "▲"
                                  : "▼"
                                : "↕"}
                            </button>
                          </th>
                          <th style={{ backgroundColor: "#4e835c" }}>
                            Achievement
                            <button
                              style={{ border: "none", background: "transparent", cursor: "pointer" }}
                              onClick={() =>
                                handleSort(activeTab === "Dept" ? "achivementvalue" : "achieved_value")
                              }
                            >
                              {sortConfig.key === (activeTab === "Dept" ? "achivementvalue" : "achieved_value")
                                ? sortConfig.direction === "asc"
                                  ? "▲"
                                  : "▼"
                                : "↕"}
                            </button>
                          </th>
                          <th style={{ backgroundColor: "#4e835c" }}>
                            Score{" "}
                            <button
                              style={{ border: "none", background: "transparent", cursor: "pointer" }}
                              onClick={() => handleSort("achievedscore")}
                            >
                              {sortConfig.key === "achievedscore"
                                ? sortConfig.direction === "asc"
                                  ? "▲"
                                  : "▼"
                                : "↕"}
                            </button>
                          </th>

                          <th style={{ backgroundColor: "#4e835c" }}>
                            Grade{" "}
                            <button
                              style={{ border: "none", background: "transparent", cursor: "pointer" }}
                              onClick={() => handleSort("grade")}
                            >
                              {(sortConfig.key === "grade")
                                ? sortConfig.direction === "asc"
                                  ? "▲"
                                  : "▼"
                                : "↕"}
                            </button>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedIndicatorsMandalScores?.length === 0 ? (
                          <tr>
                            <td className="text-center" colSpan={getColSpan()}>
                              <b style={{ color: "red" }}>Details Not Found</b>
                            </td>
                          </tr>
                        ) : (
                          sortedIndicatorsMandalScores.map((detail, i) => (
                            <tr key={i} >
                              <td style={{ textAlign: "center" }}>{i + 1}</td>

                              <td>{activeTab === "Dept" ? detail.secname : detail.sec_name}</td>
                              <td>{activeTab === "Dept" ? detail.deptname : detail.dept_name}</td>
                              {(activeTab === "Indicator" && role_cat_id !== "112") &&

                                ((detail.kpi_entry_level === "Mandal" && !inddistenb)
                                  ?
                                  <td >
                                    <Link onClick={() => {
                                      setinddistenb(true);
                                      setdistindenb(false);
                                      DisttabNoofIndicators(
                                        "Indicator",
                                        (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "ULB" : "Mandal",
                                        clickType === "hod"
                                          ? "0"
                                          : (clickType === "district" || clickType === "")
                                            ? selectedsec
                                            : "",
                                        (clickType === "sec" || clickType === "hod" || clickType === "district")
                                          ? "0"
                                          : selecteddept,
                                        detail.district_id,
                                        detail?.mandal_id,
                                        detail?.indicatorid, detail?.sec_id, detail
                                      );
                                    }}>{detail?.district_name}</Link>
                                  </td>
                                  :
                                  <td>{detail.district_name}</td>)
                              }
                              {(activeTab === "Indicator" && role_cat_id === "112") && <td>{constdist}</td>}

                              {(activeTab === "Indicator" && role_cat_id === "112") && <td>{(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01" || (role_cat_id === "116" && detail?.sec_name?.startsWith("MAU01"))) ? detail.ulb_name : detail.mandal_name}</td>}
                              {((activeTab === "Indicator" && inddistenb)) && (
                                <td>{(ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01" || (role_cat_id === "116" && detail?.sec_name?.startsWith("MAU01"))) ? detail.ulb_name : detail.mandal_name}</td>
                              )}
                              <td>{activeTab === "Dept" ? detail.indicatorname : detail.indicator_name}</td>
                              {role_cat_id === "112" && <td>{detail.acname}</td>}
                              <td>{activeTab === "Dept" ? detail.unitname : detail.unit_name}</td>
                              <td>{detail.periodic_name}</td>
                              {(!activeTab == "Dept") ? (<td>{detail.entry_level}</td>) : (<td>{detail.kpi_entry_level}</td>)}
                              <td style={{ textAlign: "right" }}>{detail.time_fraction}</td>
                              <td>{activeTab === "Dept" ? detail.indicatornature : detail.indicator_nature}</td>

                              {(activeTab === "Dept") ? (
                                <>
                                  <td style={{ textAlign: "right" }}>{detail.target?.toLocaleString("en-IN")} </td>
                                  <td style={{ textAlign: "right" }}>{detail.achivementvalue?.toLocaleString("en-IN")} </td>
                                </>
                              ) : (
                                <>
                                  <td style={{ textAlign: "right" }}>{detail.target_value?.toLocaleString("en-IN")}</td>
                                  <td style={{ textAlign: "right" }}>{detail.achieved_value?.toLocaleString("en-IN")}</td>
                                </>
                              )}

                              <td style={{ textAlign: "center" }}>{renderStatusRing(detail.achievedscore, 100, 40, 6)}</td>
                              <td style={{ textAlign: "center" }}>{(activeTab === "Dept") ? detail.achievedgrade : detail.grade}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                  </div>
                </>) : (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="mb-1" >
                      <div className="d-flex justify-content-end gap-2">
                        {inddistenb && (
                          <Button
                            variant="warning"
                            size="sm"
                            className="btn btn-warning"
                            onClick={() => BackFunct()}
                          >
                            <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back
                          </Button>
                        )}
                        {(activeTab === "District" || activeTab === "Const" && distindenb) && (
                          <button type="button" size="sm" className="btn btn-warning"
                            onClick={() => {
                              setIndicatormodal(false);
                              MandalData(clickType === "hod" ? "sec" : clickType === "district" ? "hod" : clickType === "" ? "district" : "",
                                clickType === "hod" ? "0" : (clickType === "district" || clickType === "") ? selectedsec : "",
                                (clickType === "sec" || clickType === "hod" || clickType === "district") ? "0" : selecteddept,
                                dashboardDistrictWiseIndicatorDataScoreslist[0]?.district_id, dashboardDistrictWiseIndicatorDataScoreslist[0]
                              );
                            }} >
                            <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>
                        )}</div></Col></Row>
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Alert variant="danger"> Indicators are Not Available </Alert></Col></>)}
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ marginBottom: "20px" }}>
            <Button variant="danger" style={{ padding: "8px 20px", borderRadius: "30px" }}
              onClick={() => { setdistindenb(false); setIndicatormandalsearch(""); setShow(false); setinddistenb(false); setIndicatormodal(false); setdashboardDistrictWiseIndicatorDataScoreslist([]); }} className="mb-3"> Close </Button>
          </Modal.Footer> </Modal>
                 <Alert
                                                              className="py-2 px-3 mb-2"
                                                              style={{
                                                                  fontSize: "12px",
                                                                  backgroundColor: "#fdecec",
                                                                  borderColor: "#f5b5b5",
                                                                  color: "#a00000",
                                                                  textAlign:"center"
                                                              }}
                                                          >
                                                              <strong>Disclaimer:</strong> This report was generated based on the data
                                                              available in the portal on <strong>  {reportGeneratedDate}
                           
                            .</strong>
                                                          </Alert>
           </Container >
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>);
};
export default Dashboardnewchanges;
